import {
  faChevronLeft,
  faChevronRight,
  faExclamationCircle,
  faMagic,
  faPlusSquare,
  faRedo,
  faTimes,
  faTimesCircle,
  faUserCircle,
  faInfoCircle,
  faExclamationTriangle,
  faLock,
  faLockOpen,
  faClock,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loading from 'Body/Statuses/Loading.js';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';

import {
  Alert,
  Button,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Popover,
  PopoverBody,
  PopoverHeader,
  UncontrolledTooltip,
} from 'reactstrap';
import Swal from 'sweetalert2';
import tinycolor from 'tinycolor2'; // docs: https://www.npmjs.com/package/tinycolor2
import { useAuth0 } from '../../../../auth0/reactAuth0Spa.js';
import { checkLoginForError, formatBearerToken, urlWithHttpProtocol } from '../../../../Common.functions';
import { DepartmentContext } from '../../../../DepartmentWrapper';
import { deleteData, fetchDataAgnostic, postDataAgnostic, putData } from '../../../../Services/dataApi';
import { getFlexEventDisplayName, sortFlexEventsForDisplay } from '../../../../Services/flexEvents';
import {
  addTimeToTimeSlots,
  clone,
  colors,
  isCandidateWillBeUnscheduled,
  isTimeRangeOverlap,
  getScheduleStartAndEndTime,
  generateScheduleColumn,
  clearScheduleOfCandidates,
  setupTrackers,
  calculateScheduleBlockHeight,
  generateSchedule2,
  getTextWidth,
  getTextHeight,
} from '../../../../Services/schedule';
import AddColumnPopover from './AddColumnPopover';
import CloneModal from './CloneModal/CloneModal.js';
import ConfirmModal from './ConfirmModal';
import FlexEventDetailModal from './FlexEventDetailModal/FlexEventDetailModal.js';
import HeaderDetailDropDown from './HeaderDetailDropdown';
import './Schedule.style.css';
import ScheduleDetailModal from './ScheduleDetailModal';
import ScheduleWizard from './ScheduleWizard/ScheduleWizard.js';
import style from './style.js';
import TimeSlotHeaderPopover from './TimeSlotHeaderPopover';
import TimeSlotPopover from './TimeSlotPopover';
import TopBar from './TopBar';
import { toast } from 'react-toastify';
import RezRateBanner from 'Body/RezRATE/Common/RezRateBanner/RezRateBanner.js';
import { popoverModifiers } from 'enums.js';

import RezRateTable from 'Body/RezRATE/Common/RezRateTable/RezRateTable.js';

// Initialize Day.js plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

let attendanceChecker = null;

let fileInputs = document.getElementsByClassName('swal2-file');

// Slot capsules keep the #d4d4d4 literal so tinycolor() can pick their text color;
// the rendered fill comes from tokens so the dark theme can restyle it (REZ-1299).
const SLOT_GRAY = '#d4d4d4';
const themedSlot = (backgroundColor, color, border) => {
  if (backgroundColor !== SLOT_GRAY) return {};
  return {
    backgroundColor: 'var(--rr-surface-slot)',
    border: border ? border.replace(SLOT_GRAY, 'var(--rr-surface-slot)') : border,
    color: color === 'black' ? 'var(--rr-ink)' : color === SLOT_GRAY ? 'var(--rr-surface-slot)' : color,
  };
};

const Schedule = ({
  history,
  showTopBar,
  isEmbedded,
  isSuperUserPanel,
  pk_InterviewDate,
  forcedContext,
  embeddedRef,
  setParentScheduleData,
  setParentColumnTracker,
  setParentRowTracker,
  setParentCandidates,
  allowScheduleInteraction = false,
}) => {
  const [evaluators, setEvaluators] = useState({});
  const [candidates, setCandidates] = useState({}); // get from API, contains bgcolor
  const [candidatesArray, setCandidatesArray] = useState([]); // used for child components. turning object into array messes up useEffects in children watching that prop.
  const [scheduleData, setScheduleData] = useState(null);
  const scheduleLastUpdate = useRef();

  const [scheduleID, setScheduleID] = useState(null);

  const [generatedScheduleData, setGeneratedScheduleData] = useState(null);
  const [candidateLimit, setCandidateLimit] = useState(1);

  const [selectedCell, setSelectedCell] = useState(null);
  const [selectedScheduleBlock, setSelectedScheduleBlock] = useState(null); // Can't get it off of normal click events on table
  const [splitData, setSplitData] = useState(null); // data to be submitted before splitting. Used when Split confirm modal is triggered.

  const [showScheduleDetailModal, setShowScheduleDetailModal] = useState(false);
  const [showUnsavedChangeModal, setShowUnsavedChangeModal] = useState(false);
  const [showGenerateDataPanel, setShowGenerateDataPanel] = useState(false);
  const [showSplitCellModal, setShowSplitCellModal] = useState(false);
  const [showSplitCellConfirmModal, setShowSplitCellConfirmModal] = useState(false);
  const [showHeaderPopOver, setShowHeaderPopOver] = useState({});
  const [activeTimeSlotPopover, setActiveTimeSlotPopover] = useState({ pk_Timeslot: null, childKey: null });
  const [showAddColumnPopover, setShowAddColumnPopover] = useState(false);
  const [showFlexEventDetailModal, setShowFlexEventDetailModal] = useState(false);
  const [showCloneModal, setShowCloneModal] = useState(false);
  const [manageTimeHasChanges, setManageTimeHasChanges] = useState(false);
  const manageTimeUnsavedPromptOpenRef = useRef(false);

  // ====================Clone Schedule ========================//
  const [willCopyHeaders, setWillCopyHeaders] = useState(true);
  const [willCopyStartTime, setWillCopyStartTime] = useState(true);
  const [willCopyInterviewDuration, setWillCopyInterviewDuration] = useState(true);
  const [willCopyPassingDuration, setWillCopyPassingDuration] = useState(true);
  const [willCopyCandidateAssignments, setWillCopyCandidateAssignments] = useState(true);

  const [willCopyTimeSlots, setWillCopyTimeSlots] = useState(true);
  const [willCopyCustomEvents, setWillCopyCustomEvents] = useState(true);
  const [willCopyCustomDurations, setWillCopyCustomDurations] = useState(true);

  const [willCopyFlexEvents, setWillCopyFlexEvents] = useState(true);
  const [willCopyFlexEventEvaluators, setWillCopyFlexEventEvaluators] = useState(true);
  const [willCopyEvaluators, setWillCopyEvaluators] = useState(true);
  const [willCopyFocuses, setWillCopyFocuses] = useState(true);
  const [interviewDateToClone, setInterviewDateToClone] = useState();
  // ============================================================== //

  const [isAddingColumn, setIsAddingColumn] = useState(false);
  const [isGeneratingSchedule, setIsGeneratingSchedule] = useState(false);
  const [isAddingCandidate, setIsAddingCandidate] = useState(false);
  const [isTableLoaded, setIsTableLoaded] = useState(false);
  const [isScheduleDataError, setIsScheduleDataError] = useState(false);

  // ====== For Load indicators on topbar ============== //
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isCloning, setIsCloning] = useState(false);
  // ==================================================== //

  const [saveHooks, setSaveHooks] = useState({});

  // ==================== Trackers ==============================//
  const [rowTracker, setRowTracker] = useState({}); // pk_Timeslot keys with array of candidates in them.
  const [columnTracker, setColumnTracker] = useState({}); // pk_ScheduleAssignment keys with array of candidates in them
  const [indexedFlexEvents, setIndexedFlexEvents] = useState({}); // pk_FlexEvent keys with flex event value
  const [indexedFlexEventEvaluators, setIndexedFlexEventEvaluators] = useState({}); // pk_FlexEvent keys with array of pk_User
  const [indexedEvaluatorFlexEvents, setIndexedEvaluatorFlexEvents] = useState({}); // pk_User with array of pk_FlexEvent
  const [splitCountTracker, setSplitCountTracker] = useState({});
  const [splitBlockCandidateTracker, setSplitBlockCandidateTracker] = useState({}); // pk_Candidate keys and array of pk_ScheduleBlock, SortOrder
  const [scheduleBlockTracker, setScheduleBlockTracker] = useState({}); // pk_ScheduleBlock keys their row values
  const [columnAvailabilityTracker, setColumnAvailabilityTracker] = useState({}); // pk_ScheduleAssignment keys with array of candidates in them
  // ============================================================ //

  const [interviewDates, setInterviewDates] = useState([]);
  const [pendingCandidates, setPendingCandidates] = useState({}); // keys are "<pk_Timeslot>_<pk_ScheduleAssignment>". // For indicating which cells are being modified.
  const [columnsToIgnore, setColumnsToIgnore] = useState([]); // For indicating which columns to ignore in generating schedule

  const pendingCandidatesStateRef = useRef(); // Use this in accessing pendingCandidates inside callbacks/async
  const scheduleDataRef = useRef();
  const selectedCellRef = useRef();
  const selectedScheduleBlockRef = useRef();

  const [allowInterviewLimit, setAllowInterviewLimit] = useState(true);
  const [cellSplitCount, setCellSplitCount] = useState(1);

  const [headerHoveredOn, setHeaderHoveredOn] = useState(null);
  const [firstTimeGenerate, setFirstTimeGenerate] = useState(true);

  const [cellHoveredOn, setCellHoveredOn] = useState(null);
  const [token, setToken] = useState(null);

  const [attendanceData, setAttendanceData] = useState([]);
  const [interviewLimit, setInterviewLimit] = useState(null);
  const [dateIsInThePast, setDateIsInThePast] = useState(false);
  const [interviewDateIsToday, setInterviewDateIsToday] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth); // Used for table overflow handling
  const [hasFlexColumn, setHasFlexColumn] = useState(false); // Dummy. Or something. to enable/disable the Add Flex column button in ADd Column popover
  const [willEditThePast, setWillEditThePast] = useState(false);
  const [generateMode, setGenerateMode] = useState('ordered'); // ordered, distributed, intelligent
  const [currentTime, setCurrentTime] = useState(''); // value isn't actually used, more like a toggle to refresh the screen
  const [sortOnce, setSortOnce] = useState(true);

  const [showScheduleWizard, setShowScheduleWizard] = useState(false);
  const [scheduleWizardInitialStep, setScheduleWizardInitialStep] = useState(1);
  const [showPastScheduleWarning, setShowPastScheduleWarning] = useState();

  const [tableData, setTableData] = useState({}); // Actual data to display
  const [tableColumns, setTableColumns] = useState([]); // Actual columns to display
  const [hasLongInterviews, setHasLongInterviews] = useState(false); // Track if any interviews exceed 35 minutes
  const [notifications, setNotifications] = useState([]); // Notifications/alerts for the department

  let hasFiredInactivityPopup = false;

  const scheduleDate =
    scheduleData && scheduleData.metaData && scheduleData.metaData.StartDateAndTime
      ? dayjs.tz(scheduleData.metaData.StartDateAndTime)
      : null;

  const deptContext = useContext(DepartmentContext);
  const dContext = forcedContext ? forcedContext : deptContext;
  const inactivityWait = 15; //15 in minutes

  const { department = {} } = dContext;
  const { VirtualMeetingMode } = department;
  const embeddedMeetingsEnabled = VirtualMeetingMode === 'Internal' && Boolean(department.enableEmbeddedMeetings);
  const enforce35MinuteLimit = VirtualMeetingMode === 'Internal' && !embeddedMeetingsEnabled;
  const { getTokenSilently, logout, loginWithRedirect } = useAuth0();

  fileInputs = document.getElementsByClassName('swal2-file');

  useEffect(() => {
    let fileInputs = document.getElementsByClassName('swal2-file');

    if (fileInputs && fileInputs.length > 0) {
      fileInputs[0].remove();
    }
  }, [fileInputs]);

  useEffect(() => {
    if (scheduleDate) {
      setDateIsInThePast(scheduleDate.isBefore(dayjs.tz()));
      setInterviewDateIsToday(scheduleDate.isSame(dayjs(), 'day'));
    }
  }, [scheduleDate]);

  useEffect(() => {
    pendingCandidatesStateRef.current = clone(pendingCandidates);
  }, [pendingCandidates]);

  useEffect(() => {
    if (showCloneModal) {
      hideTimeSlotPopoversExcept();
      hideHeaderPopoversExcept();
      setShowAddColumnPopover(false);
    }
  }, [showCloneModal]);

  useEffect(() => {
    if (!showScheduleDetailModal) {
      setSelectedCell(null);
      setSelectedScheduleBlock(null);
    }

    if (showScheduleDetailModal && !selectedScheduleBlock) {
      setShowScheduleDetailModal(false);
    }
  }, [showScheduleDetailModal]);

  useEffect(() => {
    if (scheduleData) {
      scheduleDataRef.current = scheduleData;

      processTableDataToDisplay();
    }
  }, [scheduleData]);

  useEffect(() => {
    selectedCellRef.current = clone(selectedCell);
  }, [selectedCell]);

  useEffect(() => {
    selectedScheduleBlockRef.current = clone(selectedScheduleBlock);
  }, [selectedScheduleBlock]);

  useEffect(() => {
    console.log();

    const interval = 60000;
    // const interval = 5000;
    attendanceChecker = setInterval(() => {
      if (scheduleDataRef.current) {
        const { StartTime, EndTime } = getScheduleStartAndEndTime(scheduleDataRef.current);
        const { headers, body } = scheduleDataRef.current;
        const now = dayjs(); //.format('MMM DD, YYYY hh:mm A');
        const isMeetingInProgress = now.isSameOrAfter(StartTime) && now.isSameOrBefore(EndTime); //isTimeRangeOverlap([StartTime, now], [now, EndTime]);

        if (isMeetingInProgress && headers.length > 0 && body.length > 1) {
          fetchAttendanceData();
        }
      }
    }, interval);

    getTokenSilently()
      .then((token) => {
        setToken(token);
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });

    getInterviewDates();
    fetchNotifications();
    const parent = document.getElementById('schedule_proper').parentElement;
    window.addEventListener('resize', () => {
      setWindowWidth(parent.clientWidth - 40);
    });
    fetchAttendanceData();
    setInterval(() => {
      setCurrentTime(dayjs().valueOf());
    }, 5000);

    document.addEventListener('mousemove', () => {
      const now = dayjs();
      localStorage.setItem('lastActivity', now.toISOString());
    });
    document.addEventListener('click', () => {
      const now = dayjs();
      localStorage.setItem('lastActivity', now.toISOString());
    });

    checkInactivity(true);

    setInterval(() => {
      checkInactivity();
    }, 10000);

    return () => {
      attendanceChecker && clearInterval(attendanceChecker);
      return;
    };
  }, []);

  useEffect(() => {
    if (pk_InterviewDate != null) {
      updateAllData();
    }
  }, [pk_InterviewDate]);

  useEffect(() => {
    if (Object.values(candidates)) {
      setCandidatesArray(Object.values(candidates));
    }
  }, [candidates]);

  useEffect(() => {
    // setGeneratedScheduleData(null);
    // setPendingCandidates({});
  }, [columnsToIgnore]);

  useEffect(() => {
    processTableDataToDisplay();
  }, [hasFlexColumn, columnsToIgnore, showHeaderPopOver, activeTimeSlotPopover, generatedScheduleData, enforce35MinuteLimit]);

  useEffect(() => {
    setHasFlexColumn(countFlexEvents() > 0);
  }, [indexedFlexEvents]);

  useEffect(() => {
    processTableDataToDisplay();
  }, [cellHoveredOn, headerHoveredOn]);

  // sets up trackers for flex events vs evaluators.
  const initializeTrackers = (scheduleDataToTrack) => {
    const { headers = [], body = [] } = scheduleDataToTrack;
    const newRowTracker = {};
    const newColumnTracker = {};

    headers.forEach((header) => {
      if (newColumnTracker[header.pk_ScheduleAssignment] == null) {
        newColumnTracker[header.pk_ScheduleAssignment] = [];
      }
      body.forEach((timeSlotRow) => {
        const rowColumn = timeSlotRow[header.pk_ScheduleAssignment];
        if (newRowTracker[timeSlotRow.pk_Timeslot] == null) {
          newRowTracker[timeSlotRow.pk_Timeslot] = [];
        }
        if (rowColumn && rowColumn.ScheduleBlockEntries) {
          rowColumn.ScheduleBlockEntries.forEach((scheduleBlock) => {
            if (scheduleBlock.Candidates) {
              scheduleBlock.Candidates.forEach((candidate) => {
                if (!candidate) {
                  return;
                }

                newRowTracker[timeSlotRow.pk_Timeslot].push(candidate.pk_Candidate);
                newColumnTracker[header.pk_ScheduleAssignment].push(candidate.pk_Candidate);
              });
            } else {
            }
          });
        }
      });
    });

    const newTrackers = setupTrackers(scheduleDataToTrack);

    setSplitCountTracker(newTrackers.splitCountTracker);
    setSplitBlockCandidateTracker(newTrackers.splitBlockCandidateTracker);
    setRowTracker(newTrackers.rowTracker);
    setColumnTracker(newTrackers.columnTracker);
    setScheduleBlockTracker(newTrackers.scheduleBlockTracker);
    setColumnAvailabilityTracker(newTrackers.columnAvailabilityTracker);

    if (setParentColumnTracker) {
      setParentColumnTracker(newTrackers.columnTracker);
    }

    if (setParentRowTracker) {
      setParentRowTracker(newTrackers.rowTracker);
    }

    // setSplitCountTracker(setupSplitCountTrackers(scheduleDataToTrack));
    // setSplitBlockCandidateTracker(setupSplitBlockCandidateTrackers(scheduleDataToTrack));
    // setRowTracker(newRowTracker);
    // setColumnTracker(newColumnTracker);
    // if (setParentColumnTracker) {
    //   setParentColumnTracker(newColumnTracker);
    // }

    // if (setParentRowTracker) {
    //   setParentRowTracker(newRowTracker);
    // }
  };

  const resetCopyValues = () => {
    setWillCopyHeaders(true);
    setWillCopyStartTime(true);
    setWillCopyInterviewDuration(true);
    setWillCopyPassingDuration(true);
    setWillCopyCandidateAssignments(true);
    setWillCopyTimeSlots(true);
    setWillCopyCustomEvents(true);
    setWillCopyCustomDurations(true);
    setWillCopyFlexEvents(true);
    setInterviewDateToClone(null);
  };

  const indexFlexEvents = (newScheduleData, evaluators = []) => {
    const newIndexedFlexEvents = {};
    const newIndexedEvaluatorFlexEvents = {};
    const newIndexedFlexEventEvaluators = {};

    // Object.keys(evaluators).forEach((key) => {
    //   const evaluator = evaluators[key];
    //   newIndexedEvaluatorFlexEvents[evaluator.pk_User] = [];
    //   if (evaluator.FlexEvents) {
    //     evaluator.FlexEvents.forEach((flexEvent) => {
    //       newIndexedEvaluatorFlexEvents[evaluator.pk_User].push(flexEvent.pk_FlexEvent);
    //       if (newIndexedFlexEventEvaluators[flexEvent.pk_FlexEvent] == null) {
    //         newIndexedFlexEventEvaluators[flexEvent.pk_FlexEvent] = [evaluator.pk_User];
    //       } else {
    //         newIndexedFlexEventEvaluators[flexEvent.pk_FlexEvent].push(evaluator.pk_User);
    //       }

    //       newIndexedFlexEvents[flexEvent.pk_FlexEvent] = flexEvent;
    //     });
    //   }
    // });

    const { metaData = {} } = newScheduleData || {};
    const { FlexEvents = [] } = metaData;
    FlexEvents.forEach((flexEvent) => {
      const { pk_FlexEvent, FlexDateStart, FlexDateEnd } = flexEvent;
      const flexEventStartDate = FlexDateStart;
      const flexEventEndDate = FlexDateEnd;

      if (
        // (flexEventStartDate === metaData.DateOfInterview || flexEventEndDate === metaData.DateOfInterview) &&
        newIndexedFlexEvents[pk_FlexEvent] == null
      ) {
        newIndexedFlexEvents[pk_FlexEvent] = flexEvent;

        // indexedEvaluatorFlexEvents
        flexEvent.AttendingUsers.forEach((evaluator) => {
          const evaluatorFlexEvents = clone(newIndexedEvaluatorFlexEvents[evaluator.pk_User]) || [];

          if (
            !evaluatorFlexEvents.find((pk_FlexEvent) => {
              return pk_FlexEvent == flexEvent.pk_FlexEvent;
            })
          ) {
            evaluatorFlexEvents.push(flexEvent);
          }

          newIndexedEvaluatorFlexEvents[evaluator.pk_User] = evaluatorFlexEvents;
        });
      }
    });

    const eventKeys = Object.keys(newIndexedFlexEvents);

    // TODO: Remove this altogether. Get Evaluators off of Flex Events,
    // flexEvent.evaluators or something. Jeff needs to do it first
    Object.keys(evaluators).forEach((key) => {
      const evaluator = evaluators[key];
      const evaluatorFlexEventsActual = []; // Flex Events off of metaData.FlexEvents. Has better shape/
      if (evaluator.FlexEvents) {
        evaluator.FlexEvents.forEach((flexEvent, i) => {
          if (eventKeys.includes(flexEvent.pk_FlexEvent.toString())) {
            const oldValue = newIndexedFlexEventEvaluators[flexEvent.pk_FlexEvent];
            evaluatorFlexEventsActual.push(newIndexedFlexEvents[flexEvent.pk_FlexEvent.toString()]);
            if (oldValue) {
              if (!oldValue.includes(evaluator.pk_User.toString())) {
                oldValue.push(evaluator.pk_User);
                newIndexedFlexEventEvaluators[flexEvent.pk_FlexEvent] = oldValue;
              }
            } else {
              newIndexedFlexEventEvaluators[flexEvent.pk_FlexEvent] = [evaluator.pk_User];
            }
          }
        });
      }

      // newIndexedEvaluatorFlexEvents[evaluator.pk_User] = evaluatorFlexEventsActual || [];
    });

    setIndexedFlexEvents(newIndexedFlexEvents);
    setIndexedEvaluatorFlexEvents(newIndexedEvaluatorFlexEvents);
    setIndexedFlexEventEvaluators(newIndexedFlexEventEvaluators);

    return { newIndexedFlexEvents, newIndexedEvaluatorFlexEvents, newIndexedFlexEventEvaluators };
  };

  const fetchSchedule = (token, options) => {
    const pathExploded = !isEmbedded ? history.location.pathname.split('/') : '';
    const scheduleID = !isEmbedded ? pathExploded[pathExploded.length - 1] : pk_InterviewDate;
    setScheduleID(scheduleID);

    if (scheduleData == null) {
      setIsTableLoaded(false);
    }

    setIsFetching(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/season/interviewDate',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            pk_InterviewDate: parseInt(scheduleID),
          },
          formatBearerToken(token),
        )
          .then((res) => {
            const { resolve } = options || {};
            const timeZone = dContext.department.timeZone;

            if (res.data.metaData == null || res.data.metaData.StartDateAndTime == null) {
              Swal.fire({
                title: 'Broken Schedule',
                icon: 'error',
                text:
                  'Problematic schedule data detected! Closing this popup would redirect to the Interview dates list.',
                type: 'error',
              }).then((result) => {
                if (result.value) {
                  history.push('/administrator');
                }
              });
            } else {
              try {
                // debugger;
                const tempSchedData = res.data;
                tempSchedData.headers = sortHeaders(res.data);

                const scheduleDataWithTime = addTimeToTimeSlots(tempSchedData, timeZone);

                initializeTrackers(scheduleDataWithTime);

                if (resolve) {
                  resolve(scheduleDataWithTime);
                  return;
                }

                setIsFetching(false);

                fetchEvaluators(token, scheduleDataWithTime, options);
              } catch (err) {
                console.log('err', err);
              }
            }
          })
          .catch((e) => {
            const { reject } = options || {};
            if (reject) {
              reject(e);
              return;
            }

            setIsFetching(false);
            setIsGeneratingSchedule(false);
            setIsScheduleDataError(true);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const fetchCandidates = (token, options) => {
    setIsFetching(true);
    const pathExploded = !isEmbedded ? history.location.pathname.split('/') : '';
    const scheduleID = pk_InterviewDate != null ? pk_InterviewDate : pathExploded[pathExploded.length - 1];

    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/candidates',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            pk_InterviewDate: parseInt(scheduleID),
          },
          formatBearerToken(token),
        )
          .then((res) => {
            const { resolve } = options || {};
            const newCandidates = { ...res.data };

            let colorKey = 0; // Math.floor(Math.random() * colors.length);
            Object.keys(newCandidates).forEach((key, i) => {
              if (colorKey >= colors.length) {
                colorKey = 0;
              }
              newCandidates[key].color = colors[colorKey];
              newCandidates[key].originalColor = colors[colorKey];
              colorKey++;
            });

            if (resolve) {
              resolve(newCandidates);
              return;
            }
            setIsFetching(false);
            setCandidates(newCandidates);
            if (setParentCandidates) {
              setParentCandidates(newCandidates);
            }
          })
          .catch((e) => {
            setIsFetching(false);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const fetchAttendanceData = (willUpdateAllData = true) => {
    const pathExploded = !isEmbedded ? history.location.pathname.split('/') : '';
    const scheduleID = pk_InterviewDate != null ? pk_InterviewDate : pathExploded[pathExploded.length - 1];
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/season/interviewDate/attendance',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            pk_InterviewDate: parseInt(scheduleID),
          },
          formatBearerToken(token),
        )
          .then((res) => {
            setAttendanceData(res.data.Attendances);
            const scheduleLastUpdated = dayjs.tz(res.data.ScheduleLastUpdated);
            if (
              willUpdateAllData &&
              (!scheduleLastUpdate.current ||
                (scheduleLastUpdate.current && scheduleLastUpdate.current.isBefore(scheduleLastUpdated)))
            ) {
              scheduleLastUpdate.current = scheduleLastUpdated;
              updateAllData();
            }
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const fetchNotifications = () => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/alerts',
          { pk_Department: dContext.department.pk_Department },
          formatBearerToken(token),
        )
          .then((res) => {
            setNotifications(res.data || []);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getPendingCandidates = () => {
    return clone(pendingCandidates);
  };

  const hasPassingPeriodNotifications = () => {
    return notifications.some((n) => n.Type === 'End of Passing' || n.Type === 'End of Passing Period');
  };

  const getInterviewDates = () => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/InterviewDates',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            setInterviewDates(res.data);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getUpdatedSelectedCellFromScheduleData = (oldCell, newScheduleData) => {
    const { row, column } = oldCell;
    const { body } = newScheduleData;

    const headers = makeColumns(newScheduleData);
    let newColumnIndex = 0;
    let newRowIndex = 0;
    const newRow = body.find((b, i) => {
      if (b.pk_Timeslot == row.pk_Timeslot) {
        newRowIndex = i;
      }

      return b.pk_Timeslot == row.pk_Timeslot;
    });

    const newColumn = headers.find((h, i) => {
      if (h.dataField == column.dataField) {
        newColumnIndex = i;
      }
      return h.dataField == column.dataField;
    });

    const newCell = {
      row: newRow,
      column: newColumn,
      columnIndex: newColumnIndex,
      rowIndex: newRowIndex,
    };
    return newCell;
  };

  const getUpdatedScheduleBlockFromSelectedCell = (oldBlock, newSelectedCell) => {
    const { pk_ScheduleBlock } = oldBlock;
    const { row, column } = newSelectedCell;
    if (!column) {
      return null;
    }
    try {
      const cellActual = row[column.dataField];
      const ScheduleBlockEntries = cellActual.ScheduleBlockEntries || [];
      const newBlock = ScheduleBlockEntries.find((s) => {
        return s.pk_ScheduleBlock == pk_ScheduleBlock;
      });
      return newBlock;
    } catch (e) {
      console.log('getUpdatedScheduleBlockFromSelectedCell error: ', e);
    }
  };

  const updateSelectedCellAndBlockFromScheduleData = (newScheduleData) => {
    if (
      selectedCellRef.current &&
      selectedCellRef.current.rowIndex == selectedCell.rowIndex &&
      selectedCellRef.current.columnIndex == selectedCell.columnIndex
    ) {
      const newSelectedCell = getUpdatedSelectedCellFromScheduleData(selectedCellRef.current, newScheduleData);
      setSelectedCell(newSelectedCell);

      if (
        selectedScheduleBlockRef.current &&
        selectedScheduleBlockRef.current.pk_ScheduleBlock == selectedScheduleBlock.pk_ScheduleBlock
      ) {
        const newSelectedBlock = getUpdatedScheduleBlockFromSelectedCell(
          selectedScheduleBlockRef.current,
          newSelectedCell,
        );
        setSelectedScheduleBlock(newSelectedBlock);
      }
    }

    // const newSelectedBlock = getUpdatedScheduleBlockFromSelectedCell(selectedScheduleBlockRef.current, newSelectedCell);

    // if (
    //   selectedCellRef.current &&
    //   selectedCellRef.current.rowIndex == newSelectedCell.rowIndex &&
    //   selectedCellRef.current.columnIndex == newSelectedCell.columnIndex
    // ) {
    //   setSelectedCell(newSelectedCell);
    // }
    // if (
    //   selectedScheduleBlockRef.current &&
    //   selectedScheduleBlockRef.current.pk_ScheduleBlock == newSelectedBlock.pk_ScheduleBlock
    // ) {
    //   setSelectedScheduleBlock(newSelectedBlock);
    // }
  };

  // NOTE: This is the last fetch to be done on refresh of table data. Reset
  // states here, like generatedScheduleData, so that all data is loaded at the same
  // time. This is to avoid gaps in cells when some data are loaded before others.
  const fetchEvaluators = (token, newScheduleData = {}, options) => {
    setIsGeneratingSchedule(true);
    setIsFetching(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/users',
          {
            pk_Department: dContext.department.pk_Department,
            IncludeEvaluators: 1,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            const { resolve } = options || {};
            if (resolve) {
              resolve(res.data);
              return;
            }
            setIsFetching(false);
            if (newScheduleData) {
              const indexedData = indexFlexEvents(newScheduleData, res.data);
              const scheduleDataWithFlexEvents = attachFlexEvents(newScheduleData, res.data, indexedData);
              setIsGeneratingSchedule(false);
              if (selectedCell && selectedScheduleBlock) {
                updateSelectedCellAndBlockFromScheduleData(scheduleDataWithFlexEvents);
              }
              setScheduleData(scheduleDataWithFlexEvents);
              if (setParentScheduleData) {
                setParentScheduleData(scheduleDataWithFlexEvents);
              }

              setGeneratedScheduleData(null);

              setEvaluators(res.data);
            }

            setIsTableLoaded(true);

            const { callingPendingCandidates = [] } = options || {};
            if (callingPendingCandidates.length) {
              const debuggerObj = { callingPendingCandidates, pendingCandidates: getPendingCandidates() };

              const newPendingCandidates = clone(pendingCandidatesStateRef.current);
              callingPendingCandidates.forEach((c) => {
                if (newPendingCandidates[c]) {
                  delete newPendingCandidates[c];
                }
              });

              setPendingCandidates(clone(newPendingCandidates));
            }
          })
          .catch((e) => {
            const { reject } = options || {};
            if (reject) {
              reject(e);
              return;
            }
            setIsFetching(false);
            setIsGeneratingSchedule(false);
            setIsTableLoaded(true);
          });
      })
      .catch((err) => {
        console.log('fetchEvaluators getToken err: ', err);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const addColumn = async (data, resolve, reject, callback) => {
    if (dateIsInThePast && !willEditThePast) {
      const continueProcess = await fireConfirmationForEditingPastSchedule();
      if (!continueProcess) {
        return;
      }
    }
    if (isInPreviewMode()) {
      setShowUnsavedChangeModal(!isSubmitting);
      return;
    }

    const pathExploded = !isEmbedded ? history.location.pathname.split('/') : '';
    let payload = data;

    if (Array.isArray(payload)) {
      payload = {
        payload: data,
      };
    } else {
      const { evaluatorList, TotalNumberOfSplits, pk_MeetingRoom } = data;

      payload = {
        payload: [
          {
            TotalNumberOfSplits: TotalNumberOfSplits,
            pk_MeetingRoom: pk_MeetingRoom,
            evaluatorPrimaryKeys: evaluatorList || [],
          },
        ],
      };
    }
    setIsAddingColumn(true);
    setIsSubmitting(true);

    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/season/schedule/column',
          {
            pk_Department: dContext.department.pk_Department,
            pk_InterviewDate: parseInt(scheduleID),
          },
          payload,
          formatBearerToken(token),
        )
          .then((res) => {
            setIsSubmitting(false);
            if (callback) {
              callback(true);
              // return;
            }
            if (resolve) {
              resolve(true);
            } else {
              setIsAddingColumn(false);
              setShowAddColumnPopover(false);
              fetchSchedule(token);
            }
          })
          .catch((err) => {
            setIsSubmitting(false);
            if (callback) {
              callback(false);
            }
            if (reject) {
              reject();
            } else {
              setIsAddingColumn(false);
            }
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const addColumns = async (data, callback) => {
    if (dateIsInThePast && !willEditThePast) {
      const continueProcess = await fireConfirmationForEditingPastSchedule();
      if (!continueProcess) {
        return;
      }
    }
    if (isInPreviewMode()) {
      setShowUnsavedChangeModal(!isSubmitting);
      return;
    }
    const { evaluatorList } = data;
    setIsAddingColumn(true);
    setIsSubmitting(true);
    Promise.all(
      evaluatorList.map((evaluator) => {
        return new Promise((resolve, reject) => {
          addColumn({ evaluatorList: Array.isArray(evaluator) ? evaluator : [evaluator] }, resolve, reject);
        });
      }),
    )
      .then((values) => {
        setIsSubmitting(false);
        setIsAddingColumn(false);
        setShowAddColumnPopover(false);
        fetchSchedule(token);
        if (callback) {
          callback();
        }
      })
      .catch((err) => {
        setIsSubmitting(false);
        setIsAddingColumn(false);
      });
  };

  const onDeleteColumn = async (columnToDelete, resolve, reject, callback) => {
    if (dateIsInThePast && !willEditThePast) {
      const continueProcess = await fireConfirmationForEditingPastSchedule();
      if (!continueProcess) {
        return;
      }
    }
    setIsSubmitting(true);
    if (isInPreviewMode()) {
      setShowUnsavedChangeModal(!isSubmitting);
      return;
    }
    // TODO: Update to use Room id or something, need actual data
    const newEvaluators = { ...evaluators };
    const newShowHeaderPopOver = { ...showHeaderPopOver };
    delete newShowHeaderPopOver[columnToDelete.dataField];

    setShowHeaderPopOver(newShowHeaderPopOver);
    setEvaluators(newEvaluators);
    getTokenSilently()
      .then((token) => {
        deleteData(
          'department/season/schedule/column',
          {
            pk_Department: dContext.department.pk_Department,
            pk_InterviewDate: parseInt(scheduleID),
          },
          {
            pk_ScheduleAssignments: Array.isArray(columnToDelete) ? columnToDelete : [columnToDelete.dataField],
            type: 'delete',
          },
          formatBearerToken(token),
        )
          .then((res) => {
            if (callback) {
              callback(true);
              return;
            }

            if (resolve) {
              resolve(true);
            } else {
              setIsSubmitting(false);
              fetchSchedule(token);
              fetchCandidates(token);
            }
          })
          .catch((err) => {
            if (callback) {
              callback(false);
            }
            if (reject) {
              reject();
            } else {
              setIsSubmitting(false);
            }
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const onClearColumn = async (columnsToClear, callBack) => {
    // const newScheduleData = clearColumns(clone(scheduleData), columnsToClear);

    // await submitGeneratedSchedule(newScheduleData.body);

    setIsSubmitting(true);

    return getTokenSilently()
      .then((token) => {
        deleteData(
          'department/season/schedule/column',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
          },
          {
            pk_ScheduleAssignments: columnsToClear,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            if (callBack) {
              callBack(res);
            }
            setIsSubmitting(false);
            fetchSchedule(token);
            fetchCandidates(token);
            return true;
          })
          .catch((err) => {
            updateAllData({ pendingItemKey: 'all' });
            setTimeout(() => {
              setIsSubmitting(false);
              setIsGeneratingSchedule(false);
            }, 1000);
            return false;
          })
          .finally(() => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const addFlexColumn = () => {
    setHasFlexColumn(true);
  };

  const removeFlexColumn = () => {
    setHasFlexColumn(false);
  };

  const cloneFromExistingSchedule = () => {
    setIsCloning(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/season/interviewDate',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            pk_InterviewDate: parseInt(interviewDateToClone.pk_InterviewDate),
          },
          formatBearerToken(token),
        )
          .then((res) => {
            const scheduleDataToClone = res.data;
            const { metaData = {} } = scheduleDataToClone;
            const { StartDateAndTime, StandardDurationInMinutes, StandardPassingDurationInMinutes } = metaData;

            const itemsToClone = [];

            if (willCopyHeaders) {
              const processHeaders = new Promise((resolve, reject) => {
                cloneHeaders(scheduleDataToClone, resolve, reject);
              });
              itemsToClone.push(processHeaders);
            }

            if (willCopyStartTime || willCopyInterviewDuration || willCopyPassingDuration) {
              const processDurations = new Promise((resolve, reject) => {
                const payload = {};
                if (willCopyStartTime) {
                  payload.startTime = dayjs.tz(StartDateAndTime).format('HH:mm');
                }
                if (willCopyInterviewDuration) {
                  payload.standardDuration = StandardDurationInMinutes;
                }
                if (willCopyPassingDuration) {
                  payload.standardPassingDuration = StandardPassingDurationInMinutes;
                }

                cloneDurations(payload, resolve, reject);
              });

              itemsToClone.push(processDurations);
            }

            if (willCopyTimeSlots) {
              const processCustomEvents = new Promise((resolve, reject) => {
                cloneTimeSlots({ scheduleDataToClone }, resolve, reject);
              });

              itemsToClone.push(processCustomEvents);
            }

            if (willCopyFlexEvents) {
              const processFlexEvents = new Promise((resolve, reject) => {
                cloneFlexEvents({ scheduleDataToClone }, resolve, reject);
              });
              itemsToClone.push(processFlexEvents);
            }

            Promise.all(itemsToClone)
              .then((res) => {
                Swal.fire(
                  'Clone Success!',
                  `Schedule configuration copied from  ${
                    interviewDateToClone && interviewDateToClone.DateOfInterview
                      ? dayjs(interviewDateToClone.DateOfInterview).format('MMM DD, YYYY')
                      : ''
                  } ${interviewDateToClone.Label || '(No Label)'}`,
                  'success',
                );
                setIsCloning(false);
                setIsSubmitting(false);
                setShowCloneModal(false);
                setInterviewDateToClone(null);
                updateAllData();
              })
              .catch((err) => {
                setIsCloning(false);
                setIsSubmitting(false);
                Swal.fire({
                  title: 'Failed Cloning',
                  icon: 'error',
                  text: 'Cloning process failed partway through.',
                  type: 'error',
                });
              });
          })
          .catch((err) => {
            Swal.fire({
              title: 'Failed Cloning',
              icon: 'error',
              text: 'Cloning process failed partway through.',
              type: 'error',
            });
            setIsCloning(false);
            setIsSubmitting(false);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const cloneHeaders = (scheduleDataToClone, resolve, reject, callback) => {
    const headersToCopy = scheduleDataToClone.headers
      ? scheduleDataToClone.headers.map((header) => {
          const { ColumnTotalNumberSplits, pk_MeetingRoom } = header;
          const headerEvaluators = [];

          if (header.Evaluators && header.Evaluators.Evaluators) {
            header.Evaluators.Evaluators.forEach((e) => {
              headerEvaluators.push(e.pk_User);
            });
          } else {
            // return {};
          }
          const toReturn = {
            TotalNumberOfSplits: ColumnTotalNumberSplits,
            evaluatorPrimaryKeys: headerEvaluators,
            pk_MeetingRoom,
          };
          return toReturn;
        })
      : [];

    const headersToDelete = scheduleData.headers.map((header) => {
      return header.pk_ScheduleAssignment;
    });

    onDeleteColumn(headersToDelete, null, null, (res) => {
      if (headersToCopy && headersToCopy.length > 0) {
        addColumn(headersToCopy, null, null, (res) => {
          if (res) {
            resolve(true);
          } else {
            reject(res);
          }
        });
      } else if (callback) {
        // fetchSchedule();
        callback();
      } else {
        if (res) {
          resolve(true);
        } else {
          reject(res);
        }
      }
    });
  };

  const cloneDurations = (data, resolve, reject, callback) => {
    const { department, season } = dContext;
    const { startTime, standardDuration, standardPassingDuration } = data;
    const pathExploded = !isEmbedded ? history.location.pathname.split('/') : '';
    const scheduleID = pk_InterviewDate != null ? pk_InterviewDate : pathExploded[pathExploded.length - 1];

    getTokenSilently()
      .then((token) => {
        putData(
          'department/interviewDate/putEntry',
          {
            pk_Department: department.pk_Department,
            pk_InterviewDate: scheduleID,
            pk_Season: season.pk_Season,
          },
          {
            entry: {
              StartTime: startTime,
              StandardDurationInMinutes: standardDuration,
              StandardPassingDurationInMinutes: standardPassingDuration,
            },
          },
          formatBearerToken(token),
        )
          .then((res) => {
            if (callback) {
              callback();
            }

            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const cloneTimeSlots = (data, resolve, reject, callback) => {
    postDataAgnostic(
      'department/season/schedule/timeslots/duplicate',
      {
        pk_Department: dContext.department.pk_Department,
        includeEvaluators: willCopyHeaders, // willCopyFlexEventEvaluators ? 1 : 0,
      },
      {
        pk_InterviewDate_CopiedTo: parseInt(scheduleID),
        pk_InterviewDate_CopiedFrom: interviewDateToClone.pk_InterviewDate,
      },
      formatBearerToken(token),
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  };

  const cloneFlexEvents = (data, resolve, reject, callback) => {
    const { scheduleDataToClone } = data;
    const metaDataOld = scheduleData.metaData || {};
    const metaDataToClone = scheduleDataToClone.metaData || {};

    postDataAgnostic(
      'department/season/schedule/flexEvents/duplicate',
      {
        pk_Department: dContext.department.pk_Department,
        includeEvaluators: willCopyEvaluators ? 1 : 0,
      },
      {
        pk_InterviewDate_CopiedTo: parseInt(scheduleID),
        pk_InterviewDate_CopiedFrom: interviewDateToClone.pk_InterviewDate,
      },
      formatBearerToken(token),
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  };

  // TO DO: Separate API for auto-fill column
  const submitGeneratedSchedule = (newSchedule, cb) => {
    setIsGeneratingSchedule(true);
    setIsSubmitting(true);
    const pathExploded = !isEmbedded ? history.location.pathname.split('/') : '';
    const scheduleID = pk_InterviewDate != null ? pk_InterviewDate : pathExploded[pathExploded.length - 1];

    return getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/season/schedule/generate',
          {
            pk_Department: dContext.department.pk_Department,
            pk_InterviewDate: parseInt(scheduleID),
          },
          {
            schedule: newSchedule,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            setIsSubmitting(false);
            updateAllData({ pendingItemKey: 'all' });
            hideHeaderPopoversExcept();
            if (cb) {
              cb();
            }
            return true;
          })
          .catch((err) => {
            updateAllData({ pendingItemKey: 'all' });
            if (cb) {
              cb(err);
            }
            setTimeout(() => {
              setIsSubmitting(false);
              setIsGeneratingSchedule(false);
            }, 1000);
            return false;
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const addCandidateToSchedule = (data) => {
    const pathExploded = !isEmbedded ? history.location.pathname.split('/') : '';
    const scheduleID = pk_InterviewDate != null ? pk_InterviewDate : pathExploded[pathExploded.length - 1];
    const candidateKeys = data.candidates.map((c) => {
      return c.pk_Candidate;
    });

    const candidatesToDelete =
      selectedScheduleBlock && selectedScheduleBlock.Candidates
        ? selectedScheduleBlock.Candidates.map((c) => {
            return c.pk_Candidate;
          })
        : [];

    const pendingItemKey = `${data.pk_Timeslot}_${data.pk_ScheduleAssignment}${
      selectedScheduleBlock ? `_${selectedScheduleBlock.SortOrder}` : `_0`
    }`;
    // ${timeSlot}_${h}${scheduleBlockCount > 1 ? `_${scheduleBlockIndex}` : `_0`}
    const newCandidates = clone(pendingCandidates);

    // Potential breakage here. Untested with Split cells.
    newCandidates[pendingItemKey] = data.candidates.slice();

    setPendingCandidates(newCandidates);

    setIsSubmitting(true);
    setIsAddingCandidate(true);
    setShowScheduleDetailModal(false);
    setIsGeneratingSchedule(true);

    getTokenSilently()
      .then((token) => {
        // Add to Existing schedule blcok.
        if (selectedScheduleBlock && selectedScheduleBlock.pk_ScheduleBlock) {
          putData(
            'department/season/schedule/candidate',
            {
              pk_Department: dContext.department.pk_Department,
              pk_ScheduleBlock: selectedScheduleBlock ? selectedScheduleBlock.pk_ScheduleBlock : null,
              pk_interviewDate: Number(scheduleID),
            },
            {
              SortOrder: selectedScheduleBlock.SortOrder,
              writeCandidatePrimaryKeys: candidateKeys || [],
              deleteCandidatePrimaryKeys: candidatesToDelete || [],
            },
            formatBearerToken(token),
          )
            .then((res) => {
              setIsSubmitting(false);
              setIsAddingCandidate(false);
              updateAllData({ pendingItemKey });
              // setSelectedScheduleBlock(null);
            })
            .catch((e) => {
              console.log('add err: ', e);

              if (e.response && e.response.status == 400) {
                Swal.fire({
                  title: 'Outdated Schedule',
                  text:
                    'Unable to add candidate. Schedule may have been modified elsewhere. Click ok to reload schedule.',
                  icon: 'info',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.value) {
                    updateAllData();
                  }
                });
              }
              setIsAddingCandidate(false);
              setIsSubmitting(false);
              const newPendingCandidates = clone(pendingCandidatesStateRef.current);
              delete newPendingCandidates[pendingItemKey];
              setPendingCandidates(newPendingCandidates);
            });
        } else {
          // Add a new Schedule block with candidates
          const { pk_ScheduleAssignment, pk_Timeslot } = data;

          postDataAgnostic(
            'department/season/schedule/block',
            {
              pk_Department: dContext.department.pk_Department,
              pk_ScheduleAssignment,
              pk_InterviewDate: scheduleID,
              pk_Timeslot,
            },
            {
              SortOrder:
                selectedScheduleBlock && selectedScheduleBlock.SortOrder != null
                  ? selectedScheduleBlock.SortOrder
                  : null,
              candidates: candidateKeys || [],
            },
            formatBearerToken(token),
          )
            .then((res) => {
              setIsSubmitting(false);
              setIsAddingCandidate(false);
              updateAllData({ pendingItemKey });
              // setSelectedScheduleBlock(null);
              // ======to replicate in Promise.all========//
              // fetchSchedule(token, { callingPendingCandidates: [pendingItemKey], newCandidates });
              // fetchCandidates(token);
              // ============================================//
            })
            .catch((e) => {
              // Add handling for when api sends error for current schedule being outdated, and to re-fetch schedule before populating again.

              if (e.response && e.response.status == 400) {
                Swal.fire({
                  title: 'Outdated Schedule',
                  text:
                    'Unable to add candidate. Schedule may have been modified elsewhere. Click ok to reload schedule.',
                  icon: 'info',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.value) {
                    updateAllData();
                  }
                });
              }

              setIsAddingCandidate(false);
              setIsSubmitting(false);
              const newPendingCandidates = clone(pendingCandidatesStateRef.current);
              delete newPendingCandidates[pendingItemKey];
              setPendingCandidates(newPendingCandidates);
            });
        }
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const clearScheduleBlock = (blocksToClear, callback) => {
    setIsSubmitting(true);
    setIsGeneratingSchedule(true);
    getTokenSilently()
      .then((token) => {
        if (blocksToClear && blocksToClear.length > 0) {
          Promise.all(
            blocksToClear.map((b) => {
              return new Promise((resolve, reject) => {
                deleteData(
                  'department/season/schedule/block',
                  {
                    pk_Department: dContext.department.pk_Department,
                    pk_InterviewDate: Number(scheduleID),
                    pk_ScheduleBlock: b,
                  },
                  null,
                  formatBearerToken(token),
                )
                  .then((res) => {
                    resolve();
                  })
                  .catch((err) => {
                    reject();
                  });
              });
            }),
          )
            .then((res) => {
              if (callback) {
                callback();
              } else {
                setIsSubmitting(false);
                fetchSchedule(token);
                fetchCandidates(token);
                setShowScheduleDetailModal(false);
              }
            })
            .catch((err) => {
              setIsSubmitting(false);
            });
        } else {
          deleteData(
            'department/season/schedule/block',
            {
              pk_Department: dContext.department.pk_Department,
              pk_InterviewDate: Number(scheduleID),
              pk_ScheduleBlock: selectedScheduleBlock.pk_ScheduleBlock,
            },
            null,
            formatBearerToken(token),
          )
            .then((res) => {
              setIsSubmitting(false);
              fetchSchedule(token);
              fetchCandidates(token);
              setShowScheduleDetailModal(false);
            })
            .catch((err) => {
              setIsSubmitting(false);
            });
        }
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const addUnavailableSlot = async (data, resolve, reject, callback) => {
    if (dateIsInThePast && !willEditThePast) {
      const continueProcess = await fireConfirmationForEditingPastSchedule();
      if (!continueProcess) {
        return;
      }
    }

    const {
      newEvaluators,
      candidates,
      FlexTimeStart,
      FlexTimeEnd,
      EventName,
      StartDateTime,
      EndDateTime,
      FlexEventName,
      hideScheduleDetailModal = true,
    } = data;

    if (isInPreviewMode()) {
      setShowUnsavedChangeModal(!isSubmitting);
      return;
    }
    setIsSubmitting(true);
    setIsGeneratingSchedule(true);

    if (hideScheduleDetailModal) {
      setShowScheduleDetailModal(false);
    }

    const pathExploded = !isEmbedded ? history.location.pathname.split('/') : '';
    const scheduleID = pk_InterviewDate != null ? pk_InterviewDate : pathExploded[pathExploded.length - 1];

    const { metaData } = scheduleData;
    const { DateOfInterview } = metaData;
    const monthDate = DateOfInterview
      ? dayjs.tz(DateOfInterview).format('MMM DD, YYYY')
      : dayjs.tz().format('MMM DD, YYYY');

    const momentStart = dayjs(`${monthDate} ${FlexTimeStart}`);
    const momentEnd = dayjs(`${monthDate} ${FlexTimeEnd}`);

    const event = {
      // StartDateTime,
      EndDateTime,
      EnableForAllUsers: false,
      EnableForAllCandidates: false,
      EnableAbsoluteTime: true,
      EventName: EventName ? EventName : FlexEventName ? FlexEventName : 'UNAVAILABLE',
      FlexTimeStart,
      FlexTimeEnd,
    };

    event.FlexDateStart = momentStart.format('YYYY-MM-DD');
    event.FlexDateEnd = momentEnd.format('YYYY-MM-DD');

    const params = {
      payload: [
        {
          event,
          evaluators: newEvaluators || [],
          candidates: candidates || [],
        },
      ],
    };

    // setIsAddingColumn(true);
    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/season/schedule/flexEvent',
          {
            pk_Department: dContext.department.pk_Department,
            pk_InterviewDate: parseInt(scheduleID),
          },
          params,
          formatBearerToken(token),
        )
          .then((res) => {
            if (callback) {
              callback();
            }
            if (resolve) {
              resolve(res);
            } else {
              setIsSubmitting(false);
              setIsGeneratingSchedule(false);
              fetchSchedule(token);
              fetchCandidates(token);
            }
          })
          .catch((err) => {
            setIsSubmitting(false);
            setIsGeneratingSchedule(false);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const addUnavailableSlots = async (data, resolve, reject, callback) => {
    if (dateIsInThePast && !willEditThePast) {
      const continueProcess = await fireConfirmationForEditingPastSchedule();
      if (!continueProcess) {
        return;
      }
    }

    if (isInPreviewMode()) {
      setShowUnsavedChangeModal(!isSubmitting);
      return;
    }
    setIsSubmitting(true);
    setIsGeneratingSchedule(true);

    if (data.length > 0 && data[0].hideScheduleDetailModal) {
      setShowScheduleDetailModal(false);
    }

    const pathExploded = !isEmbedded ? history.location.pathname.split('/') : '';
    const scheduleID = pk_InterviewDate != null ? pk_InterviewDate : pathExploded[pathExploded.length - 1];

    const { metaData } = scheduleData;
    const { DateOfInterview } = metaData;
    const monthDate = DateOfInterview
      ? dayjs.tz(DateOfInterview).format('MMM DD, YYYY')
      : dayjs.tz().format('MMM DD, YYYY');

    const payload = data.map((newSlot) => {
      const {
        newEvaluators,
        candidates,
        FlexTimeStart,
        FlexTimeEnd,
        EventName,
        StartDateTime,
        EndDateTime,
        FlexEventName,
        hideScheduleDetailModal = true,
      } = newSlot;

      const momentStart = dayjs(`${monthDate} ${FlexTimeStart}`);
      const momentEnd = dayjs(`${monthDate} ${FlexTimeEnd}`);

      const event = {
        // StartDateTime,
        EndDateTime,
        EnableForAllUsers: false,
        EnableForAllCandidates: false,
        EnableAbsoluteTime: true,
        EventName: EventName ? EventName : FlexEventName ? FlexEventName : 'UNAVAILABLE',
        FlexTimeStart,
        FlexTimeEnd,
      };

      event.FlexDateStart = momentStart.format('YYYY-MM-DD');
      event.FlexDateEnd = momentEnd.format('YYYY-MM-DD');

      return { event, evaluators: newEvaluators || [], candidates: candidates || [] };
    });

    const params = {
      payload,
    };

    // setIsAddingColumn(true);
    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/season/schedule/flexEvent',
          {
            pk_Department: dContext.department.pk_Department,
            pk_InterviewDate: parseInt(scheduleID),
          },
          params,
          formatBearerToken(token),
        )
          .then((res) => {
            toast.success('Changes saved!');
            setIsSubmitting(false);
            if (callback) {
              callback();
            } else {
              setIsGeneratingSchedule(false);
              fetchSchedule(token);
              fetchCandidates(token);
            }
            if (resolve) {
              resolve(res);
            } else {
            }
          })
          .catch((err) => {
            toast.success('Changes saved!');
            if (callback) {
              callback(err);
            }
            console.log('addUnavailableSlots err: ', err);
            setIsSubmitting(false);
            setIsGeneratingSchedule(false);
          });
      })
      .catch((err) => {
        toast.success('Changes saved!');
        if (callback) {
          callback(err);
        }
        console.log('addUnavailableSlots getToken err: ', err);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  // Update single Flex event via API
  const updateFlexEvent = (data, callback) => {
    setIsGeneratingSchedule(true);
    setIsSubmitting(true);
    const {
      evaluatorsToAdd,
      evaluatorsToDelete,
      FlexTimeEnd,
      FlexTimeStart,
      EventName,
      EndDateTime,
      FlexEventName,
    } = data;

    const params = {
      event: {
        EndDateTime,
        EnableForAllUsers: false,
        EnableForAllCandidates: false,
        EnableAbsoluteTime: true,
        EventName: EventName ? EventName : FlexEventName ? FlexEventName : 'UNAVAILABLE',
        FlexTimeStart,
        FlexTimeEnd,
      },
      writeEvaluatorPrimaryKeys: evaluatorsToAdd,
      deleteEvaluatorPrimaryKeys: evaluatorsToDelete,
    };

    getTokenSilently()
      .then((token) => {
        putData(
          'department/season/schedule/flexEvent',
          {
            pk_Department: dContext.department.pk_Department,
            pk_FlexEvent: data.pk_FlexEvent,
            pk_InterviewDate: Number(scheduleID),
          },
          params,
          formatBearerToken(token),
        )
          .then((res) => {
            toast.success('Changes saved!');
            setIsSubmitting(false);
            fetchSchedule(token);
            if (callback) {
              callback();
            }
          })
          .catch((err) => {
            toast.error('Failed to save changes!');
            setIsSubmitting(false);
          });
      })
      .catch((err) => {
        toast.error('Failed to save changes!');
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  // Update multiple Flex events via API
  const updateFlexEvents = (data, callback) => {
    setIsGeneratingSchedule(true);
    setIsSubmitting(true);

    const events = data.map((event) => {
      const {
        evaluatorsToAdd,
        evaluatorsToDelete,
        FlexTimeEnd,
        FlexTimeStart,
        EventName,
        EndDateTime,
        FlexEventName,
        pk_FlexEvent,
      } = event;

      return {
        pk_FlexEvent,
        event: {
          EndDateTime,
          EnableForAllUsers: false,
          EnableForAllCandidates: false,
          EnableAbsoluteTime: true,
          EventName: EventName ? EventName : FlexEventName ? FlexEventName : 'UNAVAILABLE',
          FlexTimeStart,
          FlexTimeEnd,
        },
        writeEvaluatorPrimaryKeys: evaluatorsToAdd,
        deleteEvaluatorPrimaryKeys: evaluatorsToDelete,
      };
    });

    const params = {
      events,
    };

    getTokenSilently()
      .then((token) => {
        putData(
          'department/season/schedule/flexEvents',
          {
            pk_Department: dContext.department.pk_Department,
            // pk_FlexEvent: data.pk_FlexEvent,
            pk_InterviewDate: Number(scheduleID),
          },
          params,
          formatBearerToken(token),
        )
          .then((res) => {
            toast.success('Changes saved!');
            setIsSubmitting(false);

            if (callback) {
              callback();
            } else {
              fetchSchedule(token);
            }
          })
          .catch((err) => {
            toast.error('Failed to save changes!');
            setIsSubmitting(false);
            if (callback) {
              callback(err);
            }
          });
      })
      .catch((err) => {
        toast.error('Failed to save changes!');
        if (callback) {
          callback(err);
        }
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const deleteFlexEvent = (pk_FlexEvent, resolve, reject, callBack) => {
    setIsGeneratingSchedule(true);
    setIsSubmitting(true);
    getTokenSilently()
      .then((token) => {
        deleteData(
          'department/season/schedule/flexEvent',
          {
            pk_Department: dContext.department.pk_Department,
          },
          { pk_FlexEvents: [pk_FlexEvent] },
          formatBearerToken(token),
        )
          .then((res) => {
            toast.success('Deleted successfully!');
            if (callBack) {
              callBack();
            }

            if (resolve) {
              resolve(true);
            } else {
              setIsSubmitting(false);
              fetchSchedule(token);
              fetchCandidates(token);
              // setShowScheduleDetailModal(false);
            }
          })
          .catch((err) => {
            if (callBack) {
              callBack(true);
            }
            toast.error('Failed to delete!');
            reject(err);
            setIsSubmitting(false);
          });
      })
      .catch((err) => {
        toast.error('Failed to delete!');
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getFlexEventStartMoment = (flexEvent) => {
    if (!flexEvent) {
      return null;
    }

    const { FlexDateStart, FlexTimeStart, StartDateTime, DateStartTime } = flexEvent;

    if (FlexDateStart && FlexTimeStart) {
      return dayjs(`${FlexDateStart} ${FlexTimeStart}`);
    }

    if (StartDateTime) {
      return dayjs(StartDateTime);
    }

    if (DateStartTime) {
      return dayjs(DateStartTime);
    }

    return null;
  };

  const isUnavailableFlexEvent = (flexEvent) => {
    const eventName = (flexEvent && (flexEvent.EventName || flexEvent.FlexEventName)) || '';
    return eventName.toLowerCase() === 'unavailable';
  };

  const handleScheduleTimeShift = async ({ deltaMinutes = 0, anchorDateTime }) => {
    const shiftMinutes = parseInt(deltaMinutes);
    console.log('[Schedule Debug] handleScheduleTimeShift called', {
      deltaMinutes,
      shiftMinutes,
      anchorDateTime,
      hasScheduleData: !!scheduleData,
      hasMetaData: !!(scheduleData && scheduleData.metaData),
    });
    if (!shiftMinutes || !anchorDateTime || !scheduleData || !scheduleData.metaData) {
      console.log('[Schedule Debug] handleScheduleTimeShift early return', {
        reason: 'missing shiftMinutes/anchorDateTime/scheduleData/metaData',
        shiftMinutes,
        anchorDateTime,
        hasScheduleData: !!scheduleData,
        hasMetaData: !!(scheduleData && scheduleData.metaData),
      });
      return;
    }

    const { metaData = {} } = scheduleData;
    const { FlexEvents = [], TimeZone } = metaData;
    console.log('[Schedule Debug] handleScheduleTimeShift meta', {
      flexEventCount: FlexEvents.length,
      TimeZone,
    });
    if (!FlexEvents || FlexEvents.length === 0) {
      console.log('[Schedule Debug] handleScheduleTimeShift early return', {
        reason: 'no FlexEvents',
      });
      return;
    }

    const anchorMoment = dayjs(anchorDateTime);
    if (!anchorMoment.isValid()) {
      console.log('[Schedule Debug] handleScheduleTimeShift early return', {
        reason: 'invalid anchorMoment',
        anchorDateTime,
      });
      return;
    }

    const now = TimeZone ? dayjs.tz(undefined, TimeZone) : dayjs();
    console.log('[Schedule Debug] handleScheduleTimeShift timing', {
      now: now.format(),
      anchorMoment: anchorMoment.format(),
    });

    const affectedFlexEvents = FlexEvents.filter((flexEvent) => {
      if (isUnavailableFlexEvent(flexEvent)) {
        console.log('[Schedule Debug] skipping unavailable flex event', {
          pk_FlexEvent: flexEvent.pk_FlexEvent,
          name: flexEvent.EventName || flexEvent.FlexEventName,
        });
        return false;
      }

      const flexStart = getFlexEventStartMoment(flexEvent);
      if (!flexStart || !flexStart.isValid()) {
        console.log('[Schedule Debug] skipping invalid flex event start', {
          pk_FlexEvent: flexEvent.pk_FlexEvent,
          name: flexEvent.EventName || flexEvent.FlexEventName,
        });
        return false;
      }

      // Must be in the future and after the modified schedule point.
      const isFuture = flexStart.isAfter(now) || flexStart.isSame(now);
      const isAfterAnchor = flexStart.isAfter(anchorMoment) || flexStart.isSame(anchorMoment);
      console.log('[Schedule Debug] flex event evaluation', {
        pk_FlexEvent: flexEvent.pk_FlexEvent,
        name: flexEvent.EventName || flexEvent.FlexEventName,
        flexStart: flexStart.format(),
        isFuture,
        isAfterAnchor,
      });
      return isFuture && isAfterAnchor;
    });

    console.log('[Schedule Debug] affectedFlexEvents result', {
      affectedCount: affectedFlexEvents.length,
      affectedIds: affectedFlexEvents.map((event) => event.pk_FlexEvent),
    });

    if (affectedFlexEvents.length === 0) {
      console.log('[Schedule Debug] handleScheduleTimeShift early return', {
        reason: 'no affected flex events after filtering',
      });
      return;
    }

    const magnitude = Math.abs(shiftMinutes);
    const isRemoval = shiftMinutes < 0;

    const result = await Swal.fire({
      title: 'Adjust Flex Event Start Times?',
      text: isRemoval
        ? `You've removed ${magnitude} minutes prior to one or more of your flex events. Would you like to start the meeting(s) ${magnitude} minutes sooner?`
        : `You've added ${magnitude} minutes prior to one or more of your flex events. Would you like to start the meeting(s) ${magnitude} minutes later?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      footer: `${affectedFlexEvents.length} future flex event(s) will be adjusted.`,
    });

    console.log('[Schedule Debug] handleScheduleTimeShift prompt result', {
      isConfirmed: result.isConfirmed,
      affectedCount: affectedFlexEvents.length,
      shiftMinutes,
    });

    if (!result.isConfirmed) {
      return;
    }

    const eventsPayload = affectedFlexEvents.map((flexEvent) => {
      const { FlexDateStart, FlexTimeStart, FlexDateEnd, FlexTimeEnd } = flexEvent;
      const originalStart = dayjs(`${FlexDateStart} ${FlexTimeStart}`);
      const originalEnd = dayjs(`${FlexDateEnd} ${FlexTimeEnd}`);
      const newStart = originalStart.add(shiftMinutes, 'minutes');
      const newEnd = originalEnd.add(shiftMinutes, 'minutes');

      return {
        pk_FlexEvent: flexEvent.pk_FlexEvent,
        EventName: flexEvent.EventName || flexEvent.FlexEventName,
        FlexEventName: flexEvent.FlexEventName || flexEvent.EventName,
        FlexTimeStart: newStart.format('HH:mm:ss'),
        FlexTimeEnd: newEnd.format('HH:mm:ss'),
        EndDateTime: newEnd.toISOString(),
        evaluatorsToAdd: [],
        evaluatorsToDelete: [],
      };
    });

    await new Promise((resolve) => {
      updateFlexEvents(eventsPayload, (err) => {
        console.log('[Schedule Debug] updateFlexEvents callback', {
          hasError: !!err,
          err,
          payloadCount: eventsPayload.length,
        });
        resolve(!err);
      });
    });
  };

  const addRowCustomEvent = (data, resolve, reject, callback) => {
    setIsGeneratingSchedule(true);
    setIsSubmitting(true);
    const pk_Timeslot = data.pk_Timeslot;
    delete data.pk_Timeslot;
    const params = { timeslot: { ...data } };

    getTokenSilently()
      .then((token) => {
        putData(
          'department/season/interviewDate/timeslot',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Timeslot: pk_Timeslot,
          },
          params,
          formatBearerToken(token),
        )
          .then((res) => {
            if (callback) {
              callback();
            }
            if (resolve) {
              resolve(true);
            } else {
              setIsSubmitting(false);
              setIsGeneratingSchedule(false);
              fetchSchedule(token);
            }
          })
          .catch((err) => {
            if (callback) {
              callback(err);
            }
            if (reject) {
              reject(err);
            } else {
              setIsSubmitting(false);
              setIsGeneratingSchedule(false);
            }
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const setColumnSplit = (data, callback) => {
    updateEvaluators(data, null, null, callback);
  };

  const setCellSplit = (data, callback) => {
    const { TotalNumberOfSplits, pk_ScheduleAssignment, pk_Timeslot } = data;
    setIsSubmitting(true);
    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/season/interviewDate/splitblock',
          {
            pk_Department: dContext.department.pk_Department,
          },
          {
            TotalNumberOfSplits,
            pk_ScheduleAssignment,
            pk_Timeslot,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            setIsSubmitting(false);
            if (callback) {
              callback();
            }
            updateAllData();
          })
          .catch((err) => {
            setIsSubmitting(false);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const removeCellSplits = (data, callback) => {
    const { pk_Timeslot, pk_ScheduleAssignment } = data;
    setIsSubmitting(true);
    getTokenSilently()
      .then((token) => {
        deleteData(
          'department/season/interviewDate/splitblock',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Timeslot,
            pk_ScheduleAssignment,
          },
          null,
          formatBearerToken(token),
        )
          .then((res) => {
            setIsSubmitting(false);
            updateAllData();
            if (callback) {
              callback();
            }
          })
          .catch((err) => {
            setIsSubmitting(false);
            if (callback) {
              callback();
            }
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const getTimeSlotHeaderPopoverVisibility = (visibility = {}) => ({
    self: false,
    showAddTimeSlotPopover: false,
    showConfirmModal: false,
    showRoomNumberPopover: false,
    showHeaderPopOver: false,
    showFocusPopover: false,
    ...visibility,
  });

  const getTimeSlotPopoverVisibility = (pk_Timeslot) => {
    const isActive = activeTimeSlotPopover.pk_Timeslot != null && `${activeTimeSlotPopover.pk_Timeslot}` === `${pk_Timeslot}`;

    return {
      self: isActive,
      showAddTimeSlotPopover: isActive && activeTimeSlotPopover.childKey === 'showAddTimeSlotPopover',
      showAddCustomPopover: isActive && activeTimeSlotPopover.childKey === 'showAddCustomPopover',
      showCustomDurationPopover: isActive && activeTimeSlotPopover.childKey === 'showCustomDurationPopover',
    };
  };

  const logSchedulePopoverDebug = (event, payload = {}) => {
    console.log(
      JSON.stringify({
        scope: 'SchedulePopover',
        source: 'Schedule',
        event,
        ...payload,
      }),
    );
  };

  const closeTimeSlotHeaderPopoverChildren = (visibility = {}) => {
    const nextVisibility = getTimeSlotHeaderPopoverVisibility(visibility);
    nextVisibility.showAddTimeSlotPopover = false;
    nextVisibility.showConfirmModal = false;
    nextVisibility.showRoomNumberPopover = false;
    return nextVisibility;
  };

  const setTimeSlotHeaderPopoverChildVisibility = (childKey, isOpen) => {
    setShowHeaderPopOver((prevState) => {
      const nextState = { ...prevState };
      const nextVisibility = closeTimeSlotHeaderPopoverChildren(nextState.timeSlotHeader || {});

      if (isOpen && childKey) {
        nextVisibility[childKey] = true;
      }

      nextState.timeSlotHeader = nextVisibility;
      return nextState;
    });
  };

  const closeTimeSlotHeaderPopoverStack = () => {
    setShowHeaderPopOver((prevState) => {
      const nextState = { ...prevState };
      const nextVisibility = closeTimeSlotHeaderPopoverChildren(nextState.timeSlotHeader || {});

      nextVisibility.self = false;
      nextVisibility.showHeaderPopOver = false;
      nextVisibility.showFocusPopover = false;

      nextState.timeSlotHeader = nextVisibility;
      return nextState;
    });
  };

  const setTimeSlotPopoverChildVisibility = (pk_Timeslot, childKey, isOpen) => {
    if (pk_Timeslot == null) {
      return;
    }

    setActiveTimeSlotPopover({
      pk_Timeslot,
      childKey: isOpen && childKey ? childKey : null,
    });
  };

  const closeTimeSlotPopoverStack = (pk_Timeslot) => {
    if (pk_Timeslot == null) {
      return;
    }

    // logSchedulePopoverDebug('closeTimeSlotPopoverStack', {
    //   pk_Timeslot,
    // });

    setActiveTimeSlotPopover((prevState) => {
      if (prevState.pk_Timeslot == null || `${prevState.pk_Timeslot}` !== `${pk_Timeslot}`) {
        return prevState;
      }

      return { pk_Timeslot: null, childKey: null };
    });
  };

  const hideHeaderPopoversExcept = (key = '') => {
    setShowHeaderPopOver((prevState) => {
      const nextState = { ...prevState };

      if (key && nextState[key] == null) {
        nextState[key] = {};
      }

      Object.keys(nextState).forEach((headerKey) => {
        if (headerKey === key) {
          const visibility =
            headerKey === 'timeSlotHeader'
              ? closeTimeSlotHeaderPopoverChildren(nextState[headerKey] || {})
              : { ...(nextState[headerKey] || {}) };
          visibility.self = true;
          visibility.showFocusPopover = false;
          nextState[headerKey] = visibility;
          return;
        }

        const visibility = { ...(nextState[headerKey] || {}) };
        Object.keys(visibility).forEach((visibilityKey) => {
          visibility[visibilityKey] = false;
        });

        nextState[headerKey] =
          headerKey === 'timeSlotHeader'
            ? {
                ...closeTimeSlotHeaderPopoverChildren(visibility),
                self: false,
                showHeaderPopOver: false,
                showFocusPopover: false,
              }
            : visibility;
      });

      return nextState;
    });
  };

  const hideTimeSlotPopoversExcept = (pk_Timeslot = '') => {
    if (pk_Timeslot == null) {
      return;
    }

    // logSchedulePopoverDebug('hideTimeSlotPopoversExcept', {
    //   pk_Timeslot,
    // });

    if (pk_Timeslot === '') {
      setActiveTimeSlotPopover({ pk_Timeslot: null, childKey: null });
      return;
    }

    setActiveTimeSlotPopover({
      pk_Timeslot,
      childKey: null,
    });
  };

  const generateScheduleForEntireTable = () => {
    const clearTable =
      generatedScheduleData && generatedScheduleData.clearTable
        ? generatedScheduleData.clearTable
        : columnsToIgnore.length > 0
        ? false
        : true;
    const headersToFillUp = generatedScheduleData ? generatedScheduleData.headersToFillUp : undefined;
    const functionToCall = generateMode === 'intelligent' ? generateScheduleColumn : generateSchedule2;
    const newScheduleBody = functionToCall(JSON.parse(JSON.stringify(scheduleData)), candidates, {
      interviewLimit,
      previousGeneratedScheduleData: generatedScheduleData || scheduleData,
      allowInterviewLimit,
      columnsToIgnore,
      clearTable,
      mode: generateMode,
      headersToFillUp: generateMode === 'intelligent' ? Object.keys(columnTracker) : headersToFillUp,
      columnAvailabilityTracker,
      scheduleBlockTracker,
      sortOnce,
    });

    const newScheduleData = JSON.parse(JSON.stringify(scheduleData));
    newScheduleData.body =
      generatedScheduleData && generatedScheduleData.headersToFillUp ? newScheduleBody : newScheduleBody.newBody;
    newScheduleData.clearTable = clearTable;
    newScheduleData.headersToFillUp = headersToFillUp;
    newScheduleData.interviewCountTracker = newScheduleBody.interviewCountTracker;
    newScheduleData.candidatesWithMissingInterviews = newScheduleBody.candidatesWithMissingInterviews;

    if (newScheduleBody.generateMessage) {
      // toast.info(newScheduleBody.generateMessage);
    }

    setPendingCandidates(newScheduleBody.pendingItems);
    setGeneratedScheduleData(newScheduleData);
    initializeTrackers(newScheduleData);
  };

  const generateScheduleForColumn = (pk_ScheduleAssignments, clearTable = false) => {
    setGenerateMode('intelligent');
    const newScheduleBody = generateSchedule2(JSON.parse(JSON.stringify(scheduleData)), candidates, {
      interviewLimit,
      previousGeneratedScheduleData: scheduleData,
      allowInterviewLimit,
      columnsToIgnore,
      clearTable,
      mode: generateMode,
      headersToFillUp: pk_ScheduleAssignments,
      columnAvailabilityTracker,
      scheduleBlockTracker,
      sortOnce,
    });

    if (!newScheduleBody) {
      console.error('generateSchedule2 returned null');
      return;
    }

    const newScheduleData = JSON.parse(JSON.stringify(scheduleData));
    newScheduleData.body = newScheduleBody.newBody;
    newScheduleData.headersToFillUp = pk_ScheduleAssignments;
    newScheduleData.clearTable = clearTable;
    newScheduleData.interviewCountTracker = newScheduleBody.interviewCountTracker;
    newScheduleData.candidatesWithMissingInterviews = newScheduleBody.candidatesWithMissingInterviews;

    if (newScheduleBody.generateMessage) {
      // toast.info(newScheduleBody.generateMessage);
    }

    setPendingCandidates(newScheduleBody.pendingItems);
    setGeneratedScheduleData(newScheduleData);
    setShowGenerateDataPanel(true);
    initializeTrackers(newScheduleData);
  };

  const clearSpecificCandidateFromSchedule = (candidatesToClear) => {
    const newScheduleData = clearScheduleOfCandidates({ candidatesToClear, scheduleData });

    submitGeneratedSchedule(newScheduleData.body);
  };

  const processStyle = (data) => {
    const { cell = {}, row, rowIndex, colIndex } = data;
    const isEndRow = row.pk_Timeslot === 'END';
    const style = {
      cursor: 'pointer',
      textAlign: 'center',
      verticalAlign: 'middle',
      padding: 3,
      backgroundColor: rowIndex % 2 == 0 ? 'var(--rr-surface)' : 'var(--rr-surface-sunken)',
    };

    const { metaData = {}, headers = [] } = scheduleData || {};
    const { pk_ScheduleAssignment } = cell;

    if (pk_ScheduleAssignment != null && columnsToIgnore.includes(pk_ScheduleAssignment.toString())) {
      style.backgroundColor = `#858482`;
    }

    if (colIndex == 0) {
      style.fontWeight = 'bold';
      style.position = 'sticky';
      style.textAlign = 'center';
      style.left = -2;
      style.verticalAlign = 'middle';
      style.zIndex = 1;

      if (
        (row.CustomDurationInMinutes != null && row.CustomDurationInMinutes != metaData.StandardDurationInMinutes) ||
        (row.CustomPassingDurationInMinutes != null &&
          row.CustomPassingDurationInMinutes != metaData.StandardPassingDurationInMinutes)
      ) {
        style.backgroundColor = '#ffec45';
      }
    } else {
      // style.padding = '2px';
    }

    if (
      generatedScheduleData == null &&
      cellHoveredOn != null &&
      !isEndRow &&
      (rowIndex == cellHoveredOn.rowIndex || colIndex == cellHoveredOn.columnIndex) &&
      cellHoveredOn.rowIndex < scheduleData.body.length - 1
    ) {
      if (rowIndex % 2 == 0) {
        style.backgroundColor = '#e8f8ff';
      } else {
        style.backgroundColor = '#caecfa';
      }
    } else {
      // if (!meetingTitle) {
      //   style.backgroundColor = backgroundColor;
      // }
    }

    const { slot, slotEnd } = row;
    const rowStartTime = dayjs(row.slot).format('MMM DD, YYYY hh:mm A');
    const rowEndTime = dayjs(row.slotEnd)
      .subtract(5, 'seconds')
      .format('MMM DD, YYYY hh:mm A');
    const cTime = dayjs.tz(undefined, metaData.TimeZone).format('MMM DD, YYYY hh:mm A');

    const isCurrentTime = isTimeRangeOverlap([slot, rowEndTime], [cTime, cTime]);

    if (isCurrentTime) {
      style.borderTop = '3px solid green';
      style.borderBottom = '3px solid green';

      if (colIndex == 0) {
        style.borderLeft = '3px solid green';
      } else if (colIndex == headers.length && !hasFlexColumn) {
        style.borderRight = '3px solid green';
      }
    }

    return style;
  };

  const processFlexCellStyle = (data) => {
    const { cell, row, rowIndex, colIndex } = data;
    const style = {
      cursor: isFetching || isSubmitting ? 'not-allowed' : 'pointer',
      textAlign: 'center',
      verticalAlign: 'middle',
      padding: 3,
      backgroundColor: '#afafaf',
    };
    const { headers = [] } = scheduleData || {};
    // const rowStartTime = parseInt(dayjs(row.slot).valueOf());
    // const rowEndTime = parseInt(dayjs(row.slotEnd).valueOf());
    // const cTime = parseInt(dayjs().valueOf());
    // const isCurrentTime = parseInt(cTime) >= parseInt(rowStartTime) && parseInt(cTime) <= parseInt(rowEndTime);
    const { metaData = {} } = scheduleData || {};
    const rowStartTime = dayjs(row.slot)
      .add(1, 'minutes')
      .format('MMM DD, YYYY hh:mm A');
    const rowEndTime = dayjs(row.slotEnd).format('MMM DD, YYYY hh:mm A');
    const cTime = dayjs.tz(undefined, metaData.TimeZone).format('MMM DD, YYYY hh:mm A');

    const { slot, slotEnd } = row;

    const isCurrentTime = isTimeRangeOverlap([slot, slotEnd], [cTime, cTime]); // cTime.isSameOrAfter(rowStartTime) && cTime.isSameOrBefore(rowEndTime);

    if (isCurrentTime) {
      style.borderTop = '3px solid green';
      style.borderBottom = '3px solid green';
      style.borderRight = '3px solid green';
    }
    return style;
  };

  const headerProcessStyle = (column, colIndex) => {
    // let style = {
    //   alignItems: 'stretch',
    //   color: 'black',
    //   cursor: 'pointer',
    //   maxWidth: 280,
    //   minWidth: colIndex > 0 ? 210 : 90, // comment out for squeezy demo
    //   // width: colIndex > 0 ? 180 : 90,
    //   position: 'sticky',
    //   textAlign: 'center',
    //   top: -5,
    //   verticalAlign: 'middle',
    //   zIndex: 2,
    //   padding: 0,
    //   // position: 'relative',
    // };

    // TODO, width doesn't seem to add up. Maybe needs to handle if bold or not.
    let textLength = (column.text ? getTextWidth({ text: column.text, fontWeight: 'bold' }) : 0) + 40;
    let labelLength = column.label ? getTextWidth({ text: column.label, fontsize: `10px` }) : 0;

    const textHeight = getTextHeight({
      text: column.text || '',
      maxWidth: 280,
      showDebugger: column.dataField == '4271' && false,
    });
    const labelHeight = getTextHeight({ text: column.label || '', fontsize: `10px`, maxWidth: 230 });

    const widthToUse = textLength + 40;

    const heightToUse = getTextHeight({ text: column.text, fontsize: 14 });

    if (column.dataField === '4628') {
      // console.log('column: ', column);
      // console.log('textWidth: ', textLength);
      // console.log('textHeight: ', textHeight);
      // console.log('labelLength: ', labelLength);
      // console.log('labelHeight: ', labelHeight);
      // console.log('widthToUse: ', widthToUse);
    }

    let style = {
      maxWidth: 280,
      minWidth: colIndex > 0 ? (widthToUse > 280 ? 280 : widthToUse < 180 ? 180 : widthToUse) : 70,
      height: textHeight + labelHeight + 25,
      // width: widthToUse > 280 ? 280 : widthToUse < 180 ? 180 : widthToUse,
      // height: 'auto',
      // height: 35 * ((textLength + labelLength * 0.4) / 30),
      position: 'relative',
      position: 'sticky',
      cursor: 'pointer',
      top: 0,
    };
    const { dataField } = column;

    // return {
    //   maxWidth: 280,
    //   minWidth: colIndex > 0 ? 210 : 90,
    //   height: '100%',
    //   position: 'relative',
    // };
    if (headerHoveredOn !== null && headerHoveredOn.columnIndex === colIndex) {
      style.backgroundColor = '#deb887';
      style.color = 'white';
    } else if (
      generatedScheduleData == null &&
      cellHoveredOn != null &&
      colIndex == cellHoveredOn.columnIndex &&
      cellHoveredOn.rowIndex < scheduleData.body.length - 1
    ) {
      style.backgroundColor = '#caecfa';
    } else if (columnsToIgnore.includes(dataField)) {
      style.backgroundColor = '#858482';
    } else {
      style.backgroundColor = 'var(--rr-surface)';
    }

    if (colIndex == 0) {
      style.maxWidth = 80;
      style.minWidth = 80;
      style.width = 80;
      style.left = 0;
      style.zIndex = 4;
    } else {
      // style.paddingLeft = 0;
      // style.paddingBottom = 0;
      // style.paddingTop = 0;
      // style.paddingRight = 0;
    }
    return style;
  };

  const headerFormatter = (column, colIndex) => {
    const { rawHeader, evaluatorNames, hiddenParent } = column;
    const { RoomFocuses = [], VirtualRoomURL } = rawHeader || {};
    const { VirtualMeetingMode } = dContext.department;
    const { StandardPassingDurationInMinutes } = scheduleData.metaData || {};

    if (colIndex == 0) {
      const visibility = showHeaderPopOver['timeSlotHeader'] || {};
      return (
        <div style={{ ...style.headerStyle({ colIndex }), width: 80, alignItems: 'center', paddingLeft: 10 }}>
          {column.text}{' '}
          {StandardPassingDurationInMinutes == 0 && hasPassingPeriodNotifications() ? (
            <>
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                style={{ marginLeft: 5 }}
                id={`passing_period_warning_time_header`}
              />
              <UncontrolledTooltip target={`passing_period_warning_time_header`}>
                Warning: No passing period - This may affect some of your notifications.
              </UncontrolledTooltip>
            </>
          ) : null}
          <FontAwesomeIcon icon={visibility.self ? faChevronLeft : faChevronRight} style={{ marginLeft: 10 }} />
        </div>
      );
    }

    if (column.text === 'Flex Events') {
      return (
        <div style={style.headerStyle(colIndex)}>
          <div
            style={{ ...style.simpleRow, alignItems: 'center', justifyContent: 'center' }}
            onClick={async (e) => {
              if (generatedScheduleData) {
                e.stopPropagation();
                return;
              }
              e.stopPropagation();
              setShowFlexEventDetailModal(true);
            }}
          >
            <div style={{ marginRight: 10 }}> {column.text || ''}</div>
            {countFlexEvents() <= 0 ? (
              <FontAwesomeIcon
                icon={faTimes}
                style={style.clickableIcon}
                onClick={async (e) => {
                  if (dateIsInThePast && !willEditThePast) {
                    const continueProcess = await fireConfirmationForEditingPastSchedule();
                    if (!continueProcess) {
                      return;
                    }
                  }
                  e.stopPropagation();
                  setHasFlexColumn(false);
                }}
              />
            ) : null}
          </div>
        </div>
      );
    } else {
      const key = column.dataField.toString();
      const candidateCount = columnTracker[key] ? columnTracker[key].length : 0;
      // const headerLockID = `header_ignoreBox_${rawHeader.pk_ScheduleAssignment}${
      //   colIndex == 1 ? `_infoTooltipTarget` : ''
      // }`;
      const isColumnToIgnore = columnsToIgnore.includes(column.dataField);

      // if (column.dataField == '4271') {
      return (
        <div
          style={{
            position: 'absolute',
            paddingRight: 10,
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',

            minHeight: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between', // Center text horizontally
            alignItems: 'flex-start',
          }}
        >
          <div
            style={{
              width: 30,
              backgroundColor: isColumnToIgnore ? '#dc3545' : 'var(--rr-primary-strong)',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              display: 'flex',
              color: isColumnToIgnore ? 'white' : 'var(--rr-on-primary)',
              cursor: 'pointer',
            }}
            id={`lock_unlock_button_${rawHeader.pk_ScheduleAssignment}`}
            onClick={(e) => {
              e.stopPropagation();
              if (isColumnToIgnore) {
                const newColumnsToIgnore = columnsToIgnore.filter((c) => c !== column.dataField);
                setColumnsToIgnore(newColumnsToIgnore);
              } else {
                const newColumnsToIgnore = [...columnsToIgnore, column.dataField];
                setColumnsToIgnore(newColumnsToIgnore);
              }
            }}
          >
            <FontAwesomeIcon
              id={`lock_unlock_button_icon_${rawHeader.pk_ScheduleAssignment}`}
              style={{ fontSize: 15 }}
              icon={columnsToIgnore.includes(column.dataField) ? faLock : faLockOpen}
            />
          </div>
          <div
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              width: '100%',
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              paddingLeft: 5,
            }}
            id={`header_text_${rawHeader.pk_ScheduleAssignment}`}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                flex: column.label ? 1 : 2, // Take all space if no label
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {`${column.text} ${candidateCount > 0 ? `(${candidateCount})` : ''} `}{' '}
              </div>
            </div>
            {column.label && (
              <div
                style={{
                  fontSize: 10,
                  minHeight: 15,
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flex: 1,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {column.label}
                </div>
              </div>
            )}

            {generatedScheduleData || showGenerateDataPanel || hiddenParent ? null : renderHeaderPopOver(column)}
          </div>
          {VirtualMeetingMode === 'ExternalColumn' && !VirtualRoomURL ? (
            <div
              style={{ ...style.simpleColumn, width: 15, color: 'red', paddingLeft: 10, marginBottom: 15 }}
              id={`missing_column_url_${rawHeader.pk_ScheduleAssignment}`}
            >
              <FontAwesomeIcon icon={faExclamationCircle} />
            </div>
          ) : null}
          {rawHeader && rawHeader.pk_ScheduleAssignment != null ? (
            <UncontrolledTooltip target={`header_text_${rawHeader.pk_ScheduleAssignment}`}>
              {RoomFocuses && RoomFocuses.length > 0 ? 'Focus: \n' : ''}
              {RoomFocuses && RoomFocuses.length > 0
                ? RoomFocuses.map((f, i) => {
                    return (
                      <div key={`${f.Name}_${i}`} style={{ width: 120 }}>
                        {f.Name}
                      </div>
                    );
                  })
                : 'No Focuses'}
            </UncontrolledTooltip>
          ) : null}

          {VirtualMeetingMode === 'ExternalColumn' && !VirtualRoomURL ? (
            <UncontrolledTooltip target={`missing_column_url_${rawHeader.pk_ScheduleAssignment}`}>
              Virtual Meeting Mode is set to "Coordinator Managed Breakout Rooms (Multiple URL)" but this room is
              missing it's own Meeting URL!
            </UncontrolledTooltip>
          ) : null}
          {/* {evaluatorNames && evaluatorNames.length > 1 ? (
            <UncontrolledTooltip
              target={`header_text_${rawHeader.pk_ScheduleAssignment}`}
              modifiers={popoverModifiers}
              placement="top"
            >
              {'Evaluators: \n'}
              {evaluatorNames && evaluatorNames.length > 0
                ? evaluatorNames.map((evaluatorName) => {
                    return <div style={{ width: 120 }}>{evaluatorName}</div>;
                  })
                : 'No Evaluators'}
            </UncontrolledTooltip>
          ) : null} */}
        </div>
      );
      // }
    }
  };

  const cellFormatter = (cell, data) => {
    const {
      row,
      rowIndex,
      VirtualRoomType,
      CustomPassingDurationInMinutes,
      pk_Timeslot,
      slot,
      slotEnd,
      endTimesText,
      column,
      hiddenParent,
    } = data;

    const { StandardPassingDurationInMinutes } = scheduleData.metaData || {};
    const { isTime } = column;

    // For Time Slot column, just render entire cell( which is a string)
    if (isTime) {
      const isMainRoomAndNoLink =
        data.CustomMeetingTitle && VirtualRoomType === 'AllDay' && !scheduleData.metaData.MainRoomURL;
      const isCustomAndNoLink = data.CustomMeetingTitle && VirtualRoomType === 'Custom' && !data.CustomMeetingUrl;
      const urlIssue = VirtualMeetingMode !== 'Disabled' && (isMainRoomAndNoLink || isCustomAndNoLink);

      return (
        <div
          style={{ width: 130 }}
          id={`${pk_Timeslot !== 'END' ? 'capsule_time_' : ''}${pk_Timeslot}${hiddenParent ? '_hidden' : ''}`}
        >
          {dayjs(slot).format('hh:mm A')}
          {generatedScheduleData || pk_Timeslot === 'END' || hiddenParent ? null : renderTimeSlotPopover(data)}
          {((!StandardPassingDurationInMinutes && !CustomPassingDurationInMinutes) ||
            CustomPassingDurationInMinutes == 0) &&
          !hiddenParent &&
          hasPassingPeriodNotifications() ? (
            <>
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                style={{ color: 'black', marginLeft: 5 }}
                id={`passing_period_warning_${pk_Timeslot}`}
              />
              <UncontrolledTooltip target={`passing_period_warning_${pk_Timeslot}`}>
                Warning: No passing period - This may affect some of your notifications.
              </UncontrolledTooltip>
            </>
          ) : null}
          {urlIssue && !hiddenParent ? (
            <>
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                style={{ color: 'red', marginLeft: 5 }}
                id={`url_warning_${pk_Timeslot}`}
              />
              <UncontrolledTooltip target={`url_warning_${pk_Timeslot}`}>
                Warning: {isCustomAndNoLink ? `Custom Event URL is missing!` : `Main Room URL is missing!`}
              </UncontrolledTooltip>
            </>
          ) : null}
          <br />
          {/* {row.pk_Timeslot} */}
        </div>
      );
    }

    if (pk_Timeslot === 'END') {
      return (
        <div>
          <b>{endTimesText}</b>
        </div>
      );
    }

    if (!cell) {
      return;
    }
    const {
      ScheduleBlockEntries,
      isFlexEvent,
      isUnavailable,
      cellState,
      unavailableEvaluators,
      availableEvaluators,
      CustomMeetingTitle,
      flexEvents = [],
      pk_ScheduleAssignment,
    } = cell;

    const { metaData } = scheduleData;

    let cellHasCandidates = false;
    const momentStart = dayjs(slot);
    const momentEnd = dayjs(slotEnd);
    const now = dayjs(`${momentStart.format('MMM DD, YYYY')} ${dayjs().format('hh:mm A')}`);

    ScheduleBlockEntries.forEach((block) => {
      if (block.Candidates && block.Candidates.length > 0) {
        cellHasCandidates = true;
      }
    });

    let cellContent = '';
    const pendingKeysInThisCell =
      Object.keys(pendingCandidates).filter((key) => {
        return key.indexOf(`${pk_Timeslot}_${cell.pk_ScheduleAssignment}_`) >= 0;
      }) || [];

    const pendingItemsInThisCell = pendingKeysInThisCell.map((key) => {
      return pendingCandidates[key];
    });

    const renderContent = (candidateList = [], scheduleBlock, scheduleBlockCount) => {
      const candidatesToRender = [];
      const { flexEventEvaluators = [], FlexEvents = [] } = scheduleBlock;
      const candidatesInFlexEvent = [];

      // Check if this interview exceeds 35 minutes
      const blockStart = dayjs(scheduleBlock.slot);
      const blockEnd = dayjs(scheduleBlock.slotEnd);
      const blockDurationInMinutes = blockEnd.diff(blockStart, 'minutes');
      const isLongInterview = enforce35MinuteLimit && blockDurationInMinutes > 35;

      let flexEventsForCell = 0;
      FlexEvents.forEach((flexEvent) => {
        const { AttendingUsers = [], AttendingCandidates = [] } = flexEvent;
        const flexEventHasEvaluatorForColumn = AttendingUsers.filter((u) => {
          return flexEventEvaluators.find((e) => {
            return e.pk_User == u.pk_User;
          });
        });

        if (flexEventHasEvaluatorForColumn.length > 0) {
          flexEventsForCell++;
        }

        AttendingCandidates.forEach((c) => {
          candidatesInFlexEvent.push(c.pk_Candidate);
        });
      });

      const columnEvaluators = [...availableEvaluators, ...unavailableEvaluators].filter((evaluator, index, list) => {
        if (!evaluator || evaluator.pk_User == null) {
          return false;
        }

        return index === list.findIndex((columnEvaluator) => columnEvaluator?.pk_User === evaluator.pk_User);
      });
      const totalColumnEvaluators = columnEvaluators.length;
      const getFlexEventAttendanceMeta = (flexEvent) => {
        const eventName = getFlexEventDisplayName(flexEvent);
        const attendingUsers = flexEvent?.AttendingUsers || [];
        const matchingEvaluators = columnEvaluators.filter((columnEvaluator) => {
          return attendingUsers.find((attendingUser) => attendingUser.pk_User === columnEvaluator.pk_User);
        });
        const matchingEvaluatorCount = matchingEvaluators.length;
        const shouldDisplay = totalColumnEvaluators > 0 && matchingEvaluatorCount > 0;

        if (totalColumnEvaluators <= 0) {
          return {
            eventName,
            matchingEvaluatorCount,
            matchingEvaluators,
            shouldDisplay: false,
            label: eventName,
          };
        }

        return {
          eventName,
          matchingEvaluatorCount,
          matchingEvaluators,
          shouldDisplay,
          label: `(${matchingEvaluatorCount}/${totalColumnEvaluators}) ${eventName}`,
        };
      };
      const formatEvaluatorNamesForTooltip = (evaluators = []) => {
        const names = evaluators
          .map((evaluator) => {
            if (!evaluator) {
              return '';
            }

            const firstName = evaluator.UserFirst || evaluator.EvaluatorFirstName || evaluator.FirstName || '';
            const lastName = evaluator.UserLast || evaluator.EvaluatorLastName || evaluator.LastName || '';
            return `${firstName} ${lastName}`.trim();
          })
          .filter((name) => name.length > 0);

        if (names.length <= 1) {
          return names[0] || '';
        }

        if (names.length === 2) {
          return `${names[0]} and ${names[1]}`;
        }

        return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`;
      };
      const visibleFlexEventDetails = sortFlexEventsForDisplay(
        FlexEvents.filter((flexEvent) => {
          const eventName = getFlexEventDisplayName(flexEvent);

          return eventName && eventName.toLowerCase() !== 'unavailable';
        }),
      )
        .map((flexEvent) => {
          return { flexEvent, ...getFlexEventAttendanceMeta(flexEvent) };
        })
        .filter((detail) => detail.shouldDisplay);
      const visibleFlexEvents = visibleFlexEventDetails.map((detail) => detail.flexEvent);

      const pendingItemKey = `${pk_Timeslot}_${pk_ScheduleAssignment}${
        scheduleBlock ? `_${scheduleBlock.SortOrder}` : ''
      }`;

      const isPendingItem = pendingCandidates[pendingItemKey] != null; // TO DO: Move to per-scheduleBlock
      const shouldRenderFlexEventLabels = !isPendingItem && candidateList.length === 0 && visibleFlexEventDetails.length > 0;
      const candidateAttendanceObject = {};
      let attendanceObject = {};

      if (attendanceData) {
        if (attendanceData.ScheduleBlocks && attendanceData.ScheduleBlocks[scheduleBlock.pk_ScheduleBlock]) {
          attendanceObject = attendanceData.ScheduleBlocks[scheduleBlock.pk_ScheduleBlock];
        } else if (attendanceData.TimeSlots && attendanceData.TimeSlots[pk_Timeslot]) {
          attendanceObject = attendanceData.TimeSlots[pk_Timeslot];
        }
      }

      if (attendanceObject.Candidates) {
        attendanceObject.Candidates.forEach((c) => {
          candidateAttendanceObject[c.fk_Candidate] = c;
        });
      }

      let evaluatorsPresent = 0;

      if (attendanceObject.Evaluators) {
        const { availableEvaluators = [] } = cell;

        attendanceObject.Evaluators.forEach((e) => {
          // To fix Admin appearing in Cell
          const evaluatorIsInColumn = availableEvaluators.find((ae) => {
            return ae.pk_User == e.fk_User;
          });

          if (evaluatorIsInColumn) {
            if (e.EnableActivelyAttending) {
              evaluatorsPresent++;
            }
          }
        });
      }

      const scheduleBlockTrackerData = scheduleBlockTracker[`ROW_${pk_Timeslot}`];

      let blockHeight = calculateScheduleBlockHeight(
        scheduleBlockTrackerData ? scheduleBlockTrackerData : 1,
        scheduleBlockCount,
      );
      candidateList.forEach((candidate, i) => {
        if (candidate == null) {
          return;
        }

        const candidateIsInFlexEvent = candidatesInFlexEvent.indexOf(candidate.pk_Candidate) >= 0;
        const candidateIsPresent =
          attendanceObject.Candidates && attendanceObject.Candidates.length
            ? attendanceObject.Candidates[0].IsActive && attendanceObject.Candidates[0].EnableActivelyAttending
            : 0;

        const key = `${pk_Timeslot}_${pk_ScheduleAssignment}${scheduleBlock ? `_${scheduleBlock.SortOrder}` : ''}`;
        const backgroundColor =
          candidates && Object.keys(candidates).length > 0 && candidates[candidate.pk_Candidate]
            ? candidates[candidate.pk_Candidate].color
            : 'black';

        const color = backgroundColor ? (tinycolor(backgroundColor).isLight() ? 'black' : 'white') : 'white';
        const border =
          isPendingItem && candidate.pk_Candidate != null
            ? '5px solid #a1e3a5 '
            : `5px solid ${backgroundColor || '#d4d4d4'}`;
        const candidateInterviewCount =
          generatedScheduleData &&
          generatedScheduleData.interviewCountTracker &&
          generatedScheduleData.interviewCountTracker[candidate.pk_Candidate]
            ? generatedScheduleData.interviewCountTracker[candidate.pk_Candidate]
            : 0;

        const flexEventEvaluatorWarningID = `cell_flexEvent_warning_${pk_Timeslot}_${cell.pk_ScheduleAssignment}_${
          scheduleBlock ? `_${scheduleBlock.SortOrder}` : ''
        }`;
        const infoInterviewCountID = `info_${key}_interviewCounter`;
        const infoEvaluatorAttendanceID = `info_${key}_evaluatorAttendance`;
        const infoCandidateAttendanceID = `info_${key}_candidateAttendance`;
        const problematicCandidateID = `problematic_candidate_${pk_Timeslot}_${pk_ScheduleAssignment}_${candidate.pk_Candidate}`;
        const flexEventCandidateWarningID = `cell_flexEvent_candidate_warning_${pk_Timeslot}_${
          cell.pk_ScheduleAssignment
        }_${scheduleBlock ? `_${scheduleBlock.SortOrder}` : ''}`;
        const longInterviewWarningID = `long_interview_warning_${pk_Timeslot}_${pk_ScheduleAssignment}_${scheduleBlock.SortOrder}`;

        const capsuleID = `capsule_${pk_ScheduleAssignment}_${pk_Timeslot}_${scheduleBlock.SortOrder}`;
        const capsuleLabelID = `capsule_${pk_ScheduleAssignment}_${pk_Timeslot}_${scheduleBlock.SortOrder}_label`;
        const capsuleLabelInnerID = `capsule_${pk_ScheduleAssignment}_${pk_Timeslot}_${scheduleBlock.SortOrder}_label_inner`;

        candidatesToRender.push(
          <>
            <div
              id={capsuleID}
              key={`${pk_Timeslot}_${pk_ScheduleAssignment}${scheduleBlock ? `_${scheduleBlock.SortOrder}` : ''}${
                hiddenParent ? '_hidden' : ''
              }`}
              disabled={hiddenParent}
              style={{
                ...style.candidateLabel,
                color,
                backgroundColor: backgroundColor || '#d4d4d4',
                border,
                ...themedSlot(backgroundColor || SLOT_GRAY, color, border),
                marginBottom: candidateList.length > 0 && i < candidateList.length - 1 ? 5 : 0,
                justifyContent: 'center',
                alignItems: 'center',
                height: blockHeight,
              }}
              onClick={async (e) => {
                if (
                  scheduleBlock &&
                  /*backgroundColor &&*/ (!isEmbedded || allowScheduleInteraction) &&
                  !isPendingItem
                ) {
                  setSelectedScheduleBlock(scheduleBlock);
                } else {
                  e.stopPropagation();
                }
              }}
            >
              {' '}
              {evaluatorsPresent ? (
                <div style={{ ...style.simpleColumn, alignItems: 'center', justifyContent: 'center', minWidth: 10 }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      position: 'relative',
                    }}
                  >
                    <div
                      id={infoEvaluatorAttendanceID}
                      // icon={faDotCircle}
                      style={{
                        border: '2px solid #f2f2f2',
                        borderRadius: 20,
                        color: '#f2f2f2',
                        backgroundColor: evaluatorsPresent > 0 ? '#298dff' : 'grey',
                        fontWeight: 'bold',
                        fontSize: 10,
                        marginRight: 2,
                        minWidth: 17,
                        minHeight: 17,
                        textAlign: 'center',
                      }}
                    >
                      {evaluatorsPresent ? evaluatorsPresent : ''}
                    </div>
                    <UncontrolledTooltip target={infoEvaluatorAttendanceID}>
                      {evaluatorsPresent} evaluator{evaluatorsPresent > 1 ? 's' : ''} present:
                      <br />
                      {attendanceObject.Evaluators
                        ? attendanceObject.Evaluators.map((evaluator) => {
                            const { EvaluatorFirstName, EvaluatorLastName, EnableActivelyAttending } = evaluator;

                            const evaluatorIsInColumn = availableEvaluators.find((ae) => {
                              return ae.pk_User == evaluator.fk_User;
                            });

                            if (evaluatorIsInColumn && EnableActivelyAttending) {
                              return (
                                <>
                                  {EvaluatorFirstName || ''} {EvaluatorLastName || ''}
                                  <br />
                                </>
                              );
                            }
                          })
                        : ''}
                    </UncontrolledTooltip>
                  </div>
                </div>
              ) : null}
              {candidateIsPresent ? (
                <div style={{ ...style.simpleColumn, alignItems: 'center', justifyContent: 'center', marginRight: 2 }}>
                  <FontAwesomeIcon
                    id={infoCandidateAttendanceID}
                    icon={faUserCircle}
                    style={{
                      color: candidateIsPresent ? '#35911f' : 'grey',
                      fontWeight: 'bold',
                      fontSize: 17,
                      border: '2px solid #f2f2f2',
                      borderRadius: 20,
                      backgroundColor: '#f2f2f2',
                    }}
                  />
                  {!hiddenParent ? (
                    <UncontrolledTooltip
                      target={infoCandidateAttendanceID}
                      style={{ color: candidateIsPresent ? '#4cd12b' : '#ff3d3d' }}
                    >
                      Candidate is present!
                    </UncontrolledTooltip>
                  ) : null}
                </div>
              ) : null}
              <div
                id={capsuleLabelID}
                style={{ ...style.simpleColumn, alignItems: 'center', justifyContent: 'center' }}
              >
                <div
                  id={capsuleLabelInnerID}
                  style={{ alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}
                >
                  {candidate.LastName || ''}
                  {candidate.FirstName ? `, ${candidate.FirstName}` : ''}
                </div>
              </div>
              {backgroundColor != 'black' ? null : (
                <div style={{ ...style.simpleColumn, alignItems: 'center', justifyContent: 'center' }}>
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    style={{ marginLeft: 5, color: '#ff3d3d' }}
                    id={problematicCandidateID}
                  />
                  {!hiddenParent && (
                    <UncontrolledTooltip target={problematicCandidateID}>
                      There was a candidate scheduled here. They are no longer in this session.
                    </UncontrolledTooltip>
                  )}
                </div>
              )}
              {candidateIsInFlexEvent ? (
                <div style={{ ...style.simpleColumn, alignItems: 'center', justifyContent: 'center' }}>
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    style={{ marginLeft: 5 }}
                    id={flexEventCandidateWarningID}
                  />
                  {!hiddenParent && (
                    <UncontrolledTooltip target={flexEventCandidateWarningID}>
                      Candidate is in a Flex Event at this time!
                    </UncontrolledTooltip>
                  )}
                </div>
              ) : null}
              {isLongInterview ? (
                <div style={{ ...style.simpleColumn, alignItems: 'center', justifyContent: 'center' }}>
                  <FontAwesomeIcon
                    icon={faClock}
                    style={{ marginLeft: 5, color: '#000000' }}
                    id={longInterviewWarningID}
                  />
                  {!hiddenParent && (
                    <UncontrolledTooltip target={longInterviewWarningID}>
                      This interview runs longer than 35 minutes and will terminate prior to the scheduled end time.
                    </UncontrolledTooltip>
                  )}
                </div>
              ) : null}
              {generatedScheduleData != null && isPendingItem ? (
                <div
                  style={{
                    ...style.simpleColumn,
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: 10,
                    marginLeft: 5,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      position: 'relative',
                    }}
                  >
                    <div
                      id={infoInterviewCountID}
                      style={{
                        border: '2px solid #f2f2f2',
                        borderRadius: 20,
                        color: 'black',
                        backgroundColor: '#a1e3a5',
                        fontWeight: 'bold',
                        fontSize: 10,
                        marginRight: 2,
                        minWidth: 17,
                        minHeight: 17,
                        textAlign: 'center',
                      }}
                    >
                      {candidateInterviewCount}
                    </div>
                    {!hiddenParent && (
                      <UncontrolledTooltip target={infoInterviewCountID}>
                        Candidate currently has {candidateInterviewCount} interviews on this Generated Schedule.
                      </UncontrolledTooltip>
                    )}
                  </div>
                </div>
              ) : null}
              {cellState === 'Flex Event' && flexEventEvaluators && flexEventEvaluators.length > 0 ? (
                <>
                  <FontAwesomeIcon
                    id={flexEventEvaluatorWarningID}
                    icon={faExclamationTriangle}
                    style={{ color: 'black', marginLeft: 10 }}
                  />
                  {!hiddenParent && (
                    <UncontrolledTooltip target={flexEventEvaluatorWarningID}>
                      <div>
                        <div>
                          Some Evaluators might be in a Flex Event and be unavailable during this time. (
                          {flexEventEvaluators.length} of {availableEvaluators.length + unavailableEvaluators.length}
                          ).
                        </div>
                        <div style={{ textAlign: 'justify', marginTop: 15 }}>
                          <div style={{ ...style.ellipsis, width: 180 }}>
                            Unavailable ({flexEventsForCell > 1 ? 'Several' : FlexEvents[0].FlexEventName}):
                          </div>
                          <div style={{ paddingLeft: 20 }}>
                            {flexEventEvaluators.map((evaluator) => {
                              if (evaluator == null) {
                              }
                              return <div>{`${evaluator ? evaluator.UserLast : 'Null Evaluator'}\n`}</div>;
                            })}
                          </div>
                        </div>
                      </div>
                    </UncontrolledTooltip>
                  )}
                </>
              ) : null}
            </div>
          </>,
        );
      });

      // If no Candidates to render, check pending list. This Pending is for individual additions,
      // NOT Generate Schedule
      if (candidatesToRender.length == 0) {
        if (isPendingItem) {
          const cellPendingCandidates = pendingCandidates[pendingItemKey] || [];
          cellPendingCandidates.forEach((candidate, i) => {
            const candidateActual = candidates[candidate.pk_Candidate];
            const backgroundColor =
              candidates && Object.keys(candidates).length > 0 && candidateActual
                ? candidateActual.color
                : cellState === 'Warning'
                ? '#ffc180'
                : '#d4d4d4';
            const color =
              candidate.pk_Candidate == null
                ? backgroundColor
                : backgroundColor
                ? tinycolor(backgroundColor).isLight()
                  ? 'black'
                  : 'white'
                : 'black';
            const border = candidate.pk_Candidate == null ? `5px solid ${backgroundColor}` : '5px solid #a1e3a5 ';
            //generatedScheduleData && generatedScheduleData.interviewCountTracker[candidate.pk_Candidate]
            // ? '5px solid #a1e3a5 '
            // : `5px solid ${backgroundColor}`;

            const pendingItemKey = `${pk_Timeslot}_${pk_ScheduleAssignment}${
              scheduleBlock ? `_${scheduleBlock.SortOrder}` : '_0'
            }`;

            const candidateInterviewCount =
              generatedScheduleData &&
              generatedScheduleData.interviewCountTracker &&
              generatedScheduleData.interviewCountTracker[candidate.pk_Candidate]
                ? generatedScheduleData.interviewCountTracker[candidate.pk_Candidate]
                : 0;

            candidatesToRender.push(
              <>
                <div
                  id={`capsule_${pk_ScheduleAssignment}_${pk_Timeslot}_${scheduleBlock.SortOrder}_${
                    hiddenParent ? 'hidden' : ''
                  }`}
                  disabled={hiddenParent}
                  key={pendingItemKey}
                  style={{
                    ...style.candidateLabel,
                    color,
                    backgroundColor,
                    border,
                    ...themedSlot(backgroundColor, color, border),
                    marginBottom: cellPendingCandidates.length > 0 && i < cellPendingCandidates.length - 1 ? 5 : 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: blockHeight,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    // if (scheduleBlock) setSelectedScheduleBlock(scheduleBlock);
                  }}
                >
                  {candidate.LastName || ' '} {candidate.FirstName ? `, ${candidate.FirstName}` : ' '}
                  {/**Add Interview counter here */}
                  {!hiddenParent &&
                  generatedScheduleData != null &&
                  generatedScheduleData.interviewCountTracker[candidate.pk_Candidate] ? (
                    <div
                      style={{
                        ...style.simpleColumn,
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: 10,
                        marginLeft: 5,
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          position: 'relative',
                        }}
                      >
                        <div
                          id={`info_${pendingItemKey}_interviewCounter`}
                          style={{
                            border: '2px solid #f2f2f2',
                            borderRadius: 20,
                            color: 'black',
                            backgroundColor: '#a1e3a5',
                            fontWeight: 'bold',
                            fontSize: 10,
                            marginRight: 2,
                            minWidth: 17,
                            minHeight: 17,
                            textAlign: 'center',
                          }}
                        >
                          {candidateInterviewCount}
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {candidate.pk_Candidate == null ? '|' : null}
                  {cellState === 'Flex Event' && flexEventEvaluators && flexEventEvaluators.length > 0 ? (
                    <>
                      <FontAwesomeIcon
                        id={`cell_flexEvent_warning_${pk_Timeslot}_${cell.pk_ScheduleAssignment}`}
                        icon={faExclamationTriangle}
                        style={{ color: 'black', marginLeft: 10 }}
                      />
                      {!hiddenParent ? (
                        <UncontrolledTooltip
                          target={`cell_flexEvent_warning_${pk_Timeslot}_${cell.pk_ScheduleAssignment}`}
                        >
                          <div>
                            <div>
                              Some Evaluators might be in a Flex Event and be unavailable during this time. (
                              {flexEventEvaluators.length} of{' '}
                              {availableEvaluators.length + unavailableEvaluators.length}
                              ).
                            </div>
                            <div style={{ textAlign: 'justify', marginTop: 15 }}>
                              <div style={{ ...style.ellipsis, width: 180 }}>
                                Unavailable ({flexEventsForCell > 1 ? 'Several' : FlexEvents[0].FlexEventName}):
                              </div>
                              <div style={{ paddingLeft: 20 }}>
                                {flexEventEvaluators.map((evaluator) => {
                                  if (evaluator == null) {
                                  }
                                  return <div>{`${evaluator ? evaluator.UserLast : 'Null Evaluator'}\n`}</div>;
                                })}
                              </div>
                            </div>
                          </div>
                        </UncontrolledTooltip>
                      ) : null}
                    </>
                  ) : null}
                </div>
              </>,
            );
          });
        } else {
          // EMPTY CELL!
          const emptyCellCapsuleId = `capsule_${pk_ScheduleAssignment}_${pk_Timeslot}_${scheduleBlock.SortOrder}_${
            hiddenParent ? 'hidden' : ''
          }`;
          candidatesToRender.push(
            <Fragment
              key={
                scheduleBlock && scheduleBlock.pk_ScheduleBlock != null
                  ? scheduleBlock.pk_ScheduleBlock
                  : `${rowIndex}_${cell.dataField}_pending`
              }
            >
              <div
                id={emptyCellCapsuleId}
                disabled={hiddenParent}
                style={{
                  ...style.candidateLabel,
                  ...themedSlot(SLOT_GRAY, CustomMeetingTitle ? 'black' : SLOT_GRAY, `5px solid ${SLOT_GRAY}`),
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: blockHeight,
                }}
                onClick={(e) => {
                  if (generatedScheduleData != null) {
                    e.stopPropagation();
                  }
                  if (scheduleBlock && (!isEmbedded || allowScheduleInteraction)) {
                    setSelectedScheduleBlock(clone(scheduleBlock));
                  }
                }}
              >
                {shouldRenderFlexEventLabels ? (
                  <div
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      color: 'black',
                      lineHeight: 1.15,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {visibleFlexEventDetails.map((detail, index) => {
                      const { flexEvent, label } = detail;

                      return (
                        <div
                          key={`${flexEvent.pk_FlexEvent || label}_${index}`}
                          style={{
                            width: '100%',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {visibleFlexEventDetails.length > 1 ? `• ${label}` : label}
                        </div>
                      );
                    })}
                  </div>
                ) : CustomMeetingTitle ? (
                  CustomMeetingTitle
                ) : cellState === 'Flex Event' ? (
                  <div style={{ visibility: 'hidden' }}>|</div>
                ) : (
                  `|`
                )}

                {cellState === 'Flex Event' &&
                !shouldRenderFlexEventLabels &&
                flexEventEvaluators &&
                flexEventEvaluators.length > 0 ? (
                  <>
                    <FontAwesomeIcon
                      id={`cell_flexEvent_warning_${pk_Timeslot}_${cell.pk_ScheduleAssignment}`}
                      icon={faExclamationTriangle}
                      style={{ color: 'black', marginLeft: CustomMeetingTitle ? 10 : 0 }}
                    />
                    {!hiddenParent ? (
                      <UncontrolledTooltip target={`cell_flexEvent_warning_${pk_Timeslot}_${cell.pk_ScheduleAssignment}`}>
                        <div>
                          <div>
                            Some Evaluators might be in a Flex Event and be unavailable during this time. (
                            {flexEventEvaluators.length} of {availableEvaluators.length + unavailableEvaluators.length}).
                          </div>
                          <div style={{ textAlign: 'justify', marginTop: 15 }}>
                            <div style={{ ...style.ellipsis, width: 180 }}>
                              Unavailable ({flexEventsForCell > 1 ? 'Several' : FlexEvents[0].FlexEventName}):
                            </div>
                            <div style={{ paddingLeft: 20 }}>
                              {flexEventEvaluators.map((evaluator) => {
                                if (evaluator == null) {
                                }
                                return <div>{`${evaluator ? evaluator.UserLast : 'Null Evaluator'}\n`}</div>;
                              })}
                            </div>
                          </div>
                        </div>
                      </UncontrolledTooltip>
                    ) : null}
                  </>
                ) : null}
              </div>
              {shouldRenderFlexEventLabels && !hiddenParent ? (
                <UncontrolledTooltip target={emptyCellCapsuleId}>
                  {visibleFlexEventDetails.map((detail, index) => {
                    const attendingNames = formatEvaluatorNamesForTooltip(detail.matchingEvaluators);

                    return (
                      <div key={`${detail.flexEvent.pk_FlexEvent || detail.eventName}_${index}`}>
                        {`${attendingNames} attending ${detail.eventName}.`}
                      </div>
                    );
                  })}
                </UncontrolledTooltip>
              ) : null}
            </Fragment>,
          );
        }
      }
      return candidatesToRender;
    };

    if (isFlexEvent) {
      let backgroundColor = '#d4d4d4';
      if (cellState === 'Unavailable') {
        backgroundColor = '#ff3d3d';
      } else if (cellState === 'Warning') {
        backgroundColor = '#ffc180';
      }

      const color = backgroundColor ? (tinycolor(backgroundColor).isLight() ? 'black' : 'white') : 'black';
      const border = `5px solid ${backgroundColor}`;

      if (cellState === 'Warning' || (cellState === 'Unavailable' && cellHasCandidates)) {
        const renderContentForWarning = (candidateList = [], scheduleBlock, scheduleBlockCount) => {
          // const { pk_Timeslot } = row;
          const { pk_ScheduleAssignment } = cell;

          const candidatesToRender = [];
          const pendingItemKey = `${pk_Timeslot}_${pk_ScheduleAssignment}${
            scheduleBlock ? `_${scheduleBlock.SortOrder}` : '_0'
          }`;
          const isPendingItem = pendingCandidates[pendingItemKey] != null; // TO DO: Move to per-scheduleBlock

          const scheduleBlockTrackerData = scheduleBlockTracker[`ROW_${pk_Timeslot}`];

          let blockHeight = calculateScheduleBlockHeight(
            scheduleBlockTrackerData ? scheduleBlockTrackerData : 1,
            scheduleBlockCount,
          );

          candidateList.forEach((candidate, i) => {
            if (candidates && Object.keys(candidates).length > 0 && candidates[candidate.pk_Candidate]) {
              backgroundColor = candidates[candidate.pk_Candidate].color;
            } else {
              backgroundColor = '#ffc180';
            }

            const color = backgroundColor ? (tinycolor(backgroundColor).isLight() ? 'black' : 'white') : 'black';
            const border = isPendingItem ? '5px solid #a1e3a5 ' : `5px solid ${backgroundColor || '#d4d4d4'}`;
            candidatesToRender.push(
              <>
                <div
                  id={`capsule_${pk_ScheduleAssignment}_${pk_Timeslot}_${scheduleBlock.SortOrder}_${
                    hiddenParent ? 'hidden' : ''
                  }`}
                  disabled={hiddenParent}
                  key={`${pk_Timeslot}_${pk_ScheduleAssignment}${scheduleBlock ? `_${scheduleBlock.SortOrder}` : ''}`}
                  // key={candidate.pk_Candidate}
                  style={{
                    ...style.candidateLabel,
                    color,
                    backgroundColor: backgroundColor || '#d4d4d4',
                    border,
                    ...themedSlot(backgroundColor || '#d4d4d4', color, border),
                    marginBottom: candidateList.length > 0 && i < candidateList.length - 1 ? 5 : 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: blockHeight,
                  }}
                  onClick={(e) => {
                    if (scheduleBlock && backgroundColor && (!isEmbedded || allowScheduleInteraction)) {
                      setSelectedScheduleBlock(scheduleBlock);
                    } else {
                      e.stopPropagation();
                    }
                  }}
                >
                  {candidate.LastName || ''} {candidate.FirstName ? `, ${candidate.FirstName}` : ''}
                  <FontAwesomeIcon
                    id={`cell_warning_${pk_Timeslot}_${cell.pk_ScheduleAssignment}`}
                    icon={faExclamationCircle}
                    style={{ marginLeft: candidateList.length > 0 ? 10 : 0 }}
                  />
                  {!hiddenParent && (
                    <UncontrolledTooltip target={`cell_warning_${pk_Timeslot}_${cell.pk_ScheduleAssignment}`}>
                      <div>
                        <div>
                          Some Evaluators are Unavailable during this time ({unavailableEvaluators.length} of{' '}
                          {availableEvaluators.length + unavailableEvaluators.length}).
                        </div>
                        <div style={{ textAlign: 'justify', marginTop: 15 }}>
                          <div>Unavailable:</div>
                          <div style={{ paddingLeft: 20 }}>
                            {unavailableEvaluators.map((evaluator) => {
                              if (evaluator == null) {
                              }
                              return <div>{`${evaluator ? evaluator.UserLast : 'Null Evaluator'}\n`}</div>;
                            })}
                          </div>
                          Available:
                          <div style={{ paddingLeft: 20 }}>
                            {availableEvaluators.map((evaluator) => {
                              return <div>{`${evaluator.UserLast}\n`}</div>;
                            })}
                          </div>
                        </div>
                      </div>
                    </UncontrolledTooltip>
                  )}
                </div>
              </>,
            );
          });

          // If no Candidates to render, check pending list
          if (candidatesToRender.length == 0) {
            if (isPendingItem) {
              const cellPendingCandidates = pendingCandidates[pendingItemKey] || [];
              cellPendingCandidates.forEach((candidate) => {
                const backgroundColor =
                  candidates && Object.keys(candidates).length > 0 ? candidates[candidate.pk_Candidate].color : 'black';
                const color = backgroundColor ? (tinycolor(backgroundColor).isLight() ? 'black' : 'white') : 'black';
                const border =
                  isPendingItem && candidate.pk_Candidate != null
                    ? '5px solid #a1e3a5 '
                    : `5px solid ${backgroundColor}`;

                candidatesToRender.push(
                  <div
                    id={`capsule_${pk_ScheduleAssignment}_${pk_Timeslot}_${scheduleBlock.SortOrder}${
                      hiddenParent ? '_hidden' : ''
                    }`}
                    key={`${pk_Timeslot}_${pk_ScheduleAssignment}${scheduleBlock ? `_${scheduleBlock.SortOrder}` : ''}`}
                    style={{
                      ...style.candidateLabel,
                      color,
                      backgroundColor,
                      border,
                      ...themedSlot(backgroundColor, color, border),
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      // if (scheduleBlock) setSelectedScheduleBlock(scheduleBlock);
                    }}
                  >
                    {candidate.LastName || ''} {candidate.FirstName ? `, ${candidate.FirstName}` : ''}
                    <FontAwesomeIcon
                      id={`cell_warning_${pk_Timeslot}_${cell.pk_ScheduleAssignment}`}
                      icon={faExclamationCircle}
                      style={{ color: 'black', marginLeft: 10 }}
                    />
                    <UncontrolledTooltip target={`cell_warning_${pk_Timeslot}_${cell.pk_ScheduleAssignment}`}>
                      <div>
                        <div>
                          Some Evaluators are Unavailable during this time ({unavailableEvaluators.length} of{' '}
                          {availableEvaluators.length + unavailableEvaluators.length}).
                        </div>
                        <div style={{ textAlign: 'justify', marginTop: 15 }}>
                          <div>Unavailable:</div>
                          <div style={{ paddingLeft: 20 }}>
                            {unavailableEvaluators.map((evaluator) => {
                              if (evaluator == null) {
                              }
                              return <div>{`${evaluator ? evaluator.UserLast : 'Null Evaluator'}\n`}</div>;
                            })}
                          </div>
                          Available:
                          <div style={{ paddingLeft: 20 }}>
                            {availableEvaluators.map((evaluator) => {
                              return <div>{`${evaluator.UserLast}\n`}</div>;
                            })}
                          </div>
                        </div>
                      </div>
                    </UncontrolledTooltip>
                  </div>,
                );
              });
            } else {
              candidatesToRender.push(
                <div
                  id={`capsule_${pk_ScheduleAssignment}_${pk_Timeslot}_${scheduleBlock.SortOrder}`}
                  key={
                    scheduleBlock && scheduleBlock.pk_ScheduleBlock != null
                      ? scheduleBlock.pk_ScheduleBlock
                      : `${rowIndex}_${cell.dataField}_pending`
                  }
                  style={{
                    ...style.candidateLabel,
                    backgroundColor: '#ffc180',
                    color: '#ffc180',
                    border: `5px solid #ffc180`,
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: blockHeight,
                  }}
                  onClick={() => {
                    if (scheduleBlock && (!isEmbedded || allowScheduleInteraction))
                      setSelectedScheduleBlock(scheduleBlock);
                  }}
                >
                  |
                  <FontAwesomeIcon
                    id={`cell_warning_${pk_Timeslot}_${cell.pk_ScheduleAssignment}`}
                    icon={faExclamationCircle}
                    style={{ color: 'black' }}
                  />
                  <UncontrolledTooltip target={`cell_warning_${pk_Timeslot}_${cell.pk_ScheduleAssignment}`}>
                    <div>
                      <div>
                        Some Evaluators are Unavailable during this time ({unavailableEvaluators.length} of{' '}
                        {availableEvaluators.length + unavailableEvaluators.length}).
                      </div>
                      <div style={{ textAlign: 'justify', marginTop: 15 }}>
                        <div>Unavailable:</div>
                        <div style={{ paddingLeft: 20 }}>
                          {unavailableEvaluators.map((evaluator) => {
                            if (evaluator == null) {
                            }
                            return <div>{`${evaluator ? evaluator.UserLast : 'Null Evaluator'}\n`}</div>;
                          })}
                        </div>
                        Available:
                        <div style={{ paddingLeft: 20 }}>
                          {availableEvaluators.map((evaluator) => {
                            return <div>{`${evaluator.UserLast}\n`}</div>;
                          })}
                        </div>
                      </div>
                    </div>
                  </UncontrolledTooltip>
                </div>,
              );
            }
          }
          return candidatesToRender;
        };

        return (
          <div>
            {isTableLoaded
              ? ScheduleBlockEntries.map((scheduleBlock, i) => {
                  const { Candidates = [], slot, slotEnd } = scheduleBlock;
                  const cTime = dayjs.tz(undefined, metaData.TimeZone).format('MMM DD, YYYY hh:mm A');
                  const endTimeToUse = dayjs
                    .tz(slotEnd)
                    .subtract(10, 'seconds')
                    .format('MMM DD, YYYY hh:mm A');

                  const isCurrentTime = isTimeRangeOverlap([slot, endTimeToUse], [cTime, cTime]);

                  cellContent = renderContentForWarning(Candidates, scheduleBlock, ScheduleBlockEntries.length);
                  return (
                    <div
                      style={
                        style.splitCell({ isCurrentTime, i, isSplit: ScheduleBlockEntries.length > 1 })
                        // i > 0
                        //   ? style.splitCell(isCurrentTime)
                        //   : { border: isCurrentTime && i > 0 ? '3px solid green' : null }
                      }
                    >
                      {cellContent}
                    </div>
                  );
                })
              : null}
          </div>
        );
      } else {
        return (
          <div>
            {isTableLoaded
              ? ScheduleBlockEntries.map((scheduleBlock, i) => {
                  const { Candidates = [], slot, slotEnd } = scheduleBlock;

                  const cTime = dayjs.tz(undefined, metaData.TimeZone).format('MMM DD, YYYY hh:mm A');
                  const endTimeToUse = dayjs(slotEnd)
                    .subtract(10, 'seconds')
                    .format('MMM DD, YYYY hh:mm A');

                  const isCurrentTime = isTimeRangeOverlap([slot, endTimeToUse], [cTime, cTime]);

                  if (isUnavailable) {
                    const scheduleBlockTrackerData = scheduleBlockTracker[`ROW_${pk_Timeslot}`];

                    let blockHeight = calculateScheduleBlockHeight(
                      scheduleBlockTrackerData ? scheduleBlockTrackerData : 1,
                      ScheduleBlockEntries.length,
                    );

                    return (
                      <div
                        id={`capsule_${pk_Timeslot}_${pk_ScheduleAssignment}_${scheduleBlock.SortOrder}`}
                        style={
                          style.splitCell({ isCurrentTime, i, isSplit: ScheduleBlockEntries.length > 1 })
                          // i > 0
                          //   ? style.splitCell(isCurrentTime)
                          //   : { border: isCurrentTime && i > 0 ? '3px solid green' : null }
                        }
                        onClick={(e) => {
                          if (
                            scheduleBlock &&
                            /*backgroundColor &&*/ (!isEmbedded || allowScheduleInteraction) &&
                            generatedScheduleData == null
                          ) {
                            setSelectedScheduleBlock(scheduleBlock);
                          } else {
                            e.stopPropagation();
                          }
                        }}
                      >
                        <div
                          id={`capsule_${pk_Timeslot}_${pk_ScheduleAssignment}_${scheduleBlock.SortOrder}_label`}
                          style={{
                            ...style.candidateLabel,
                            color,
                            backgroundColor,
                            border,
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: blockHeight,
                          }}
                          onClick={(e) => {
                            if (generatedScheduleData) {
                              e.stopPropagation();
                            }
                          }}
                        >
                          {isUnavailable
                            ? `UNAVAILABLE`
                            : cell.flexEventName
                            ? cell.flexEventName
                            : 'UNKNOWN FLEX EVENT'}
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        style={
                          style.splitCell({ isCurrentTime, i, isSplit: ScheduleBlockEntries.length > 1 })
                          // i > 0
                          //   ? style.splitCell(isCurrentTime)
                          //   : { border: isCurrentTime && i > 0 ? '3px solid green' : null }
                        }
                      >
                        {renderContent(Candidates, scheduleBlock, ScheduleBlockEntries.length)}
                      </div>
                    );
                  }
                })
              : null}
          </div>
        );
      }
    } else if (CustomMeetingTitle && !cellHasCandidates && ScheduleBlockEntries) {
      return (
        <div>
          {isTableLoaded
            ? ScheduleBlockEntries.map((scheduleBlock, i) => {
                const pendingItemKey = `${pk_Timeslot}_${pk_ScheduleAssignment}${
                  scheduleBlock ? `_${scheduleBlock.SortOrder}` : ''
                }`;

                const { Candidates = [], slot, slotEnd } = scheduleBlock;
                const rowStartTime = dayjs(slot).format('MMM DD, YYYY hh:mm A');
                const rowEndTime = dayjs(slotEnd)
                  .subtract(5, 'seconds')
                  .format('MMM DD, YYYY hh:mm A');
                const cTime = dayjs.tz(undefined, metaData.TimeZone).format('MMM DD, YYYY hh:mm A');

                const isCurrentTime = isTimeRangeOverlap([slot, rowEndTime], [cTime, cTime]);

                const isPendingItem = pendingCandidates[pendingItemKey] != null; // TO DO: Move to per-scheduleBlock
                if (Candidates.length > 0) {
                  cellContent = renderContent(Candidates, scheduleBlock, ScheduleBlockEntries.length);
                  return (
                    <div
                      style={
                        style.splitCell({ isCurrentTime, i, isSplit: ScheduleBlockEntries.length > 1 })
                        // i > 0
                        //   ? style.splitCell(isCurrentTime)
                        //   : { border: isCurrentTime && i > 0 ? '3px solid green' : null }
                      }
                    >
                      {cellContent}
                    </div>
                  );
                } else if (isPendingItem) {
                  const cellPendingCandidates = pendingCandidates[pendingItemKey] || [];
                  const candidate = cellPendingCandidates[0];
                  const backgroundColor =
                    candidates && Object.keys(candidates).length > 0 ? candidates[candidate.pk_Candidate].color : null;
                  const color = backgroundColor ? (tinycolor(backgroundColor).isLight() ? 'black' : 'white') : 'black';
                  const border = isPendingItem ? '5px solid #a1e3a5 ' : `5px solid ${backgroundColor}`;

                  return (
                    <div
                      style={
                        style.splitCell({ isCurrentTime, i, isSplit: ScheduleBlockEntries.length > 1 })
                        // i > 0
                        //   ? style.splitCell(isCurrentTime)
                        //   : { border: isCurrentTime && i > 0 ? '3px solid red' : null }
                      }
                    >
                      <div
                        id={`capsule_${pk_ScheduleAssignment}_${pk_Timeslot}_${scheduleBlock.SortOrder}`}
                        key={`${pk_Timeslot}_${pk_ScheduleAssignment}${
                          scheduleBlock ? `_${scheduleBlock.SortOrder}` : ''
                        }`}
                        style={{
                          ...style.candidateLabel,
                          color,
                          backgroundColor,
                          border,
                          ...themedSlot(backgroundColor, color, border),
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          // if (scheduleBlock) setSelectedScheduleBlock(scheduleBlock);
                        }}
                      >
                        {candidate.LastName || ''} {candidate.FirstName ? `, ${candidate.FirstName}` : ''}
                      </div>
                    </div>
                  );
                } else {
                  let backgroundColor = '#d4d4d4';
                  const color = backgroundColor ? (tinycolor(backgroundColor).isLight() ? 'black' : 'white') : 'black';
                  const border = `5px solid ${backgroundColor}`;
                  return (
                    <div
                      id={`capsule_${pk_ScheduleAssignment}_${pk_Timeslot}_${scheduleBlock.SortOrder}`}
                      style={
                        style.splitCell({ isCurrentTime, i, isSplit: ScheduleBlockEntries.length > 1 })
                        // i > 0
                        //   ? style.splitCell(isCurrentTime)
                        //   : { border: isCurrentTime && i > 0 ? '3px solid green' : null }
                      }
                      onClick={(e) => {
                        setSelectedScheduleBlock(scheduleBlock);
                      }}
                    >
                      <div
                        id={`capsule_${pk_ScheduleAssignment}_${pk_Timeslot}_${scheduleBlock.SortOrder}_label`}
                        style={{
                          ...style.candidateLabel,
                          color,
                          backgroundColor,
                          border,
                          ...themedSlot(backgroundColor, color, border),
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        {CustomMeetingTitle}
                      </div>
                    </div>
                  );
                }
              })
            : null}
        </div>
      );
    } else if (
      (ScheduleBlockEntries && ScheduleBlockEntries.length > 0) ||
      (pendingItemsInThisCell && pendingItemsInThisCell.length > 0)
    ) {
      // REGULAR SPLIT CELL
      const { metaData } = scheduleData;
      return (
        <div>
          {isTableLoaded
            ? // ScheduleBlockEntries ? (
              ScheduleBlockEntries.map((scheduleBlock, i) => {
                const { Candidates = [], slot, slotEnd } = scheduleBlock;
                const endTimeToUse = dayjs(slotEnd)
                  .subtract(10, 'seconds')
                  .format('MMM DD, YYYY hh:mm A');
                const cTime = dayjs.tz(undefined, metaData.TimeZone).format('MMM DD, YYYY hh:mm A');
                const isCurrentTime = isTimeRangeOverlap([slot, endTimeToUse], [cTime, cTime]);
                cellContent = renderContent(Candidates, scheduleBlock, ScheduleBlockEntries.length);

                return (
                  <div
                    style={
                      style.splitCell({ isCurrentTime, i, isSplit: ScheduleBlockEntries.length > 1 })
                      // i > 0
                      //   ? style.splitCell(isCurrentTime)
                      //   : { border: isCurrentTime && i > 0 ? '3px solid green' : null }
                    }
                  >
                    {cellContent}
                  </div>
                );
              })
            : null}
        </div>
      );
    } else {
      return (
        <div
          key={`empty_${pk_Timeslot}_${Math.random() * 900}`}
          id={`capsule_${pk_ScheduleAssignment}_${pk_Timeslot}`}
          style={{
            ...style.candidateLabel,
            // visibility: 'hidden',
            padding: 5,
          }}
          onClick={() => {}}
        >
          NO VALUE
        </div>
      );
    }
  };

  const flexColumnCellFormatter = (cell, data) => {
    const { row, rowIndex, formatExtraData, FlexEvents = [], endTimesText, pk_Timeslot } = data;

    let flexEvents = FlexEvents || [];

    let hasFlexEventMainRoomAndNoLink = false;
    let hasFlexEventCustomAndNoLink = false;
    let hasFlexEventUrlIssue = false;

    let flexEventWithUrlIssues = [];
    flexEvents = flexEvents.filter((fE) => {
      return (
        (fE.EventName && fE.EventName.toLowerCase() !== 'unavailable') ||
        (fE.FlexEventName && fE.FlexEventName.toLowerCase() !== 'unavailable')
      );
    });
    flexEvents = sortFlexEventsForDisplay(flexEvents);

    const flexEventTitles = flexEvents.map((flexEvent) => {
      return getFlexEventDisplayName(flexEvent);
    });

    flexEvents.forEach((f) => {
      const { FlexEventName, CustomUrl, UrlType } = f;
      const isMainRoomAndNoLink = FlexEventName && UrlType === 'AllDay' && !scheduleData.metaData.MainRoomURL;
      const isCustomAndNoLink = FlexEventName && UrlType === 'Custom' && !CustomUrl;
      const urlIssue = VirtualMeetingMode !== 'Disabled' && (isMainRoomAndNoLink || isCustomAndNoLink);

      if (urlIssue) {
        hasFlexEventUrlIssue = true;
        flexEventWithUrlIssues.push(f);
      }

      if (isMainRoomAndNoLink) {
        hasFlexEventMainRoomAndNoLink = true;
      }

      if (isCustomAndNoLink) {
        hasFlexEventCustomAndNoLink = true;
      }
    });

    if (pk_Timeslot === 'END') {
      return (
        <div>
          <b>{endTimesText}</b>
        </div>
      );
    }

    const isOverlap = flexEvents && flexEvents.length > 1;

    const scheduleBlockTrackerData = scheduleBlockTracker[`ROW_${pk_Timeslot}`];

    let blockHeight = calculateScheduleBlockHeight(scheduleBlockTrackerData ? scheduleBlockTrackerData : 1, 1);

    return (
      <div
        id={`capsule_flexEvent_${rowIndex}`}
        style={{
          ...style.candidateLabel,
          display: 'flex',
          flexDirection: 'row',
          color: flexEvents.length <= 0 ? 'white' : 'black',
          backgroundColor: isOverlap ? '#ff9703' : 'white',
          border: `5px solid ${isOverlap ? '#ff9703' : 'white'}`,
          textAlign: 'center',
          fontWeight: 'bold',
          textAlign: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: blockHeight,
        }}
      >
        {flexEvents && flexEvents.length > 0 ? (
          <div
            style={{
              flex: 1,
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {flexEventTitles.map((title, index) => {
              return (
                <div
                  key={`${title}_${index}`}
                  style={{
                    width: '100%',
                    lineHeight: 1.15,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {isOverlap ? `• ${title}` : title}
                </div>
              );
            })}
          </div>
        ) : (
          '|'
        )}

        {isOverlap || hasFlexEventUrlIssue ? (
          <div
            style={{
              width: 24,
              minWidth: 24,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {isOverlap ? (
              <>
                <FontAwesomeIcon id={`row_${rowIndex}_flexEvent`} icon={faInfoCircle} />
                <UncontrolledTooltip target={`row_${rowIndex}_flexEvent`}>
                  {flexEventTitles.map((title, index) => {
                    return <div key={`${title}_${index}`}>{title}</div>;
                  })}
                </UncontrolledTooltip>
              </>
            ) : null}
            {hasFlexEventUrlIssue ? (
              <>
                <FontAwesomeIcon icon={faExclamationTriangle} id={`row_${rowIndex}_flexEvent_urlIssueIcon`} />

                <UncontrolledTooltip target={`row_${rowIndex}_flexEvent_urlIssueIcon`}>
                  The following Flex Events have URL issues:
                  {sortFlexEventsForDisplay(flexEventWithUrlIssues).map((flexEvent, index) => {
                    return <div key={`${flexEvent.pk_FlexEvent || index}`}>{getFlexEventDisplayName(flexEvent)}</div>;
                  })}
                </UncontrolledTooltip>
              </>
            ) : null}
          </div>
        ) : null}
        {/* {flexEvents.length > 0 && isOverlap ? (
          <UncontrolledTooltip target={`row_${rowIndex}_flexEvent`}>
            {flexEvents.map((flexEvent) => {
              if (flexEvent.EventName) {
                return <div>{flexEvent.EventName}</div>;
              } else if (flexEvent.FlexEventName) {
                return <div>{flexEvent.FlexEventName}</div>;
              }
            })}
          </UncontrolledTooltip>
        ) : null} */}
      </div>
    );
  };

  const cellHasRenderableFlexEvent = (cellActual) => {
    if (!cellActual) {
      return false;
    }

    const columnEvaluators = [...(cellActual.availableEvaluators || []), ...(cellActual.unavailableEvaluators || [])].filter(
      (evaluator, index, list) => {
        if (!evaluator || evaluator.pk_User == null) {
          return false;
        }

        return index === list.findIndex((columnEvaluator) => columnEvaluator?.pk_User === evaluator.pk_User);
      },
    );

    if (columnEvaluators.length <= 0) {
      return false;
    }

        return (cellActual.ScheduleBlockEntries || []).some((scheduleBlockEntry) => {
          return (scheduleBlockEntry.FlexEvents || []).some((flexEvent) => {
            const eventName = getFlexEventDisplayName(flexEvent);
            const attendingUsers = flexEvent?.AttendingUsers || [];

        if (!eventName || eventName.toLowerCase() === 'unavailable') {
          return false;
        }

        const matchingEvaluatorCount = columnEvaluators.filter((columnEvaluator) => {
          return attendingUsers.find((attendingUser) => attendingUser.pk_User === columnEvaluator.pk_User);
        }).length;

            return matchingEvaluatorCount > 0;
          });
        });
      };

  const sortHeaders = (scheduleData) => {
    const headers = scheduleData.headers || [];
    let newHeaders = [];
    const columnsWithRooms = [];
    const columnsWithoutRooms = [];

    headers.forEach((header) => {
      const listToAddTo = header.RoomLabel ? columnsWithRooms : columnsWithoutRooms;
      let name = '';
      let evaluators = header && header.Evaluators && header.Evaluators.Evaluators ? header.Evaluators.Evaluators : [];
      const evaluatorNames = [];
      evaluators.forEach((evaluator, i) => {
        const { UserFirst = ' ', UserLast = ' ' } = evaluator;
        evaluatorNames.push(`${UserFirst[0]}. ${UserLast}`);
      });
      evaluatorNames.sort();
      evaluatorNames.forEach((evaluatorName, i) => {
        name += `${evaluatorName}${evaluatorNames.length > 1 && i < evaluatorNames.length - 1 ? ', ' : ' '}`;
      });

      listToAddTo.push({
        ...header,
        text: name || 'No Header Name!',
        label: header.RoomLabel,
      });
    });

    columnsWithRooms.sort((a, b) => {
      const textA = a.label ? a.label.toUpperCase() : '';
      const textB = b.label ? b.label.toUpperCase() : '';
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    columnsWithoutRooms.sort((a, b) => {
      const textA = a.text ? a.text.toUpperCase() : '';
      const textB = b.text ? b.text.toUpperCase() : '';
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    newHeaders = [...columnsWithRooms, ...columnsWithoutRooms];

    return newHeaders;
  };

  const makeColumns = (data) => {
    const headers = data.headers;
    let newColumns = [];

    headers.forEach((header, i) => {
      let name = '';
      let evaluators = header && header.Evaluators && header.Evaluators.Evaluators ? header.Evaluators.Evaluators : [];
      const evaluatorNames = [];
      evaluators.forEach((evaluator, i) => {
        const { UserLast = ' ', UserFirst = ' ' } = evaluator;

        evaluatorNames.push(`${UserFirst[0]}. ${UserLast}`);
      });
      evaluatorNames.sort();
      evaluatorNames.forEach((evaluatorName, i) => {
        name += `${evaluatorName}${evaluatorNames.length > 1 && i < evaluatorNames.length - 1 ? ', ' : ' '}`;
      });

      // if (evaluatorNames.length > 1) {
      //   name = `${evaluatorNames[0]} +${evaluatorNames.length - 1}`;
      // } else {
      //   name += evaluatorNames[0];
      // }

      const headerStyle = headerProcessStyle(header, i + 1);
      newColumns.push({
        // Header: name || 'No Header Name!',
        text: name,
        label: header.RoomLabel,
        cellFormatter: cellFormatter,
        headerFormatter: headerFormatter,
        headerStyle: headerProcessStyle,
        dataKey: header.pk_ScheduleAssignment.toString(),
        dataField: header.pk_ScheduleAssignment.toString(),
        style: processStyle,
        rawHeader: header,
        width: headerStyle.width,
        evaluatorNames,
        events: {
          onClick: async (data) => {
            const { e, column, columnIndex, row, rowIndex } = data;
            const clickedCapsule =
              e.target && e.target.closest ? e.target.closest('[id^="capsule_"]') : e.target && e.target.id;
            e.stopPropagation();
            if (generatedScheduleData || !clickedCapsule || row.pk_Timeslot === 'END') {
              return;
            }

            if (isInPreviewMode({ column, row })) {
              setShowUnsavedChangeModal(!isSubmitting);
              return;
            }

            if (isEmbedded && !allowScheduleInteraction) {
              return;
            }

            const cellActual = row[parseInt(column.dataField)];
            const cellHasCustomEvent = !!row.CustomMeetingTitle;
            const cellHasCandidates = (cellActual.ScheduleBlockEntries || []).some((scheduleBlockEntry) => {
              return scheduleBlockEntry.Candidates && scheduleBlockEntry.Candidates.length > 0;
            });
            const cellHasVisibleFlexEvent = cellHasRenderableFlexEvent(cellActual);

            setSelectedCell({ column, row, columnIndex, rowIndex });

            if (cellHasVisibleFlexEvent && !cellHasCustomEvent && !cellHasCandidates) {
              setShowFlexEventDetailModal(true);
            } else {
              setCellSplitCount(
                cellActual.ScheduleBlockTotalNumberOfSplits != null
                  ? cellActual.ScheduleBlockTotalNumberOfSplits
                  : cellActual.ColumnTotalNumberOfSplits
                  ? cellActual.ColumnTotalNumberOfSplits
                  : 1,
              );
              setShowScheduleDetailModal(true);
            }
            hideHeaderPopoversExcept();
            hideTimeSlotPopoversExcept();
            setShowAddColumnPopover(false);
          },
          /*...*/
          /*...*/
          onMouseEnter: async (data) => {
            const { e, column, columnIndex, row, rowIndex } = data;

            if (isInPreviewMode()) {
              return;
            }

            setCellHoveredOn({ rowIndex, columnIndex });
          },
          onMouseLeave: async (data) => {
            const { e, column, columnIndex, row, rowIndex } = data;

            if (isInPreviewMode()) {
              return;
            }
            setCellHoveredOn(null);
          },
        },
        headerEvents: {
          onClick: async (data) => {
            const { e, column, columnIndex } = data;

            const { rawHeader } = column;
            const { RoomFocuses = [], VirtualRoomURL } = rawHeader || {};
            const { VirtualMeetingMode } = dContext.department;

            e.stopPropagation();
            // if (dateIsInThePast && !willEditThePast) {
            //   const continueProcess = await fireConfirmationForEditingPastSchedule();
            //   if (!continueProcess) {
            //     return;
            //   }
            // }
            if (isInPreviewMode()) {
              setShowUnsavedChangeModal(!isSubmitting);
              return;
            }
            hideTimeSlotPopoversExcept();
            // hideHeaderPopoversExcept(parseInt(column.accessor));
            setShowAddColumnPopover(false);
          },
          onMouseEnter: (data) => {
            const { e, column, columnIndex } = data;
            setHeaderHoveredOn({ column, columnIndex });
          },
          onMouseLeave: (data) => {
            const { e, column, columnIndex } = data;
            setHeaderHoveredOn(null);
          },
        },
        headerAttrs: {
          id: `room_${header.pk_ScheduleAssignment}_header`,
        },
        attrs: (data) => {
          const { cell, row, rowIndex, colIndex } = data;
          const { pk_Timeslot } = row;

          if (pk_Timeslot === 'END') {
            if (colIndex == 1) {
              return { colSpan: hasFlexColumn ? scheduleData.headers.length + 1 : scheduleData.headers.length };
            } else {
              return { hidden: true };
            }
          }
        },
      });
    });

    newColumns.splice(0, 0, {
      dataKey: 'slot',
      dataField: 'slot',
      text: 'Time',
      rawHeader: { pk_ScheduleAssignment: 'slot' },
      /*...*/
      /*...*/
      cellFormatter: cellFormatter,
      headerFormatter: headerFormatter,
      classes: 'timeSlot',
      style: processStyle,
      headerStyle: headerProcessStyle,
      isTime: true,
      metaData: data.metaData,
      formatExtraData: { metaData: data.metaData, isTime: true },
      events: {
        onClick: async (data) => {
          const { e, column, columnIndex, row, rowIndex } = data;
          const visibility = getTimeSlotPopoverVisibility(row.pk_Timeslot);
          const hasChildOpen =
            visibility.showAddTimeSlotPopover || visibility.showAddCustomPopover || visibility.showCustomDurationPopover;

          // logSchedulePopoverDebug('timeSlotCellClick', {
          //   pk_Timeslot: row.pk_Timeslot,
          //   columnIndex,
          //   targetId: e?.target?.id || null,
          //   targetClassName: e?.target?.className || null,
          //   self: Boolean(visibility.self),
          //   hasChildOpen,
          //   showAddTimeSlotPopover: Boolean(visibility.showAddTimeSlotPopover),
          //   showAddCustomPopover: Boolean(visibility.showAddCustomPopover),
          //   showCustomDurationPopover: Boolean(visibility.showCustomDurationPopover),
          // });

          if ((isEmbedded && !allowScheduleInteraction) || row.pk_Timeslot === 'END') {
            return;
          }

          if (columnIndex == 0) {
            if (isInPreviewMode()) {
              setShowUnsavedChangeModal(!isSubmitting);
              return;
            }
            if (visibility.self && !hasChildOpen) {
              // logSchedulePopoverDebug('timeSlotCellClick:closingParent', {
              //   pk_Timeslot: row.pk_Timeslot,
              // });
              closeTimeSlotPopoverStack(row.pk_Timeslot);
              hideHeaderPopoversExcept();
              setShowAddColumnPopover(false);
              return;
            }
            // logSchedulePopoverDebug('timeSlotCellClick:openingParent', {
            //   pk_Timeslot: row.pk_Timeslot,
            // });
            hideTimeSlotPopoversExcept(row.pk_Timeslot);
            hideHeaderPopoversExcept();
            setShowAddColumnPopover(false);
          }
        },
      },
      headerEvents: {
        onClick: async (data) => {
          const { e, column, columnIndex } = data;
          const visibility = getTimeSlotHeaderPopoverVisibility(showHeaderPopOver['timeSlotHeader']);
          const hasChildOpen = visibility.showAddTimeSlotPopover || visibility.showConfirmModal;

          e.stopPropagation();
          if (isEmbedded) {
            return;
          }

          if (isInPreviewMode()) {
            setShowUnsavedChangeModal(!isSubmitting);
            return;
          }
          if (visibility.self && !hasChildOpen) {
            await (async () => {
              if (manageTimeUnsavedPromptOpenRef.current) {
                return;
              }

              if (manageTimeHasChanges) {
                manageTimeUnsavedPromptOpenRef.current = true;
                const result = await Swal.fire({
                  title: 'Unsaved Changes',
                  text: 'You have unsaved changes. Do you want to discard them?',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  confirmButtonText: 'Discard Changes',
                  cancelButtonText: 'Keep Editing',
                });
                manageTimeUnsavedPromptOpenRef.current = false;
                if (!result.isConfirmed) {
                  return;
                }
                setManageTimeHasChanges(false);
              }

              closeTimeSlotHeaderPopoverStack();
              setShowAddColumnPopover(false);
            })();
            return;
          }
          hideTimeSlotPopoversExcept();
          hideHeaderPopoversExcept('timeSlotHeader');
          setShowAddColumnPopover(false);
        },
        onMouseEnter: (data) => {
          const { e, column, columnIndex, row, rowIndex } = data;
          setHeaderHoveredOn({ column, columnIndex });
        },
        onMouseLeave: () => {
          setHeaderHoveredOn(null);
        },
      },
      headerAttrs: {
        id: 'timeSlotHeader',
      },
      attrs: (data) => {
        const { cell, row, rowIndex, colIndex } = data;
        return { id: `timeSlot_${row.pk_Timeslot}` };
      },
    });

    if (hasFlexColumn) {
      newColumns.push({
        dataKey: 'flexColumn',
        dataField: 'flexColumn',
        text: 'Flex Events',
        isDummyField: true,
        cellFormatter: flexColumnCellFormatter,
        headerStyle: {
          alignItems: 'center',
          color: 'black',
          cursor: 'pointer',
          maxWidth: 280,
          minWidth: 180,
          textAlign: 'center',
          top: 0,
          verticalAlign: 'middle',
          backgroundColor: '#afafaf',
          zIndex: 2,
        },
        style: processFlexCellStyle,
        headerFormatter: headerFormatter,
        events: {
          onClick: async (data) => {
            const { e, column, columnIndex, row, rowIndex } = data;

            const clickedCapsule =
              e.target && e.target.closest ? e.target.closest('[id^="capsule_"]') : e.target && e.target.id;

            if (isFetching || isSubmitting || generatedScheduleData != null || !clickedCapsule) {
              e.stopPropagation();
              return;
            }
            if (isInPreviewMode({ column, row })) {
              setShowUnsavedChangeModal(!isSubmitting);
              return;
            }
            if (!allowScheduleInteraction) {
              return;
            }
            setSelectedCell({ column, row, columnIndex, rowIndex });
            setShowFlexEventDetailModal(true);
          },
          onMouseEnter: async (data) => {
            const { columnIndex, rowIndex } = data;
            if (isInPreviewMode()) {
              return;
            }
            setCellHoveredOn({ rowIndex, columnIndex });
          },
          onMouseLeave: async () => {
            if (isInPreviewMode()) {
              return;
            }
            setCellHoveredOn(null);
          },
        },
        headerEvents: {
          onClick: async (data) => {
            const { e } = data;
            e.stopPropagation();
            if (generatedScheduleData) {
              e.stopPropagation();
              return;
            }
            e.stopPropagation();
            setShowFlexEventDetailModal(true);
          },
          onMouseEnter: (data) => {
            const { column, columnIndex } = data;
            setHeaderHoveredOn({ column, columnIndex });
          },
          onMouseLeave: () => {
            setHeaderHoveredOn(null);
          },
        },
        attrs: (data) => {
          const { row, colIndex } = data;

          if (row.pk_Timeslot === 'END') {
            if (colIndex == 1) {
              return { colSpan: scheduleData.headers.length + 1 };
            } else {
              return { hidden: true };
            }
          }
        },
      });
    }

    const newHeaders = [];
    newColumns.forEach((column) => {
      const originalHeader = headers.find((h) => {
        return parseInt(h.pk_ScheduleAssignment) == parseInt(column.dataField);
      });

      if (originalHeader) {
        newHeaders.push(clone(originalHeader));
      }
    });

    const newScheduleData = clone(scheduleData);
    newScheduleData.headers = newHeaders;

    return newColumns;
  };

  const onToggleScheduleDetailModal = async (e) => {
    const newValue = !showScheduleDetailModal;

    setShowScheduleDetailModal(newValue);
    if (!newValue) {
      // setSelectedCell(null);
      // setSelectedScheduleBlock(null);
      console.log(`end: ${dayjs().format('HH:mm:ss')}`);
    }
  };

  const updateEvaluators = (data, callback) => {
    const {
      evaluatorsToAdd = [],
      evaluatorsToDelete = [],
      column,
      TotalNumberOfSplits,
      pk_MeetingRoom,
      ignoreEvaluatorFocuses,
      RoomLabel,
      pk_ScheduleAssignment,
      RoomFocuses = [],
      VirtualRoomDescription,
      VirtualRoomURL,
    } = data;

    const { rawHeader = {} } = column || {};
    const { Evaluators = {} } = rawHeader || {};
    if (
      Evaluators &&
      Evaluators.Evaluators &&
      evaluatorsToDelete &&
      evaluatorsToAdd &&
      evaluatorsToDelete.length - evaluatorsToAdd.length >= Evaluators.Evaluators.length
    ) {
      Swal.fire(
        'Oops...',
        'You must select at least one evaluator or delete this column if it is no longer needed.',
        'error',
      );
    }

    const payload = {
      writeEvaluatorPrimaryKeys: evaluatorsToAdd || [],
      deleteEvaluatorPrimaryKeys: evaluatorsToDelete || [],
      TotalNumberOfSplits,
      VirtualRoomDescription,
      EnableIgnoreEvaluatorFocus: ignoreEvaluatorFocuses, // TODO
      VirtualRoomURL: VirtualRoomURL ? urlWithHttpProtocol(VirtualRoomURL) : null,
      Focuses: RoomFocuses.map((f) => {
        return f.pk_Focus;
      }),
    };

    if (RoomLabel != null) {
      payload.RoomLabel = RoomLabel;
    }

    setIsSubmitting(true);
    getTokenSilently()
      .then((token) => {
        putData(
          'department/season/schedule/evaluator',
          {
            pk_Department: dContext.department.pk_Department,
            pk_ScheduleAssignment: parseInt(pk_ScheduleAssignment),
            pk_InterviewDate: pk_InterviewDate || Number(scheduleID),
          },
          payload,
          formatBearerToken(token),
        )
          .then((res) => {
            const newShowHeaderPopOver = { ...showHeaderPopOver };
            newShowHeaderPopOver[pk_ScheduleAssignment].self = false;
            if (callback) {
              callback();
            }
            setIsSubmitting(false);
            setShowHeaderPopOver(newShowHeaderPopOver);
            fetchSchedule(token);
          })
          .catch((err) => {
            if (callback) {
              callback(false);
            }
            setIsSubmitting(false);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const setSaveHook = (newSaveHook, key) => {
    const newSaveHooks = { ...saveHooks };
    if (newSaveHooks[key] == null) {
      newSaveHooks[key] = {};
    }
    newSaveHooks[key] = newSaveHook;
    setSaveHooks(newSaveHooks);
  };

  const setIsChanged = (newIsChanged, key) => {
    const newSaveHooks = { ...saveHooks };

    if (newSaveHooks[key] == null) {
      newSaveHooks[key] = {};
    }
    newSaveHooks[key].isChanged = newIsChanged;
    setSaveHooks(newSaveHooks);
  };

  const countFlexEvents = (customEvaluators) => {
    let count = 0;

    Object.values(indexedFlexEvents).forEach((flexEvent) => {
      if (flexEvent.FlexEventName && flexEvent.FlexEventName.toLowerCase() !== 'unavailable') {
        count++;
      }
    });

    // Object.values(customEvaluators || evaluators).forEach((e) => {
    //   if (e.FlexEvents) {
    //     e.FlexEvents.forEach((flexEvent) => {
    //       const flexEventStartDate = dayjs(flexEvent.FlexStartTime).format('MMM DD YYYY');
    //       const flexEventEndDate = dayjs(flexEvent.FlexTimeEnd).format('MMM DD, YYYY');
    //       const { metaData = {} } = scheduleData || {};
    //       if (
    //         (flexEventStartDate === metaData.DateOfInterview || flexEventEndDate === metaData.DateOfInterview) &&
    //         flexEvent.FlexEventName &&
    //         flexEvent.FlexEventName.toLowerCase() !== 'unavailable'
    //       ) {
    //         count++;
    //       }
    //     });
    //   }
    // });
    return count;
  };

  const renderHeaderPopOver = (header) => {
    const visibility = showHeaderPopOver[header.dataField] || {};
    let hasChildOpen = false;

    Object.keys(visibility).forEach((key) => {
      if (key !== 'self') {
        if (visibility[key]) {
          hasChildOpen = true;
        }
      }
    });
    // if (document.getElementById(`room_${header.dataField}_header`) == null) {
    //   console.log(`no header for room_${header.dataField}_header`);

    //   return;
    // }

    return (
      <Popover
        placementPrefix="bs-popover headerDetailPopover"
        isOpen={visibility && visibility.self} // Change with room id later
        target={`room_${header.dataField}_header`} // Change with room id later
        trigger={`${hasChildOpen ? 'click' : 'legacy'}`}
        placement="right"
        modifiers={popoverModifiers}
        toggle={async (e) => {
          if (
            e.target &&
            (e.target.id.indexOf('lock_unlock_button') >= 0 || e.target.closest('[id*="lock_unlock_button"]'))
          ) {
            return;
          }

          const newShowHeaderPopOver = { ...showHeaderPopOver };
          const visibility = newShowHeaderPopOver[header.dataField] || {};

          if (!allowScheduleInteraction) {
            return;
          }

          if (visibility.showFocusPopover) {
            visibility.showFocusPopover = false;
            newShowHeaderPopOver[header.dataField] = visibility;
            setShowHeaderPopOver(newShowHeaderPopOver);
            return;
          }
          if (visibility.showUnavailable) {
            visibility.showUnavailable = false;
            newShowHeaderPopOver[header.dataField] = visibility;
            setShowHeaderPopOver(newShowHeaderPopOver);
            return;
          }
          if (visibility.showRoomNumberPopover) {
            visibility.showRoomNumberPopover = false;
            newShowHeaderPopOver[header.dataField] = visibility;
            setShowHeaderPopOver(newShowHeaderPopOver);
            return;
          }

          if (visibility.showSplitPopover) {
            visibility.showSplitPopover = false;
            newShowHeaderPopOver[header.dataField] = visibility;
            setShowHeaderPopOver(newShowHeaderPopOver);
            return;
          }

          if (visibility.showConfirmClearPopover) {
            visibility.showConfirmClearPopover = false;
            newShowHeaderPopOver[header.dataField] = visibility;
            setShowHeaderPopOver(newShowHeaderPopOver);
            return;
          }

          // if (dateIsInThePast && !willEditThePast) {
          //   const continueProcess = await fireConfirmationForEditingPastSchedule();
          //   if (!continueProcess) {
          //     return;
          //   }
          // }
          if (isInPreviewMode() && !visibility.self) {
            setShowUnsavedChangeModal(!isSubmitting);
            return;
          }

          visibility.self = !visibility.self;

          if (!visibility.self) {
            visibility.showHeaderPopOver = false;
            visibility.showFocusPopover = false;

            hideHeaderPopoversExcept();
          } else {
            hideHeaderPopoversExcept(header.dataField);
          }

          // LAST RESORT, Manually false ALL other header keys
          // Object.keys(newShowHeaderPopOver).forEach((key)=>{

          //   newShowHeaderPopOver
          // })
          // newShowHeaderPopOver[header.dataField] = visibility;

          // setShowHeaderPopOver(newShowHeaderPopOver);
          // hideHeaderPopoversExcept(header.dataField);
        }}
      >
        <PopoverHeader>
          <div style={style.spacedBetweenRow}>
            <div style={style.simpleColumn}>
              {' '}
              <div style={{ textAlign: 'left' }}>{header.text || ''}</div>
            </div>
            <div style={style.simpleColumn}>
              <div style={style.flexEndRow}>
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  style={style.clickableIcon}
                  onClick={(e) => {
                    e.stopPropagation();
                    const newShowHeaderPopOver = { ...showHeaderPopOver };
                    const visibility = newShowHeaderPopOver[header.dataField] || {};
                    visibility.self = false;
                    visibility.showRoomNumberPopover = false;
                    Object.keys(visibility).forEach((key) => {
                      visibility[key] = false;
                    });
                    newShowHeaderPopOver[header.dataField] = { ...visibility };

                    setShowHeaderPopOver(newShowHeaderPopOver);
                  }}
                />
              </div>
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody style={style.popOverBody}>
          <HeaderDetailDropDown
            addUnavailableSlot={addUnavailableSlot}
            addUnavailableSlots={addUnavailableSlots}
            updateFlexEvents={updateFlexEvents}
            fetchSchedule={() => {
              fetchSchedule(token);
            }}
            columnTracker={columnTracker}
            dContext={dContext}
            deleteFlexEvent={deleteFlexEvent}
            evaluators={evaluators}
            generateScheduleForColumn={generateScheduleForColumn}
            headers={scheduleData ? scheduleData.headers : []}
            isSubmitting={isSubmitting}
            onClearColumn={onClearColumn}
            onDeleteColumn={onDeleteColumn}
            onUpdateEvaluators={updateEvaluators}
            scheduleData={scheduleData}
            selectedHeader={header}
            setColumnSplit={setColumnSplit}
            setIsChanged={setIsChanged}
            setSaveHook={setSaveHook}
            setShowHeaderPopOver={setShowHeaderPopOver}
            setShowSplitCellConfirmModal={setShowSplitCellConfirmModal}
            showHeaderPopOver={showHeaderPopOver}
            splitCountTracker={splitCountTracker}
            token={token}
            updateFlexEvent={updateFlexEvent}
            updateAllData={updateAllData}
            fireConfirmationForEditingPastSchedule={fireConfirmationForEditingPastSchedule}
            dateIsInThePast={dateIsInThePast}
            willEditThePast={willEditThePast}
            scheduleID={scheduleID}
          />
        </PopoverBody>
      </Popover>
    );
  };

  const renderTimeSlotHeaderPopOver = () => {
    const visibility = getTimeSlotHeaderPopoverVisibility(showHeaderPopOver['timeSlotHeader']);
    const requestCloseTimeSlotHeaderPopover = async () => {
      if (manageTimeUnsavedPromptOpenRef.current) {
        return false;
      }

      if (manageTimeHasChanges) {
        manageTimeUnsavedPromptOpenRef.current = true;
        const result = await Swal.fire({
          title: 'Unsaved Changes',
          text: 'You have unsaved changes. Do you want to discard them?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          confirmButtonText: 'Discard Changes',
          cancelButtonText: 'Keep Editing',
        });
        manageTimeUnsavedPromptOpenRef.current = false;
        if (!result.isConfirmed) {
          return false;
        }
        setManageTimeHasChanges(false);
      }

      closeTimeSlotHeaderPopoverStack();
      return true;
    };
    const getTimeSlotHeaderPopoverPlacement = () => {
      if (typeof window === 'undefined') {
        return 'right';
      }

      const headerEl = document.getElementById('timeSlotHeader');
      if (!headerEl) {
        return 'right';
      }

      const rect = headerEl.getBoundingClientRect();
      const rightSpace = window.innerWidth - rect.right;
      const estimatedPopoverWidth = 420;
      const safeGap = 16;

      return rightSpace < estimatedPopoverWidth + safeGap ? 'bottom' : 'right';
    };

    return (
      <Popover
        modifiers={popoverModifiers}
        placementPrefix="bs-popover headerDetailPopover"
        placement={getTimeSlotHeaderPopoverPlacement()}
        flip={false}
        isOpen={visibility && visibility.self}
        target={`timeSlotHeader`}
        trigger="manual"
        toggle={() => {}}
      >
        <PopoverHeader>
          <div style={style.flexEndRow}>
            <div style={{ width: '100%', textAlign: 'center' }}>Manage Time</div>
            <FontAwesomeIcon
              icon={faTimesCircle}
              style={style.clickableIcon}
              onClick={async (e) => {
                e.stopPropagation();
                await requestCloseTimeSlotHeaderPopover();
              }}
            />
          </div>
        </PopoverHeader>
        <PopoverBody style={style.popOverBody}>
          <TimeSlotHeaderPopover
            pk_InterviewDate={pk_InterviewDate}
            forcedContext={forcedContext}
            visibility={visibility}
            setTimeSlotHeaderPopoverChildVisibility={setTimeSlotHeaderPopoverChildVisibility}
            requestCloseTimeSlotHeaderPopover={requestCloseTimeSlotHeaderPopover}
            forceCloseTimeSlotHeaderPopover={closeTimeSlotHeaderPopoverStack}
            updateAllData={updateAllData}
            scheduleData={scheduleData}
            fetchSchedule={fetchSchedule}
            dateIsInThePast={dateIsInThePast}
            willEditThePast={willEditThePast}
            fireConfirmationForEditingPastSchedule={fireConfirmationForEditingPastSchedule}
            VirtualMeetingMode={VirtualMeetingMode}
            onChangeDetected={setManageTimeHasChanges}
            unsavedPromptOpenRef={manageTimeUnsavedPromptOpenRef}
            onScheduleTimeShift={handleScheduleTimeShift}
            hideHeaderPopover={requestCloseTimeSlotHeaderPopover}
          />
        </PopoverBody>
      </Popover>
    );
  };

  const renderTimeSlotPopover = (row) => {
    // WARNING: Weird bug for Popover.
    // Add column with key x, delete column, add column with
    // key x again, crash.
    const { pk_Timeslot } = row;
    const visibility = getTimeSlotPopoverVisibility(pk_Timeslot);
    const { metaData } = scheduleData;
    const slotTime = row.slot; //.format('hh:mm A');
    const slotEndTime = row.slotEnd; //.format('hh:mm A');

    // logSchedulePopoverDebug('renderTimeSlotPopover', {
    //   pk_Timeslot,
    //   self: Boolean(visibility.self),
    //   showAddTimeSlotPopover: Boolean(visibility.showAddTimeSlotPopover),
    //   showAddCustomPopover: Boolean(visibility.showAddCustomPopover),
    //   showCustomDurationPopover: Boolean(visibility.showCustomDurationPopover),
    // });

    return (
      <Popover
        // placementPrefix="headerDetailPopover bs-popover "
        popperClassName="headerDetailPopover"
        target={`timeSlot_${pk_Timeslot}`} // Change with room id later
        trigger="manual"
        isOpen={visibility && visibility.self}
        flip={false}
        placement="right"
        modifiers={popoverModifiers}
        toggle={() => {}}
      >
        <PopoverHeader>
          <div style={style.flexEndRow}>
            <div style={style.centeredLabel}>{`${dayjs(slotTime).format('hh:mm A')} - ${dayjs(slotEndTime).format(
              'hh:mm A',
            )}`}</div>
            <FontAwesomeIcon
              icon={faTimesCircle}
              style={style.clickableIcon}
              onClick={(e) => {
                e.stopPropagation();
                closeTimeSlotPopoverStack(pk_Timeslot);
              }}
            />
          </div>
        </PopoverHeader>
        <PopoverBody>
          <>
            <div>
              <TimeSlotPopover
                forcedContext={forcedContext}
                row={row}
                fetchSchedule={fetchSchedule}
                pk_InterviewDate={pk_InterviewDate || Number(scheduleID)}
                scheduleData={scheduleData}
                addRowCustomEvent={addRowCustomEvent}
                visibility={visibility}
                setTimeSlotChildVisibility={(childKey, isOpen) =>
                  setTimeSlotPopoverChildVisibility(pk_Timeslot, childKey, isOpen)
                }
                fireConfirmationForEditingPastSchedule={fireConfirmationForEditingPastSchedule}
                dateIsInThePast={dateIsInThePast}
                willEditThePast={willEditThePast}
                showPastScheduleWarning={showPastScheduleWarning}
                onScheduleTimeShift={handleScheduleTimeShift}
                hideHeaderPopover={() => closeTimeSlotPopoverStack(pk_Timeslot)}
              />
            </div>
          </>
        </PopoverBody>
      </Popover>
    );
  };

  const renderAddColumnPopover = () => {
    return (
      <Popover
        modifiers={popoverModifiers}
        flip={false}
        placementPrefix="addColumnPopover bs-popover"
        target={`addButton`}
        trigger={'legacy'}
        isOpen={showAddColumnPopover}
        toggle={async () => {
          if (dateIsInThePast && !willEditThePast) {
            const continueProcess = await fireConfirmationForEditingPastSchedule();
            if (!continueProcess) {
              return;
            }
          }
          if (isInPreviewMode()) {
            setShowUnsavedChangeModal(!isSubmitting);
            return;
          }
          setShowAddColumnPopover(!showAddColumnPopover);
        }}
      >
        <PopoverHeader>
          <div style={style.flexEndRow}>
            <div style={style.centeredLabel}>Add Column</div>
            <FontAwesomeIcon
              icon={faTimesCircle}
              style={style.clickableIcon}
              onClick={() => {
                setShowAddColumnPopover(false);
              }}
            />
          </div>
        </PopoverHeader>
        <PopoverBody style={style.popOverBody}>
          <AddColumnPopover
            headers={scheduleData && scheduleData.headers ? scheduleData.headers : []}
            evaluators={evaluators}
            isAddingColumn={isAddingColumn}
            onAddColumn={addColumn}
            onAddColumns={addColumns}
            onAddFlexColumn={addFlexColumn}
            hasFlexColumn={hasFlexColumn}
            onRemoveFlexColumn={removeFlexColumn}
            setShowAddColumnPopover={setShowAddColumnPopover}
          />
        </PopoverBody>
      </Popover>
    );
  };

  const renderCloneModal = () => {
    return (
      <CloneModal
        scheduleID={scheduleID}
        setWillEditThePast={setWillEditThePast}
        resetCopyValues={resetCopyValues}
        showCloneModal={showCloneModal}
        setShowCloneModal={setShowCloneModal}
        setInterviewDateToClone={setInterviewDateToClone}
        willCopyHeaders={willCopyHeaders}
        setWillCopyHeaders={setWillCopyHeaders}
        willCopyStartTime={willCopyStartTime}
        setWillCopyStartTime={setWillCopyStartTime}
        willCopyInterviewDuration={willCopyInterviewDuration}
        setWillCopyInterviewDuration={setWillCopyInterviewDuration}
        willCopyPassingDuration={willCopyPassingDuration}
        setWillCopyPassingDuration={setWillCopyPassingDuration}
        willCopyCandidateAssignments={willCopyCandidateAssignments}
        setWillCopyCandidateAssignments={setWillCopyCandidateAssignments}
        willCopyCustomEvents={willCopyCustomEvents}
        setWillCopyCustomEvents={setWillCopyCustomEvents}
        willCopyTimeSlots={willCopyTimeSlots}
        setWillCopyTimeSlots={setWillCopyTimeSlots}
        willCopyFlexEventEvaluators={willCopyFlexEventEvaluators}
        setWillCopyFlexEventEvaluators={setWillCopyFlexEventEvaluators}
        willCopyCustomDurations={willCopyCustomDurations}
        setWillCopyCustomDurations={setWillCopyCustomDurations}
        willCopyFlexEvents={willCopyFlexEvents}
        setWillCopyFlexEvents={setWillCopyFlexEvents}
        willCopyEvaluators={willCopyEvaluators}
        setWillCopyEvaluators={setWillCopyEvaluators}
        willCopyFocuses={willCopyFocuses}
        setWillCopyFocuses={setWillCopyFocuses}
        interviewDateToClone={interviewDateToClone}
        isCloning={isCloning}
        cloneFromExistingSchedule={cloneFromExistingSchedule}
        isSubmitting={isSubmitting}
        interviewDates={interviewDates}
      />
    );
  };

  const attachFlexEvents = (scheduleData, newEvaluators, indexedData) => {
    const newScheduleData = clone(scheduleData);
    const { body, headers, metaData } = newScheduleData;
    const { FlexEvents = [] } = metaData;
    const newBody = clone(body);
    let flexEventName = null;
    const newHeaders = clone(headers);
    const headerFlexEvents = {};
    const { newIndexedFlexEventEvaluators, newIndexedFlexEvents, newIndexedEvaluatorFlexEvents } = indexedData || {};

    newBody.forEach((row, i) => {
      const rowStartTime = dayjs(row.slot);
      const rowEndTime = dayjs(row.slotEnd);

      // Attaches Flex Events by looking through evaluators. Processes Unavailables
      headers.forEach((header, i) => {
        const { pk_ScheduleAssignment } = header;
        let isFlexEvent = false;
        let isUnavailable = false;
        let cellState = 'Normal'; // Normal, Flex Event, Warning, Unavailable
        let flexEventActual = null;

        const cellFlexEvents = [];
        let cellEvaluators = [];
        let cellEvaluatorKeys = [];

        const Evaluators = header.Evaluators && header.Evaluators.Evaluators ? header.Evaluators.Evaluators : [];
        cellEvaluators = [...Evaluators];
        cellEvaluators.forEach((evaluator) => {
          cellEvaluatorKeys.push(evaluator.pk_User);
        });

        cellEvaluators = [];

        cellEvaluatorKeys.forEach((pk_User) => {
          if (newEvaluators[pk_User]) {
            cellEvaluators.push(newEvaluators[pk_User]);
          }
        });

        const availableEvaluators = [...cellEvaluators];
        const unavailableEvaluators = [];

        Evaluators.forEach((headerEvaluator) => {
          const pk_User = Object.keys(newEvaluators).find((key) => {
            return key.toString() === headerEvaluator.pk_User.toString();
          });

          const evaluator = newEvaluators[pk_User];

          if (evaluator) {
            if (evaluator.FlexEvents) {
              const evaluatorFlexEvents = newIndexedEvaluatorFlexEvents[pk_User] || [];

              evaluatorFlexEvents.forEach((f) => {
                const flexEvent = newIndexedFlexEvents[f.pk_FlexEvent];
                const { FlexTimeStart, FlexDateStart, FlexTimeEnd, FlexDateEnd } = flexEvent;
                if (
                  FlexDateStart.toLowerCase() == 'invalid date' ||
                  FlexDateEnd.toLowerCase() == 'invalid date' ||
                  FlexTimeStart.toLowerCase() == 'invalid date' ||
                  FlexTimeEnd.toLowerCase() == 'invalid date'
                ) {
                  return;
                }

                const flexEventStart = dayjs(`${FlexDateStart} ${FlexTimeStart}`);
                const flexEventEnd = dayjs(`${FlexDateEnd} ${FlexTimeEnd}`);

                if (
                  (flexEventStart.isSameOrAfter(rowStartTime) && flexEventStart.isBefore(rowEndTime)) || // Event start is between rowstart and rowend
                  (flexEventEnd.isAfter(rowStartTime) && flexEventEnd.isBefore(rowEndTime)) || // event end is between rowstart and row end
                  (flexEventStart.isSameOrBefore(rowStartTime) && flexEventEnd.isSameOrAfter(rowEndTime)) // rowstart and row end is within event start and end
                ) {
                  isFlexEvent = true; // flexEvent.FlexEventName.toLowerCase() === 'unavailable';
                  flexEventName = flexEvent.FlexEventName;
                  flexEventActual = flexEvent;

                  // if Evaluator has UNAVAILABLE event, means evaluator would
                  // be unavailable for this cell
                  if (flexEventName === 'UNAVAILABLE') {
                    const indexToRemove = availableEvaluators.findIndex((item) => {
                      return item.pk_User == evaluator.pk_User;
                    });
                    if (indexToRemove >= 0) {
                      unavailableEvaluators.push(clone(availableEvaluators[indexToRemove]));
                      availableEvaluators.splice(indexToRemove, 1);
                    }
                  } else {
                    // Block for Non-UNAVAILABLE flex events
                    const newRowFlexEvents = row.FlexEvents ? row.FlexEvents.slice() : [];

                    if (
                      !newRowFlexEvents.find((f) => {
                        return f.pk_FlexEvent == flexEvent.pk_FlexEvent;
                      })
                    ) {
                      newRowFlexEvents.push(flexEvent);
                      row.FlexEvents = newRowFlexEvents;
                    }

                    row[`${header.pk_ScheduleAssignment.toString()}`].flexEvents = newRowFlexEvents;
                    row[`${header.pk_ScheduleAssignment.toString()}`].FlexEvents = newRowFlexEvents;
                  }

                  if (
                    flexEvent.FlexEventName.toLowerCase() === 'unavailable' &&
                    !cellFlexEvents.find((f) => {
                      return f.pk_FlexEvent === flexEvent.pk_FlexEvent;
                    })
                  ) {
                    cellFlexEvents.push(flexEvent);
                    const { ScheduleBlockEntries = [] } = row[pk_ScheduleAssignment];

                    ScheduleBlockEntries.forEach((scheduleBlockEntry) => {
                      const { slot, slotEnd } = scheduleBlockEntry;
                      const { FlexStartTime, FlexTimeEnd } = flexEvent;

                      if (isTimeRangeOverlap([slot, slotEnd], [FlexStartTime, FlexTimeEnd])) {
                        if (!scheduleBlockEntry.flexEvents) {
                          scheduleBlockEntry.flexEvents = [];
                        }
                        if (!scheduleBlockEntry.FlexEvents) {
                          scheduleBlockEntry.FlexEvents = [];
                        }
                        scheduleBlockEntry.isFlexEvent = true;
                        scheduleBlockEntry.flexEvents.push(flexEvent);
                        // scheduleBlockEntry.FlexEvents.push(flexEvent);
                      }
                    });
                  }
                }
              });
            }
          }
        });

        // Check if there would be evaluators left
        if (cellEvaluators.length > 0 && availableEvaluators.length == 0) {
          isUnavailable = true;
          cellState = 'Unavailable';
        } else if (
          cellEvaluators.length > 0 &&
          availableEvaluators.length > 0 &&
          availableEvaluators.length < cellEvaluators.length
        ) {
          cellState = 'Warning';
        } else if (isFlexEvent) {
          cellState = 'Flex Event';
        } else {
          cellState = 'Normal';
        }

        row[pk_ScheduleAssignment].isFlexEvent = isFlexEvent;
        row[pk_ScheduleAssignment].isUnavailable = isUnavailable;
        row[pk_ScheduleAssignment].flexEvents = cellFlexEvents;
        row[pk_ScheduleAssignment].cellState = cellState;
        row[pk_ScheduleAssignment].availableEvaluators = availableEvaluators;
        row[pk_ScheduleAssignment].unavailableEvaluators = unavailableEvaluators;

        if (headerFlexEvents[pk_ScheduleAssignment] == null) {
          headerFlexEvents[pk_ScheduleAssignment] = [];
        }
        cellFlexEvents.forEach((flexEvent) => {
          if (flexEvent.FlexEventName !== 'UNAVAILABLE') return;

          const { pk_FlexEvent } = flexEvent;
          const eventIndex = headerFlexEvents[pk_ScheduleAssignment].findIndex((f) => {
            return f.pk_FlexEvent === pk_FlexEvent;
          });
          if (eventIndex < 0) {
            const evaluatorIDs = newIndexedFlexEventEvaluators
              ? newIndexedFlexEventEvaluators[flexEvent.pk_FlexEvent]
              : indexedFlexEventEvaluators[flexEvent.pk_FlexEvent] || [];
            const evaluatorsActual = [];

            evaluatorIDs.forEach((id) => {
              const evaluatorToAdd = clone(newEvaluators[parseInt(id)]);

              if (evaluatorToAdd) {
                delete evaluatorToAdd.FlexEvents;

                evaluatorsActual.push(evaluatorToAdd);
              }
            });

            flexEvent.evaluators = evaluatorsActual;
            headerFlexEvents[pk_ScheduleAssignment].push(flexEvent);
          }
        });

        if (isFlexEvent) {
          row[pk_ScheduleAssignment].flexEventName = flexEventName;
        }
      });

      //  Attaches Flex EVents by looping through Flex Events. Should have been used isntead of the above headers loop, but a lot of existing code already uses the shape from headers loop :'(
      // Runs through Flex Events list off of metadata and checks if overlaps with row.
      FlexEvents.forEach((flexEvent) => {
        const { FlexTimeStart, FlexDateStart, FlexTimeEnd, FlexDateEnd, pk_FlexEvent } = flexEvent;
        if (
          FlexDateStart.toLowerCase() == 'invalid date' ||
          FlexDateEnd.toLowerCase() == 'invalid date' ||
          FlexTimeStart.toLowerCase() == 'invalid date' ||
          FlexTimeEnd.toLowerCase() == 'invalid date'
        ) {
          return;
        }
        const flexEventStart = dayjs(`${FlexDateStart} ${FlexTimeStart}`);
        const flexEventEnd = dayjs(`${FlexDateEnd} ${FlexTimeEnd}`);
        const newRowFlexEvents = row.FlexEvents || [];

        if (
          (flexEventStart.isSameOrAfter(rowStartTime) && flexEventStart.isBefore(rowEndTime)) || // Event start is between rowstart and rowend
          (flexEventEnd.isAfter(rowStartTime) && flexEventEnd.isBefore(rowEndTime)) || // event end is between rowstart and row end
          (flexEventStart.isSameOrBefore(rowStartTime) && flexEventEnd.isSameOrAfter(rowEndTime)) // rowstart and row end is within event start and end
        ) {
          if (
            !newRowFlexEvents.find((f) => {
              return f.pk_FlexEvent === pk_FlexEvent;
            })
          ) {
            newRowFlexEvents.push(flexEvent);
            row.FlexEvents = newRowFlexEvents;
          }

          if (flexEvent.AttendingCandidates && flexEvent.AttendingCandidates.length > 0) {
            flexEvent.AttendingCandidates.forEach((candidate) => {
              headers.forEach((header, i) => {
                const { pk_ScheduleAssignment } = header;

                const Evaluators = header.Evaluators ? header.Evaluators.Evaluators : [];

                const { ScheduleBlockEntries = [] } = row[pk_ScheduleAssignment] || {};
                const newScheduleBlockEntries = [];
                const oldFlexEvents = row[pk_ScheduleAssignment].FlexEvents || [];
                const flexEventAlreadyExistsInCell = oldFlexEvents.find((fe) => {
                  return fe.pk_FlexEvent == flexEvent.pk_FlexEvent;
                });

                if (!flexEventAlreadyExistsInCell) {
                  oldFlexEvents.push(flexEvent);
                  row[pk_ScheduleAssignment].FlexEvents = oldFlexEvents;
                }

                const flexEventHasEvaluatorForColumn = flexEvent.AttendingUsers.filter((u) => {
                  return Evaluators.find((e) => {
                    return e.pk_User == u.pk_User;
                  });
                });

                ScheduleBlockEntries.forEach((scheduleBlock) => {
                  const { slot, slotEnd } = scheduleBlock;
                  const oldBlockEvents = scheduleBlock.FlexEvents ? clone(scheduleBlock.FlexEvents) : [];
                  const { FlexTimeStart, FlexTimeEnd } = flexEvent;
                  const flexStart = dayjs(`${dayjs(FlexDateStart).format('MMM DD, YYYY')} ${FlexTimeStart}`);

                  const flexEventAlreadyExistsInBlock = oldBlockEvents.find((fe) => {
                    return fe.pk_FlexEvent == flexEvent.pk_FlexEvent;
                  });
                  if (
                    isTimeRangeOverlap(
                      [slot, slotEnd],
                      [flexStart.format('MMM DD, YYYY hh:mm A'), `${FlexDateEnd} ${FlexTimeEnd}`],
                    )
                  ) {
                    const flexEventCandidates = scheduleBlock.flexEventCandidates || [];
                    const candidateExists = flexEventCandidates.find((c) => {
                      return c.pk_Candidate == candidate.pk_Candidate;
                    });

                    if (!candidateExists) {
                      flexEventCandidates.push(candidate);
                    }

                    if (!flexEventAlreadyExistsInBlock) {
                      oldBlockEvents.push(flexEvent);
                    }

                    if (flexEventHasEvaluatorForColumn) {
                      scheduleBlock.FlexEvents = oldBlockEvents;
                    }

                    scheduleBlock.flexEventCandidates = flexEventCandidates;
                  }

                  newScheduleBlockEntries.push(scheduleBlock);
                  row[pk_ScheduleAssignment].ScheduleBlockEntries = newScheduleBlockEntries;
                });
              });
            });
          }

          if (flexEvent.AttendingUsers) {
            flexEvent.AttendingUsers.forEach((evaluator) => {
              headers.forEach((header, i) => {
                const { pk_ScheduleAssignment } = header;
                const Evaluators = header.Evaluators ? header.Evaluators.Evaluators : [];

                const { ScheduleBlockEntries = [] } = row[pk_ScheduleAssignment] || {};
                const newScheduleBlockEntries = [];
                const oldFlexEvents = row[pk_ScheduleAssignment].FlexEvents || [];
                const flexEventAlreadyExistsInCell = oldFlexEvents.find((fe) => {
                  return fe.pk_FlexEvent == flexEvent.pk_FlexEvent;
                });
                const evaluatorIsInColumn = Evaluators.find((e) => {
                  return evaluator.pk_User == e.pk_User;
                });

                if (!evaluatorIsInColumn) {
                  return;
                }
                if (!flexEventAlreadyExistsInCell) {
                  oldFlexEvents.push(flexEvent);
                  row[pk_ScheduleAssignment].FlexEvents = oldFlexEvents;
                }
                ScheduleBlockEntries.forEach((scheduleBlock) => {
                  const { slot, slotEnd } = scheduleBlock;
                  const oldBlockEvents = scheduleBlock.FlexEvents ? clone(scheduleBlock.FlexEvents) : [];
                  const { FlexTimeStart, FlexTimeEnd } = flexEvent;
                  const flexStart = dayjs(`${dayjs(FlexDateStart).format('MMM DD, YYYY')} ${FlexTimeStart}`);

                  const flexEventAlreadyExistsInBlock = oldBlockEvents.find((fe) => {
                    return fe.pk_FlexEvent == flexEvent.pk_FlexEvent;
                  });

                  if (
                    isTimeRangeOverlap(
                      [slot, slotEnd],
                      [`${flexStart.format('MMM DD, YYYY hh:mm A')}`, `${FlexDateEnd} ${FlexTimeEnd}`],
                    )
                  ) {
                    const flexEventEvaluators = scheduleBlock.flexEventEvaluators || [];
                    const evaluatorExists = flexEventEvaluators.find((e) => {
                      return e.pk_User == evaluator.pk_User;
                    });

                    if (!evaluatorExists) {
                      flexEventEvaluators.push(evaluator);
                    }

                    if (!flexEventAlreadyExistsInBlock) {
                      oldBlockEvents.push(flexEvent);
                    }
                    scheduleBlock.FlexEvents = oldBlockEvents;
                    scheduleBlock.flexEventEvaluators = flexEventEvaluators;
                  }

                  newScheduleBlockEntries.push(scheduleBlock);
                  row[pk_ScheduleAssignment].ScheduleBlockEntries = newScheduleBlockEntries;
                });
              });
            });
          }
        }
      });
    });

    newHeaders.forEach((h) => {
      h.flexEvents = headerFlexEvents[h.pk_ScheduleAssignment];
    });

    newScheduleData.body = newBody;
    newScheduleData.headers = newHeaders;
    return newScheduleData;
  };

  // If cell is highlighted green.
  const isInPreviewMode = (options = {}) => {
    const { column, row } = options;
    let isPending = false;
    if (column && row) {
      isPending = pendingCandidates[`${row.pk_Timeslot}_${column.pk_ScheduleAssignment}`];
    }
    return isPending;
  };

  const updateAllData = (options) => {
    const parent = document.getElementById('schedule_proper').parentElement;
    setWindowWidth(parent.clientWidth - 40);

    const getScheduleData = new Promise((resolve, reject) => {
      fetchSchedule(token, { ...options, resolve, reject });
    });

    getScheduleData.then((newScheduleData) => {
      const getEvaluators = new Promise((resolve, reject) => {
        fetchEvaluators(token, newScheduleData, { ...options, resolve, reject });
      });

      const getCandidates = new Promise((resolve, reject) => {
        fetchCandidates(token, { ...options, resolve, reject });
      });

      Promise.all([getEvaluators, getCandidates])
        .then((values) => {
          const { pendingItemKey } = options || {};
          const [newEvaluators, newCandidates] = values;
          if (pendingItemKey) {
            if (pendingItemKey === 'all') {
              setPendingCandidates({});
            } else {
              const newPendingCandidates = clone(pendingCandidatesStateRef.current);
              delete newPendingCandidates[pendingItemKey];
              setPendingCandidates(newPendingCandidates);
              pendingCandidatesStateRef.current = clone(newPendingCandidates);
            }
          }

          const indexedData = indexFlexEvents(newScheduleData, newEvaluators);
          const scheduleDataWithFlexEvents = attachFlexEvents(newScheduleData, newEvaluators, indexedData);

          if (selectedCell && selectedScheduleBlock) {
            updateSelectedCellAndBlockFromScheduleData(scheduleDataWithFlexEvents);
          }
          setScheduleData(scheduleDataWithFlexEvents);
          if (setParentScheduleData) {
            setParentScheduleData(scheduleDataWithFlexEvents);
          }

          setIsGeneratingSchedule(false);
          setGeneratedScheduleData(null);
          initializeTrackers(newScheduleData);
          setEvaluators(newEvaluators);
          setCandidates(newCandidates);

          setIsTableLoaded(true);
          if (setParentCandidates) {
            setParentCandidates(newCandidates);
          }
          const { headers, body, metaData } = newScheduleData;
          const { StartTime, EndTime } = getScheduleStartAndEndTime(newScheduleData);
          const now = dayjs();
          if (headers.length <= 0 && body.length <= 1 && !isEmbedded) {
            setScheduleWizardInitialStep(1);
            setShowScheduleWizard(true);
          } else {
            setShowScheduleWizard(false);
          }

          setCandidateLimit(metaData.CandidateLimit || 1);
          setIsFetching(false);

          const isMeetingInProgress = now.isSameOrAfter(StartTime) && now.isSameOrBefore(EndTime);
          if (headers.length > 0 && body.length > 1) {
            fetchAttendanceData(false);
          }
          const interval = 60000;
          // const interval = 5000;
          clearInterval(attendanceChecker);
          attendanceChecker = setInterval(() => {
            if (scheduleDataRef.current) {
              const { StartTime, EndTime } = getScheduleStartAndEndTime(scheduleDataRef.current);
              const { headers, body } = scheduleDataRef.current;
              const now = dayjs(); //.format('MMM DD, YYYY hh:mm A');
              const extendedEndTime = dayjs(EndTime).add(5, 'minutes'); // Keep checking attendance 5 mins after meeting ends
              const isMeetingInProgress = now.isSameOrAfter(StartTime) && now.isSameOrBefore(extendedEndTime);

              if (isMeetingInProgress && headers.length > 0 && body.length > 1) {
                fetchAttendanceData();
              }
            }
          }, interval);
        })
        .catch((err) => {
          console.log('updateAll err: ', err);
        });
    });
  };

  const processTableDataToDisplay = (options) => {
    const { skipColumnRemake } = options || {};

    const newTableData = generatedScheduleData ? generatedScheduleData.body : scheduleData ? scheduleData.body : [];

    if (skipColumnRemake) {
    } else {
      const newTableColumns = scheduleData
        ? makeColumns(scheduleData).map((column, index) => ({
            ...column,
            id: column.id || `column_${index}`, // Ensure each column has a unique id
          }))
        : [];
      setTableColumns(newTableColumns);
    }

    // Check for long interviews (>35 minutes) only when the department is not using embedded meetings.
    let foundLongInterview = false;
    if (enforce35MinuteLimit && scheduleData && scheduleData.body) {
      scheduleData.body.forEach((row) => {
        if (row.pk_Timeslot !== 'END') {
          Object.keys(row).forEach((key) => {
            const cell = row[key];
            if (cell && cell.ScheduleBlockEntries) {
              cell.ScheduleBlockEntries.forEach((block) => {
                if (block.Candidates && block.Candidates.length > 0 && block.slot && block.slotEnd) {
                  const blockStart = dayjs(block.slot);
                  const blockEnd = dayjs(block.slotEnd);
                  const blockDurationInMinutes = blockEnd.diff(blockStart, 'minutes');
                  if (blockDurationInMinutes > 35) {
                    foundLongInterview = true;
                  }
                }
              });
            }
          });
        }
      });
    }
    setHasLongInterviews(foundLongInterview);

    newTableData.cellHoveredOn = cellHoveredOn;
    setTableData(newTableData);
  };

  const renderUnsavedChangesConfirmModal = () => {
    return (
      <ConfirmModal
        isOpen={showUnsavedChangeModal}
        title={'Alert - Unsaved changes!'}
        message="Do you want to accept or discard the generated schedule?"
        buttonChoices={
          <>
            <Button
              color="secondary"
              onClick={() => {
                setShowUnsavedChangeModal(false);
              }}
            >
              <div style={style.buttonLabel}>Cancel</div>
            </Button>
            <Button
              color="danger"
              onClick={() => {
                setGeneratedScheduleData(null);
                setShowUnsavedChangeModal(false);
                setShowGenerateDataPanel(false);
              }}
            >
              <div style={style.buttonLabel}>Discard</div>
            </Button>
            <Button
              color="success"
              onClick={() => {
                if (generatedScheduleData) {
                  submitGeneratedSchedule(generatedScheduleData.body);
                }
                setShowUnsavedChangeModal(false);
                setShowGenerateDataPanel(false);
              }}
            >
              <div style={style.buttonLabel}>Accept</div>
            </Button>
          </>
        }
      />
    );
  };

  const getMaxSplitCount = () => {
    if (selectedCell == null) {
      return 1;
    }
    const col = parseInt(selectedCell.column.dataField);
    const { StandardDurationInMinutes, StandardPassingDurationInMinutes } = scheduleData.metaData;
    let lowestSplitCount = null;
    scheduleData.body.forEach((row, i) => {
      if (i == scheduleData.body.length - 1) {
        return;
      }
      const { CustomDurationInMinutes = 0, CustomPassingDurationInMinutes = 0 } = row[col];
      const duration =
        CustomDurationInMinutes != null ? parseInt(CustomDurationInMinutes) : parseInt(StandardDurationInMinutes);
      const passingDuration = CustomPassingDurationInMinutes
        ? parseInt(CustomPassingDurationInMinutes)
        : parseInt(StandardPassingDurationInMinutes);

      if (lowestSplitCount == null || duration + passingDuration < lowestSplitCount) {
        lowestSplitCount = duration + passingDuration;
      }
    });
    return lowestSplitCount;
  };

  const renderSplitCellModal = () => {
    return (
      <Modal isOpen={showSplitCellModal} zIndex={9999} centered={true}>
        <ModalHeader
          toggle={() => {
            setShowSplitCellModal(false);
          }}
        >
          Set Split Count
        </ModalHeader>
        <ModalBody>
          <div>
            <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
              <Input
                style={{ textAlign: 'center', width: '50%' }}
                type="number"
                value={cellSplitCount}
                placeholder="Enter number of splits"
                onChange={(e) => {
                  let newValue = parseInt(e.target.value);
                  if (newValue < 1) {
                    newValue = 1;
                  }
                  const maxSplitCount = getMaxSplitCount();

                  if (newValue > maxSplitCount) {
                    newValue = maxSplitCount;
                  }

                  setCellSplitCount(newValue);
                }}
              />
            </div>

            <div style={style.splitCellButtonRow}>
              <Button
                color="danger"
                style={{ ...style.simpleColumn, ...style.genButton, backgroundColor: null, justifyContent: 'center' }}
                onClick={() => {
                  setShowSplitCellModal(false);
                }}
              >
                Cancel
              </Button>
              <Button
                color="danger"
                style={{ ...style.simpleColumn, ...style.genButton, backgroundColor: null, justifyContent: 'center' }}
                onClick={() => {
                  const { row, column } = selectedCell;
                  const { dataField } = column;
                  const { pk_Timeslot } = row;

                  const data = {
                    pk_ScheduleAssignment: parseInt(dataField),
                    pk_Timeslot,
                  };
                  setSplitData(data);

                  const willCandidateBeUnscheduled = isCandidateWillBeUnscheduled(splitCountTracker, {
                    timeSlots: [pk_Timeslot],
                    headers: [parseInt(dataField)],
                    splitValue: 1,
                  });

                  if (willCandidateBeUnscheduled) {
                    setShowSplitCellConfirmModal(true);
                    return;
                  }
                  removeCellSplits(data, () => {
                    setShowScheduleDetailModal(false);
                    setShowSplitCellModal(false);
                  });
                }}
              >
                Remove
              </Button>
              <Button
                style={{ ...style.simpleColumn, ...style.genButton, justifyContent: 'center' }}
                onClick={() => {
                  const { row, column } = selectedCell;
                  const { dataField } = column;
                  const { pk_Timeslot } = row;

                  const data = {
                    pk_ScheduleAssignment: parseInt(dataField),
                    TotalNumberOfSplits: cellSplitCount,
                    pk_Timeslot,
                  };

                  setSplitData(data);

                  const willCandidateBeUnscheduled = isCandidateWillBeUnscheduled(splitCountTracker, {
                    timeSlots: [pk_Timeslot],
                    headers: [parseInt(dataField)],
                    splitValue: cellSplitCount,
                  });

                  if (willCandidateBeUnscheduled) {
                    setShowSplitCellConfirmModal(true);
                    return;
                  }

                  setCellSplit(data, (err) => {
                    if (!err) {
                      setShowScheduleDetailModal(false);
                      setShowSplitCellModal(false);
                    }
                  });
                }}
              >
                Set
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  };

  const renderSplitCellConfirmModal = () => {
    return (
      <ConfirmModal
        isOpen={showSplitCellConfirmModal}
        title={'Cannot reduce splits!'}
        message="One or more candidates will be unscheduled because the schedule block they are in will be removed. Manually Clear them first, or set a higher split count."
        buttonChoices={
          <Button
            style={style.genButton}
            onClick={() => {
              if (selectedCell) {
                const { row, column } = selectedCell;
                const selectedCellActual = row[parseInt(column.dataField)];
                const { ScheduleBlockTotalNumberOfSplits, ColumnTotalNumberOfSplits } = selectedCellActual;
                setCellSplitCount(ScheduleBlockTotalNumberOfSplits || ColumnTotalNumberOfSplits || 1);
              } else {
                // console.log("selectedCell doesn't exist");
              }

              setShowSplitCellConfirmModal(false);
            }}
          >
            <div style={style.buttonLabel}>OK</div>
          </Button>
        }
      />
    );
  };

  const renderFlexEventColumnDetailModal = () => {
    return (
      <FlexEventDetailModal
        candidates={candidatesArray}
        columnTracker={columnTracker}
        dateIsInThePast={dateIsInThePast}
        fireConfirmationForEditingPastSchedule={fireConfirmationForEditingPastSchedule}
        forcedContext={forcedContext}
        indexedFlexEventEvaluators={indexedFlexEventEvaluators}
        isOpen={showFlexEventDetailModal}
        pk_InterviewDate={pk_InterviewDate}
        rowTracker={rowTracker}
        scheduleData={scheduleData}
        selectedCell={selectedCell}
        setSelectedCell={setSelectedCell}
        setShowFlexEventDetailModal={setShowFlexEventDetailModal}
        showPastScheduleWarning={showPastScheduleWarning}
        updateAllData={updateAllData}
        updateFlexEvents={updateFlexEvents}
        VirtualMeetingMode={VirtualMeetingMode}
        willEditThePast={willEditThePast}
        evaluators={
          evaluators && Object.values(evaluators).length > 0
            ? Object.values(evaluators).sort((a, b) => {
                const aString = `${a.UserLast}, ${a.UserFirst}`.toUpperCase();
                const bString = `${b.UserLast}, ${b.UserFirst} `.toUpperCase();

                if (aString < bString) {
                  return -1;
                }
                if (aString > bString) {
                  return 1;
                }
                return 0;
              })
            : []
        }
      />
    );
  };

  const renderScheduleDetailModal = () => {
    return (
      <ScheduleDetailModal
        addCandidateToSchedule={addCandidateToSchedule}
        addUnavailableSlot={addUnavailableSlot}
        addUnavailableSlots={addUnavailableSlots}
        allowInterviewLimit={allowInterviewLimit}
        attendanceData={attendanceData}
        candidateLimit={candidateLimit}
        candidates={candidates}
        clearScheduleBlock={clearScheduleBlock}
        clearSpecificCandidateFromSchedule={clearSpecificCandidateFromSchedule}
        columnTracker={columnTracker}
        dateIsInThePast={dateIsInThePast}
        dContext={dContext}
        deleteFlexEvent={deleteFlexEvent}
        evaluators={evaluators}
        fetchSchedule={fetchSchedule}
        fireConfirmationForEditingPastSchedule={fireConfirmationForEditingPastSchedule}
        indexedEvaluatorFlexEvents={indexedEvaluatorFlexEvents}
        isAddingCandidate={isAddingCandidate}
        isFetching={isFetching}
        isSubmitting={isSubmitting}
        onToggle={onToggleScheduleDetailModal}
        pendingCandidates={pendingCandidates}
        rowTracker={rowTracker}
        scheduleBlockTracker={scheduleBlockTracker}
        scheduleData={scheduleData}
        scheduleID={scheduleID}
        selectedCell={selectedCell}
        selectedScheduleBlock={selectedScheduleBlock}
        setAllowInterviewLimit={setAllowInterviewLimit}
        setShowScheduleDetailModal={setShowScheduleDetailModal}
        setShowSplitCellModal={setShowSplitCellModal}
        showScheduleDetailModal={showScheduleDetailModal}
        splitBlockCandidateTracker={splitBlockCandidateTracker}
        submitGeneratedSchedule={submitGeneratedSchedule}
        updateAllData={updateAllData}
        updateFlexEvent={updateFlexEvent}
        updateFlexEvents={updateFlexEvents}
        VirtualMeetingMode={VirtualMeetingMode}
        willEditThePast={willEditThePast}
      />
    );
  };

  const fireConfirmationForEditingPastSchedule = () => {
    // if the interview date is the same day then let them continue - no need to ask about editting
    if (interviewDateIsToday) {
      return true;
    }
    setShowPastScheduleWarning(true);
    return Swal.fire({
      title: 'Warning!',
      text: `This schedule is in the past or already in progress. Are you sure you want to modify?`,
      showCancelButton: true,
      icon: 'warning',
      confirmButtonColor: 'red',
      confirmButtonText: `Yes`,
    }).then((result) => {
      setTimeout(() => {
        setShowPastScheduleWarning(false);
      }, 1000);

      if (result.value) {
        setWillEditThePast(true);

        return true;
      }
      return false;
    });
  };

  const getZoneFromOffset = () => {
    if (scheduleData && scheduleData.metaData && scheduleData.metaData.TimeZone) {
      // Day.js doesn't have tz.names() like moment.js
      // Instead, we'll just return the timezone from the schedule data
      // or fall back to the guessed timezone if they match offsets
      const scheduleTimezone = scheduleData.metaData.TimeZone;
      const guessedTimezone = dayjs.tz.guess();

      try {
        const scheduleOffset = dayjs.tz(undefined, scheduleTimezone).format('Z');
        const guessedOffset = dayjs.tz(undefined, guessedTimezone).format('Z');

        // If the offsets match, prefer the guessed timezone (user's local timezone)
        if (scheduleOffset === guessedOffset) {
          return guessedTimezone;
        }
      } catch (error) {
        // If there's an error with timezone conversion, fall back to schedule timezone
        console.warn('Timezone conversion error:', error);
      }

      return scheduleTimezone;
    }

    return dayjs.tz.guess(); // Fallback to user's guessed timezone
  };

  const checkInactivity = (forceLogout) => {
    const now = dayjs();
    const lastActivity = localStorage.getItem('lastActivity');

    const lastActivityMoment = lastActivity ? dayjs(lastActivity) : null;
    const currentInactivityLength = now.diff(lastActivityMoment, 'minutes');
    const { StartTime, EndTime } = getScheduleStartAndEndTime(scheduleDataRef.current);
    const isMeetingInProgress = now.isSameOrAfter(StartTime) && now.isSameOrBefore(EndTime);

    if (
      !isMeetingInProgress &&
      (!isEmbedded || isSuperUserPanel) &&
      (!lastActivity || (lastActivity && currentInactivityLength > inactivityWait && !hasFiredInactivityPopup))
    ) {
      hasFiredInactivityPopup = true;
      // const autoLogoutTimeout = setTimeout(() => {
      //   logout();
      // }, 40000);

      if (forceLogout) {
        sessionStorage.removeItem('roleChoice');
        logout();
      } else {
        Swal.fire({
          title: 'Inactivity Detected',
          text: 'Are you still there?',
          showDenyButton: true,
          confirmButtonText: 'Yes',
          denyButtonText: 'No, Log me out',
          denyButtonColor: 'red',
          timer: 30000,
          timerProgressBar: true,
        }).then((res) => {
          hasFiredInactivityPopup = false;
          if (res.dismiss === Swal.DismissReason.timer) {
            logout();
            sessionStorage.removeItem('roleChoice');
          } else if (res.isConfirmed) {
            // YES STILL HERE
            // clearTimeout(autoLogoutTimeout);
          } else {
            // logout
            logout();
            sessionStorage.removeItem('roleChoice');
          }
        });
      }
    } else if (isMeetingInProgress) {
      localStorage.setItem('lastActivity', now.toISOString());
    }
  };

  return (
    <div id="schedule_proper">
      {isScheduleDataError ? (
        <div style={{ textAlign: 'center', fontWeight: 'bold', marginTop: '20vh' }}>Error fetching Schedule Data</div>
      ) : (
        <>
          {showGenerateDataPanel ? (
            <Alert style={{ marginBottom: 0 }}>
              <div>
                <div style={style.previewButtonPanel}>
                  <Button
                    color="danger"
                    style={{ ...style.genButton, backgroundColor: null }}
                    onClick={() => {
                      setGeneratedScheduleData(null);
                      setShowGenerateDataPanel(false);
                      setPendingCandidates({});
                      initializeTrackers(scheduleData);
                    }}
                  >
                    <div style={style.buttonLabel}>Discard New Schedule</div>
                  </Button>
                  <Button
                    style={{ ...style.genButton, backgroundColor: null }}
                    color="success"
                    onClick={() => {
                      submitGeneratedSchedule(generatedScheduleData.body);
                      setShowGenerateDataPanel(false);
                      setGenerateMode('ordered');
                    }}
                  >
                    <div style={style.buttonLabel}>Accept New Schedule</div>
                  </Button>

                  <Button
                    style={{ ...style.genButton }}
                    onClick={() => {
                      if (generatedScheduleData && generatedScheduleData.headersToFillUp) {
                        generateScheduleForColumn(generatedScheduleData.headersToFillUp);
                      } else {
                        setGenerateMode('ordered');
                        generateScheduleForEntireTable();
                      }
                    }}
                  >
                    <div style={{ ...style.spacedBetweenRow, width: '100%' }}>
                      <FontAwesomeIcon icon={generatedScheduleData ? faRedo : faMagic} style={style.buttonIcon} />
                      <div style={style.buttonLabel}> {generatedScheduleData ? `Regenerate` : `Generate`} Schedule</div>
                    </div>
                  </Button>
                </div>
                <div style={style.buttonLabel}>
                  Accepting the new schedule will overwrite the previous schedule!{' '}
                  {allowInterviewLimit
                    ? `(Candidate Interview Limit is set to ${interviewLimit})`
                    : scheduleData && scheduleData.headers
                    ? `(Maximum ${scheduleData.headers.length} candidate interviews)`
                    : 1}{' '}
                </div>
              </div>
            </Alert>
          ) : !isEmbedded || allowScheduleInteraction || showTopBar ? (
            <TopBar
              addRowCustomEvent={addRowCustomEvent}
              allowInterviewLimit={allowInterviewLimit}
              candidates={candidates}
              columnAvailabilityTracker={columnAvailabilityTracker}
              columnsToIgnore={columnsToIgnore}
              columnTracker={columnTracker}
              dContext={dContext}
              evaluators={evaluators}
              fetchSchedule={fetchSchedule}
              fireConfirmationForEditingPastSchedule={fireConfirmationForEditingPastSchedule}
              generatedScheduleData={generatedScheduleData}
              generateMode={generateMode}
              initializeTrackers={initializeTrackers}
              interviewLimit={interviewLimit}
              isAddingCandidate={isAddingCandidate}
              isCloning={isCloning}
              isEmbedded={isEmbedded}
              isFetching={isFetching}
              isGeneratingSchedule={isGeneratingSchedule}
              isInPreviewMode={isInPreviewMode}
              isSubmitting={isSubmitting}
              rowTracker={rowTracker}
              scheduleBlockTracker={scheduleBlockTracker}
              scheduleData={scheduleData}
              scheduleID={scheduleID}
              setAllowInterviewLimit={setAllowInterviewLimit}
              setCandidateLimit={setCandidateLimit}
              setGeneratedScheduleData={setGeneratedScheduleData}
              setInterviewLimit={setInterviewLimit}
              setPendingCandidates={setPendingCandidates}
              setShowCloneModal={setShowCloneModal}
              setShowGenerateDataPanel={setShowGenerateDataPanel}
              setShowUnsavedChangeModal={setShowUnsavedChangeModal}
              showCloneModal={showCloneModal}
              sortOnce={sortOnce}
              submitGeneratedSchedule={submitGeneratedSchedule}
              willEditThePast={willEditThePast}
              toggleScheduleWizard={() => {
                if (!showScheduleWizard) {
                  setScheduleWizardInitialStep(1);
                  setShowScheduleWizard(true);
                } else {
                  setShowScheduleWizard(false);
                }
              }}
            />
          ) : null}
          {showGenerateDataPanel &&
          generatedScheduleData &&
          generatedScheduleData.candidatesWithMissingInterviews &&
          generatedScheduleData.candidatesWithMissingInterviews.length > 0 ? (
            <RezRateBanner
              textColor={'#ffffff'}
              backgroundColor="#ed723e"
              message={`There are ${generatedScheduleData.candidatesWithMissingInterviews.length} candidates who have less interviews than there are evaluators. We suggest to generate a new schedule, remove Unavailable items, or add more time slots to the schedule.`}
            />
          ) : (
            <br />
          )}
          {hasLongInterviews && (
            <div style={{ marginBottom: 5 }}>
              <RezRateBanner
                message="Warning: There are interviews that run longer than 35 minutes and they will terminate prior to the scheduled end time."
                backgroundColor="#f0ad4e"
              />
            </div>
          )}
          {(!isEmbedded || allowScheduleInteraction) && !generatedScheduleData && !showGenerateDataPanel ? (
            <div style={style.spacedBetweenRow}>
              <div style={{ fontStyle: 'italic' }}>
                {scheduleData ? (
                  <>
                    {' '}
                    <FontAwesomeIcon icon={faInfoCircle} style={{ marginRight: 5 }} />
                    This schedule displayed is for "
                    <b>
                      {scheduleData && scheduleData.metaData ? getZoneFromOffset() : 'N/A'} (
                      {dayjs.tz(undefined, getZoneFromOffset()).format('hh:mm A')})
                    </b>
                    ". You are currently in Timezone "<b>{dayjs.tz.guess()}</b>".
                  </>
                ) : (
                  ''
                )}
              </div>

              <div style={{ ...style.simpleColumn, minWidth: 340 }}>
                <div style={{ ...style.simpleRow, justifyContent: 'right' }}>
                  {scheduleData ? (
                    <div style={{ ...style.simpleColumn, minWidth: 160 }}>
                      <div style={style.simpleRow}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'relative',
                          }}
                        >
                          <div
                            style={{
                              border: '2px solid #f2f2f2',
                              borderRadius: 20,
                              color: '#f2f2f2',
                              backgroundColor: '#298dff',
                              fontWeight: 'bold',
                              fontSize: 10,
                              marginRight: 2,
                              minWidth: 17,
                              minHeight: 17,
                              textAlign: 'center',
                            }}
                          >
                            1
                          </div>
                        </div>
                        <div style={{ fontStyle: 'italic' }}>- Evaluators present</div>
                      </div>
                      <div style={style.simpleRow}>
                        <FontAwesomeIcon
                          icon={faUserCircle}
                          style={{
                            color: '#35911f',
                            fontWeight: 'bold',
                            fontSize: 17,
                            border: '2px solid #f2f2f2',
                            borderRadius: 20,
                            backgroundColor: '#f2f2f2',
                          }}
                        />
                        <div style={{ fontStyle: 'italic' }}>- Candidate present</div>
                      </div>
                    </div>
                  ) : null}

                  {allowScheduleInteraction && !generatedScheduleData ? (
                    <div style={{ ...style.simpleColumn, minWidth: 100, alignItems: 'center' }}>
                      <Button
                        size="sm"
                        disabled={isAddingColumn}
                        color="primary"
                        onClick={() => {
                          setShowFlexEventDetailModal(true);
                          setShowAddColumnPopover(false);
                        }}
                        style={{ marginRight: 10 }}
                      >
                        <div style={style.spacedBetweenRow}>
                          <div>
                            <FontAwesomeIcon icon={faPlusSquare} id="addButton" style={style.addColumnIcon} />
                          </div>
                          {<div style={{ marginLeft: 10 }}>Manage Flex Events</div>}
                        </div>
                      </Button>
                    </div>
                  ) : null}
                  <div style={{ ...style.simpleColumn, minWidth: 100 }}>
                    <Button
                      size="sm"
                      onClick={async () => {
                        if (generatedScheduleData) {
                          return;
                        }

                        if (dateIsInThePast && !willEditThePast) {
                          const continueProcess = await fireConfirmationForEditingPastSchedule();
                          if (!continueProcess) {
                            return;
                          }
                        }

                        if (isInPreviewMode()) {
                          setShowUnsavedChangeModal(!isSubmitting);
                          return;
                        }

                        hideHeaderPopoversExcept();
                        hideTimeSlotPopoversExcept();
                        setScheduleWizardInitialStep(2);
                        setShowScheduleWizard(true);
                      }}
                    >
                      <div style={style.spacedBetweenRow}>
                        <div>
                          <FontAwesomeIcon icon={faPlusSquare} id="addButton" style={style.addColumnIcon} />
                        </div>
                        {<div style={{ marginLeft: 10 }}>Manage Columns</div>}
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          <div style={style.tableContainer(scheduleData, windowWidth, hasFlexColumn)}>
            <div style={{ ...style.simpleColumn, width: '100%' }} id="scheduleContainer">
              {scheduleData ? (
                <RezRateTable
                  bordered={true}
                  columns={tableColumns}
                  // data={tableData}
                  data={generatedScheduleData ? generatedScheduleData.body : scheduleData ? scheduleData.body : []}
                  tableBodyHeight={`calc(100vh - 450px)`}
                  tableType="striped"
                  rowStyle={(row, rowIndex) => {
                    return { padding: 0 };
                  }}
                  keyField="field_key"
                  noDataIndication={<div style={{ textAlign: 'center' }}>No Data</div>}
                />
              ) : (
                <div style={style.loadingContainer}>
                  {/* <Spinner color="primary" /> */}
                  <div style={{ display: 'flex', width: 100, height: 100 }}>
                    <Loading />
                  </div>
                </div>
              )}
              {/* {scheduleData ? (
                <table>
                  <thead>
                    {table.getHeaderGroups().map((headerGroup) => (
                      <tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                          <th key={header.id} id={header.id}>
                            {header.isPlaceholder
                              ? null
                              : flexRender(header.column.columnDef.header, header.getContext())}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody>
                    {table.getRowModel().rows.map((row) => (
                      <tr key={row.id}>
                        {row.getVisibleCells().map((cell) => (
                          <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    {table.getFooterGroups().map((footerGroup) => (
                      <tr key={footerGroup.id}>
                        {footerGroup.headers.map((header) => (
                          <th key={header.id}>
                            {header.isPlaceholder
                              ? null
                              : flexRender(header.column.columnDef.footer, header.getContext())}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </tfoot>
                </table>
              ) : (
                <div style={style.loadingContainer}>
                  <div style={{ display: 'flex', width: 100, height: 100 }}>
                    <Loading />
                  </div>
                </div>
              )} */}
            </div>
          </div>

          {(!isEmbedded || allowScheduleInteraction) && !generatedScheduleData
            ? scheduleData && document.getElementById('timeSlotHeader') //&& scheduleData.headers && scheduleData.headers.length > 0
              ? renderTimeSlotHeaderPopOver()
              : null
            : null}

          {/* {!isEmbedded || allowScheduleInteraction ? renderAddColumnPopover() : null} */}

          {renderScheduleDetailModal()}
          {renderFlexEventColumnDetailModal()}
          {renderUnsavedChangesConfirmModal()}
          {renderSplitCellModal()}
          {renderSplitCellConfirmModal()}
          {renderCloneModal()}
          <ScheduleWizard
            forcedContext={forcedContext}
            pk_InterviewDate={pk_InterviewDate}
            isOpen={showScheduleWizard}
            setShowScheduleWizard={setShowScheduleWizard}
            initialStep={scheduleWizardInitialStep}
            columnTracker={columnTracker}
            evaluators={evaluators}
            candidates={candidates}
            scheduleData={scheduleData}
            updateAllData={updateAllData}
          />
        </>
      )}
    </div>
  );
};

export default Schedule;
